import { apis } from './index';
import {
  COMMON_URL_PRESFOR,
  BASE_URL_PRESFOR,
  GEOMATIC_TOKEN,
  GEOMATIC_URL,
} from './api';
import axios from 'axios';

//presfor importation

export const API_URLS_PRESFOR = {
  ...apis.API_URLS_PRESFOR,
  UPDATE_ANNONCE_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/update-anp`,
  LIST_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/anp-by-enquete`,
  LIST_PUB_UNIQUE: `${COMMON_URL_PRESFOR}certificat-foncier/anp`,
  GENERATE_CONTRAT: `${COMMON_URL_PRESFOR}contrat/generate-contrat-pdf`,
  ADD_SERVITUDE: `${COMMON_URL_PRESFOR}pvrdc/servitude`,
  ADD_ETAT_DE_DROIT: `${COMMON_URL_PRESFOR}pvrdc/etat-droit`,
  UPDATE_ETAT_DE_DROIT: `${COMMON_URL_PRESFOR}pvrdc/update-etat-droit`,
  DELETE_VALID: `${COMMON_URL_PRESFOR}constat/delete-valid`,
  DELETE_CECPDC: `${COMMON_URL_PRESFOR}constat/delete-cecpdc`,
  DELETE_ANP: `${COMMON_URL_PRESFOR}certificat-foncier/delete-anp`,
  DELETE_ANPC: `${COMMON_URL_PRESFOR}certificat-foncier/delete-anpc`,
  DELETE_ANPO: `${COMMON_URL_PRESFOR}certificat-foncier/delete-anpo`,
  DELETE_CLP: `${COMMON_URL_PRESFOR}clp/delete`,
  DELETE_PVCL: `${COMMON_URL_PRESFOR}pvcl/delete`,
  DELETE_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/delete-dcf`,
  TRANSMISSION_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/dcf-transmission-byNNNNN`,
  TRANSMISSION_DCF_ENQUETE: `${COMMON_URL_PRESFOR}certificat-foncier/dcf-transmission-byVillage`,
  DELETE_CF: `${COMMON_URL_PRESFOR}certificat-foncier/delete-cf19`,
  GET_NUM_CONTRAT_ENQUETE: `${COMMON_URL_PRESFOR}contrat/numero-contrats/by-enquete`,
  UPDATE_PVCL: `${COMMON_URL_PRESFOR}pvcl/update-pvcl`,
  DELETE_ANNEXES_PVCL: `${COMMON_URL_PRESFOR}pvcl/delete-lppc`,
  UPDATE_ANNEXES_PVCL: `${COMMON_URL_PRESFOR}pvcl/update-lppc`,
  GET_PARCELLE_GEOMATIC: `${GEOMATIC_URL}parcelle`,
  UPDATE_DEMANDE_CF: `${COMMON_URL_PRESFOR}certificat-foncier/update-certificat`,
  POST_PDF_CLP: `${COMMON_URL_PRESFOR}clp/upload-clp-pdf`,
  GET_CLP: `${COMMON_URL_PRESFOR}clp/find-one`,
  POST_ANNEXES_CLP: `${COMMON_URL_PRESFOR}clp/clp-lppc`,
  POST_CLP: `${COMMON_URL_PRESFOR}clp/new`,
  GET_ALL_NUM_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/get-all-nnnnn`,
  GET_PPD_SHP: `${COMMON_URL_PRESFOR}certificat-foncier/download-shapeppd`,
  GET_PPP_SHP: `${COMMON_URL_PRESFOR}certificat-foncier/download-shapeppp`,
  GET_PPD_PDF: `${COMMON_URL_PRESFOR}certificat-foncier/ppdef/download-pdf`,
  GET_PPP_PDF: `${COMMON_URL_PRESFOR}certificat-foncier/ppprov/download-pdf`,
  UPDATE_INFO_CF: `${COMMON_URL_PRESFOR}certificat-foncier/refresh-de-cf`,
  UPDATE_STATUS_DEMANDE: `${COMMON_URL_PRESFOR}certificat-foncier/refresh-anonce-pub-demandeur`,
  UPDATE_ETAT_DEMANDE: `${COMMON_URL_PRESFOR}certificat-foncier/refresh-etat-dcf`,
  POST_PDF_CF: `${COMMON_URL_PRESFOR}certificat-foncier/upload-cf`,
  POST_DEMANDES_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/anpd`,
  PDF_DEMANDES_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/create-anp-pdf`,
  POST_CLOTURE_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/anpc`,
  UPDATE_PV_CLOTURE_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/update-anpc`,
  ANNONCE_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/anp`,
  POST_PDF_PVO: `${COMMON_URL_PRESFOR}certificat-foncier/upload-pvo`,
  POST_PVO_PRESENCE: `${COMMON_URL_PRESFOR}certificat-foncier/dcf-pvo-lp`,
  POST_PVO: `${COMMON_URL_PRESFOR}certificat-foncier/dcf-pvo`,
  POST_ANPO: `${COMMON_URL_PRESFOR}certificat-foncier/anpo`,
  UPDATE_ANPO: `${COMMON_URL_PRESFOR}certificat-foncier/update-anpo`,
  READ_PDF_CF: `${COMMON_URL_PRESFOR}certificat-foncier/read-file`,
  POST_PDF_CONSTAT: `${COMMON_URL_PRESFOR}constat/upload-constat-pdf`,
  GET_CONSTAT: `${COMMON_URL_PRESFOR}constat/find-one`,
  POST_ANNEXES_CONSTAT: `${COMMON_URL_PRESFOR}constat/add-person`,
  POST_CONSTAT: `${COMMON_URL_PRESFOR}constat/new`,
  POST_PDF_CLOTUREPUB: `${COMMON_URL_PRESFOR}certificat-foncier/upload-anpc`,
  POST_PDF_OUVERTUREPUB: `${COMMON_URL_PRESFOR}certificat-foncier/upload-anpo`,
  CREATE_CLOTUREPUB_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/create-anpc-pdf`,
  POST_PDF_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/upload-anp`,
  POST_PDF_PVCL: `${COMMON_URL_PRESFOR}pvcl/upload-pvcl-pdf`,
  GET_PVCL: `${COMMON_URL_PRESFOR}pvcl/find-one`,
  POST_ANNEXES_PVCL: `${COMMON_URL_PRESFOR}pvcl/lppc`,
  POST_PVCL: `${COMMON_URL_PRESFOR}pvcl/new`,
  ADD_LISTE_SERVITUDE: `${COMMON_URL_PRESFOR}pvrdc/servitude`,
  POST_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/new`,
  UPDATE_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/update`,
  ADD_MEMBRE_EQUIPE_ENQ_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/equipe-enquete`,
  UPDATE_MEMBRE_EQUIPE_ENQ_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/update/equipe-enquete`,
  DELETE_MEMBRE_EQUIPE_ENQ_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/delete/equipe-enquete`,
  POST_FICHE_DEMO_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/fiche-demographique`,
  ADD_DECLARATION_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/declaration`,
  UPDATE_DECLARATION_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/update/declaration`,
  DELETE_DECLARATION_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/delete/declaration`,
  ADD_LITIGE_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/fiche-identification-litige`,
  ADD_FICHE_LITIGE_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/fiche-litige`,
  UPDATE_FICHE_LITIGE_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/fiche-litige`,
  ADD_OCCUPANT_PARCELLE: `${COMMON_URL_PRESFOR}pvrdc/add-dec-occupant`,
  DELETE_OCCUPANT_PARCELLE: `${COMMON_URL_PRESFOR}pvrdc/delete-dec-occupant`,
  UPDATE_OCCUPANT_PARCELLE: `${COMMON_URL_PRESFOR}pvrdc/update-dec-occupant`,
  UPDATE_OCCUP_PARCELLE_DATE: `${COMMON_URL_PRESFOR}pvrdc/occupant-parcelle`,
  ADD_OCCUP_PARCELLE_DATE: `${COMMON_URL_PRESFOR}pvrdc/occupant-parcelle`,
  ADD_ETAT_DE_DROIT_PROP: `${COMMON_URL_PRESFOR}pvrdc/add-etat-droit`,
  DELETE_PVRDC_FICHE_DEMOGRAPHIQUE: `${COMMON_URL_PRESFOR}pvrdc/annexe/remove-fiche-demo`,
  DELETE_PVRDC_ANNEXE_EQUIPE_ENQUETE: `${COMMON_URL_PRESFOR}pvrdc/annexe/remove-equipe-enquete`,
  DELETE_PVRDC_ANNEXE_DECLARATION_OCCUPANT: `${COMMON_URL_PRESFOR}pvrdc/annexe/remove-declaration-persone-auditionne`,
  DELETE_PVRDC_ANNEXE_OCCUPANT_PARCELLE: `${COMMON_URL_PRESFOR}pvrdc/annexe/remove-occupant-personne`,
  DELETE_PVRDC_ANNEXE_FICHE_LITIGE: `${COMMON_URL_PRESFOR}pvrdc/annexe/remove-fiche-litige`,
  DELETE_PVRDC_ANNEXE_DESIGNATION_GESTIONNAIRE: `${COMMON_URL_PRESFOR}pvrdc/annexe/remove-designation-gestionnaire`,
  DELETE_PVRDC_ANNEXE_DETENTEUR_DROIT: `${COMMON_URL_PRESFOR}pvrdc/annexe/remove-detenteur-droit`,
  DELETE_PVRDC_ANNEXE_ETAT_DROIT: `${COMMON_URL_PRESFOR}pvrdc/annexe/remove-etat-droit`,
  DELETE_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/remove-pvrdc`,
  DELETE_PVRDC_ANNEXE_SERVITUDE: `${COMMON_URL_PRESFOR}pvrdc/annexe/remove-annexe-servitude`,
  DELETE_PVRDC_ANNEXE_SIGNATURE_DESIGNATION_GESTIONNAIRE: `${COMMON_URL_PRESFOR}pvrdc/annexe/remove-signature-designation-gestionnaire`,
  ADD_AYANT_DROIT: `${COMMON_URL_PRESFOR}pvrdc/ayant-droit`,
  POST_PDF_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/upload-pvrdc-pdf`,
  RAPPORT_PVRDC: `${BASE_URL_PRESFOR}pvrdc/rapport-pvrdc`,
  GET_CF: `${COMMON_URL_PRESFOR}certificat-foncier/dcf-one`,
  GET_PVRDC: `${COMMON_URL_PRESFOR}certificat-foncier/pvrdc-by-dcf`,
  GET_DCF_CONSTATS: `${COMMON_URL_PRESFOR}constat/dcf-constats`,
  GET_DCF_ANNONCE_PUBLICITE: `${COMMON_URL_PRESFOR}certificat-foncier/annoncepub-by-certif`,
  POST_PDF_CFPIECE: `${COMMON_URL_PRESFOR}user/ce/upload-dcf-id-pieces`,
  POST_PDF_CFPIECE_CLIENT: `${COMMON_URL_PRESFOR}user/ce/upload-dcf-id-pieces`,
  UPDATE_PDF_CFPIECE: `${COMMON_URL_PRESFOR}user/ce/upload-dcf-id-pieces`,
  POST_PDF_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/upload-dcf-document`,
  POST_DEMANDE_CF: `${COMMON_URL_PRESFOR}certificat-foncier/new`,
  POST_DESIGNATION_GESTIONNAIRECFC: `${COMMON_URL_PRESFOR}pvrdc/add-gbfc`,
  PUT_DESIGNATION_GESTIONNAIRECFC: `${COMMON_URL_PRESFOR}pvrdc/update-gbfc`,
  POST_DCF_DEMANDE_CLIENT: `${COMMON_URL_PRESFOR}certificat-foncier/client/new-dcf`,
  ADD_SIGNATAIRE_BIEN_FONCIER: `${COMMON_URL_PRESFOR}pvrdc/add-liste-gbfc`,
  ADD_DETENTEURS_DE_DROITS_CF: `${COMMON_URL_PRESFOR}pvrdc/listeddcc`,
  LOG_ACTIVITY: `${COMMON_URL_PRESFOR}log-activity/getLogsBy`,
  LOG_ACTIVITY_BY_ID: `${COMMON_URL_PRESFOR}log-activity/getLogsBy`,
  TRANSMISSION_AUDIT: `${COMMON_URL_PRESFOR}transmission-audit`,
  TRANSMISSION_AUDIT_FILTRES: `${COMMON_URL_PRESFOR}transmission-audit/filtres`,
  GET_CF_BY_ENQ: `${COMMON_URL_PRESFOR}certificat-foncier/by-enquete`,
  POST_TEMOIN_CONTRAT: `${COMMON_URL_PRESFOR}contrat/add-temoin`,
  UPDATE_TEMOIN_CONTRAT: `${COMMON_URL_PRESFOR}contrat/update-temoin`,
  POST_PDF_CONTRAT: `${COMMON_URL_PRESFOR}contrat/upload-contract`,
  POST_CECPDC_BY_ANNONCE: `${COMMON_URL_PRESFOR}constat/cecpdc-by-annonce`,
  UPDATE_CECPDC_BY_ANNONCE: `${COMMON_URL_PRESFOR}constat/cecpdc-by-annonce`,
  GET_CECPDC_BY_ANNONCE: `${COMMON_URL_PRESFOR}constat/cecpdc-by-annonce`,
  GET_CECPDC_ANNONCE_BY_ID: `${COMMON_URL_PRESFOR}constat/cecpdc-annonce-byid`,
  DELETE_CECPDC_BY_ANNONCE: `${COMMON_URL_PRESFOR}constat/cecpdc-by-annonce`,
  POST_CECPDC_PDF: `${COMMON_URL_PRESFOR}constat/generate-cecpdc-pdf`,
  POST_VALID_PDF: `${COMMON_URL_PRESFOR}constat/generate-valid-pdf`,
  UPDATE_PROCURATION_CONTRAT: `${COMMON_URL_PRESFOR}update/procuration`,
  POST_PDF_CNI_CONTRAT: `${COMMON_URL_PRESFOR}contrat/file-pieces`,
  POST_FICHE_IDENTIFICATION: `${COMMON_URL_PRESFOR}certificat-foncier/fiche-identification`,
  UPDATE_FICHE_IDENTIFICATION: `${COMMON_URL_PRESFOR}certificat-foncier/fiche-identification`,
  UPDATE_PDF_CNI_CONTRAT: `${COMMON_URL_PRESFOR}update/file-pieces`,
  POST_PDF_PROCURATION_CONTRAT: `${COMMON_URL_PRESFOR}contrat/upload-procuration`,
  UPDATE_PDF_PROCURATION_CONTRAT: `${COMMON_URL_PRESFOR}update/procuration`,
  POST_PDF_CROQUIS_CONTRAT: `${COMMON_URL_PRESFOR}contrat/upload-croquis`,
  POST_ANNEXES_CONTRAT: `${COMMON_URL_PRESFOR}contrat/upload-annexe`,
  UPDATE_ANNEXES_CONTRAT: `${COMMON_URL_PRESFOR}update/annexe`,
  READ_PDF_PROCURATION: `${COMMON_URL_PRESFOR}contrat-read/procuration`,
  READ_PDF_CROQUIS: `${COMMON_URL_PRESFOR}contrat-read/croquis`,
  READ_PDF_CONTRAT: `${COMMON_URL_PRESFOR}read-contract/file`,
  READ_PDF_ANNEXES: `${COMMON_URL_PRESFOR}contrat-read/annexe/`,
  READ_PDF_PIECESID: `${COMMON_URL_PRESFOR}contrat-read/piece/`,
  GET_CONTRAT_ENQ: `${COMMON_URL_PRESFOR}contrat/by-enquete`,
  GET_CONTRAT: `${COMMON_URL_PRESFOR}contrat/findone`,
  GET_CONTRAT_ALL: `${COMMON_URL_PRESFOR}contrat/all`,
  GET_CONTRATS_TRANSMIS: `${COMMON_URL_PRESFOR}contrat/list-contrats-transmis`,
  GET_CONTRATS_A_TRANSMETTRE: `${COMMON_URL_PRESFOR}contrat/list-contrats-a-transmettre`,
  TRANSMIT_CONTRAT_AFOR: `${COMMON_URL_PRESFOR}contrat/afor-transmission/transmit-or-update`,
 TRANSMIT_CONTRAT_DOCUMENTS_AFOR: `${COMMON_URL_PRESFOR}contrat/afor-transmission-documents`,
  GET_DELETE_CONTRAT: `${COMMON_URL_PRESFOR}update/delete/`,
  POST_SOUSSIGNE_CONTRAT: `${COMMON_URL_PRESFOR}contrat/add-person`,
  PUT_SOUSSIGNE_CONTRAT: `${COMMON_URL_PRESFOR}contrat/update-person`,
  POST_CONTRAT: `${COMMON_URL_PRESFOR}contrat/new`,
  UPDATE_CONTRAT: `${COMMON_URL_PRESFOR}contrat/update-contrat`,
  GET_ENQUETE_USER: `${COMMON_URL_PRESFOR}enquete/by-user`,
  GET_ENQUETE_ALL: `${COMMON_URL_PRESFOR}enquete/all`,
  GET_ONLY_ENQUETE_ALL: `${COMMON_URL_PRESFOR}enquete/all-enquete`,
  GET_ONLY_ENQUETE_ALL_CLIENT: `${COMMON_URL_PRESFOR}enquete/check-enquete`,
  POST_ENQUETE_CLIENT: `${COMMON_URL_PRESFOR}enquete/new-client-enquete`,
  GET_COMMUNE_VIL: `${COMMON_URL_PRESFOR}codification/commune-vil`,
  GET_SP_COMMUNE: `${COMMON_URL_PRESFOR}codification/sp-commune`,
  GET_DEP_SP: `${COMMON_URL_PRESFOR}codification/dep-sp`,
  GET_REGION_DEP: `${COMMON_URL_PRESFOR}codification/region-dep`,
  GET_REGIONS: `${COMMON_URL_PRESFOR}codification/regions`,
  POST_USER_RESEND_EMAIL: `${COMMON_URL_PRESFOR}user/resend-email`,
  POST_USER_CONFIRM_EMAIL: `${COMMON_URL_PRESFOR}user/confirm-email`,
  CHANGE_PSWD_USER: `${COMMON_URL_PRESFOR}user/change-password`,
  FORGOT_PSWD_USER: `${COMMON_URL_PRESFOR}user/forgot-password`,
  SIGNIN_USER: `${COMMON_URL_PRESFOR}user/signin`,
  UPDATE_USER: `${COMMON_URL_PRESFOR}user`,
  REFRESH_TOKEN_USER: `${COMMON_URL_PRESFOR}user/refresh-token`,
  SIGNUP_USER: `${COMMON_URL_PRESFOR}user/signup`,
  GET_ALL_USER: `${COMMON_URL_PRESFOR}user/all`,
  GET_CHECK_USER: `${COMMON_URL_PRESFOR}user/check-admin`,
  POST_ENQUETE: `${COMMON_URL_PRESFOR}enquete/new`,
  GET_ENQUETE_BY_CODE: `${COMMON_URL_PRESFOR}enquete/by-code`,
  GET_ALL_CF: `${COMMON_URL_PRESFOR}certificat-foncier/cf/all`,
  GET_ALL_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/list-dcf`,
  EXPORT_DCF_PDF: `${COMMON_URL_PRESFOR}certificat-foncier/export-dcfs`,
  EXPORT_PVCL: `${COMMON_URL_PRESFOR}certificat-foncier/export-pvcls`,
  GET_HISTORY_EXPORT_LIVRABLE: `${COMMON_URL_PRESFOR}certificat-foncier/history-export-livrable`,
  DOWNLOAD_HISTORY_EXPORT_LIVRABLE: `${COMMON_URL_PRESFOR}certificat-foncier/history-export-livrable`,
  TRANSMIT_OR_UPDATE_DCFS: `${COMMON_URL_PRESFOR}transmission-afor/dcfs/transmit-or-update`,
  TRANSMIT_OR_UPDATE_PVCLS: `${COMMON_URL_PRESFOR}transmission-afor/pvcls/transmit-or-update`,
  TRANSMIT_OR_UPDATE_PVRDCS: `${COMMON_URL_PRESFOR}transmission-afor/pvrdcs/transmit-or-update`,
  TRANSMIT_OR_UPDATE_OCCUPANTS_PARCELLE: `${COMMON_URL_PRESFOR}transmission-afor/pvrdcs/send-occupants-parcelle/transmit-or-update`,
  TRANSMIT_OR_UPDATE_PLANS_PROVISOIRE: `${COMMON_URL_PRESFOR}transmission-afor/plans/ppp-document`,
  TRANSMIT_OR_UPDATE_PLANS_PROVISOIRE_V2: `${COMMON_URL_PRESFOR}transmission-afor/ppp-v2/transmit-or-update`,
  TRANSMIT_OR_UPDATE_PLANS_DEFINITIF: `${COMMON_URL_PRESFOR}transmission-afor/plans/ppd-document`,
  TRANSMIT_OR_UPDATE_ATT_APPROBATION: `${COMMON_URL_PRESFOR}transmission-afor/cecpdcs/transmit-or-update`,
  TRANSMIT_OR_UPDATE_ATT_VALIDATION: `${COMMON_URL_PRESFOR}transmission-afor/valids/transmit-or-update`,
  ADD_OTA: `${COMMON_URL_PRESFOR}ota/create-ota`,
  GET_ALL_OTA: `${COMMON_URL_PRESFOR}ota/all`,
  GET_ALL_DCF_CLIENT: `${COMMON_URL_PRESFOR}certificat-foncier/all-dcf`,
  GET_ONE_OTA: `${COMMON_URL_PRESFOR}ota`,
  POST_DECLARATION_OUVERTURE: `${COMMON_URL_PRESFOR}clarification/declaration-ouverture/new`,
  POST_TRANSMISSION_LETTRE: `${COMMON_URL_PRESFOR}clarification/transmission-lettre/new`,
  UPDATE_DECLARATION_OUVERTURE: `${COMMON_URL_PRESFOR}clarification/declaration-ouverture/update`,
  UPDATE_TRANSMISSION_LETTRE: `${COMMON_URL_PRESFOR}clarification/transmission-lettre/update`,
  DELETE_DO: `${COMMON_URL_PRESFOR}clarification/declaration-ouverture/delete`,
  DELETE_TL: `${COMMON_URL_PRESFOR}clarification/transmission-lettre/delete`,
  GET_TL: `${COMMON_URL_PRESFOR}clarification/transmission-by-code`,
  POST_AEFC: `${COMMON_URL_PRESFOR}consolidation/new/attestation-aefc`,
  POST_AEFJ: `${COMMON_URL_PRESFOR}consolidation/new/attestation-aefj`,
  DOWNLOAD_MOBILE_APP: `${COMMON_URL_PRESFOR}certificat-foncier/download-apk`,
  SEND_MESSAGE: `${COMMON_URL_PRESFOR}contact/send-message`,
  //PUT_DESIGNATION_GESTIONNAIRECFC: `${COMMON_URL_PRESFOR}pvrdc/update-gbfc`,
  // CREATE_DCF_ANP_PDFS: `${COMMON_URL_PRESFOR}certificat-foncier/create-dcf-anp-pdf`
  GET_VILLAGES_BY_CODE_ENQUETE: `${COMMON_URL_PRESFOR}codification/sp`,
  GET_DTV_BY_ENQUETE: `${COMMON_URL_PRESFOR}dtv/by-enquete`,
  POST_ATTESTATION_VALIDATION_ENQUETE: `${COMMON_URL_PRESFOR}dtv/attestation-valid`,
  IMPORT_DRIVE: `${COMMON_URL_PRESFOR}certificat-foncier/recovery-dcf-from-drive`,
  IMPORT_DRIVE_STATUS: `${COMMON_URL_PRESFOR}certificat-foncier/drive-import-status`,
  DOWNLOAD_RECOVERY_REPORT: `${COMMON_URL_PRESFOR}certificat-foncier/download-recovery-report`,
  GET_HISTO_IMPORT_PLAN_DRIVE: `${COMMON_URL_PRESFOR}certificat-foncier/histo-import-plan-drive`,
  DOWNLOAD_HISTO_IMPORT_PLAN_REPORT: `${COMMON_URL_PRESFOR}certificat-foncier/histo-import-plan-drive`,
  IMPORT_CF19_DRIVE: `${COMMON_URL_PRESFOR}certificat-foncier/recovery-cf19-from-drive`,
  GET_HISTO_IMPORT_CF19_DRIVE: `${COMMON_URL_PRESFOR}certificat-foncier/histo-import-cf19-drive`,
  DOWNLOAD_HISTO_IMPORT_CF19_REPORT: `${COMMON_URL_PRESFOR}certificat-foncier/histo-import-cf19-drive`,
  PUT_ATTESTATION_VALIDATION_ENQUETE: `${COMMON_URL_PRESFOR}dtv/attestation-valid`,
  GET_PARTICIPANTS_ATTESTATION_VALIDATION_ENQUETE_RURAL: `${COMMON_URL_PRESFOR}dtv/participants-attestation-validation-rural`,
  POST_ATTESTATION_APPROBATION_ENQUETE: `${COMMON_URL_PRESFOR}dtv/attestation-approbation`,
  PUT_ATTESTATION_APPROBATION_ENQUETE: `${COMMON_URL_PRESFOR}dtv/attestation-approbation`,
  POST_DTV_HISTO: `${COMMON_URL_PRESFOR}dtv/histo`,
  GET_TRONCONS: `${COMMON_URL_PRESFOR}dtv/pvlim`,
  POST_TRONCON: `${COMMON_URL_PRESFOR}dtv/pvlim`,
  PUT_TRONCON: `${COMMON_URL_PRESFOR}dtv/pvlim`,
  POST_DTV_ANP: `${COMMON_URL_PRESFOR}dtv/anp`,
  PUT_DTV_ANP: `${COMMON_URL_PRESFOR}dtv/anp`,
  POST_DTV_ANPO: `${COMMON_URL_PRESFOR}dtv/anpo`,
  PUT_DTV_ANPO: `${COMMON_URL_PRESFOR}dtv/anpo`,

  POST_ANPC: `${COMMON_URL_PRESFOR}dtv/anpc`,
  DELETE_TRONCON: `${COMMON_URL_PRESFOR}dtv/pvlim`,
  UPLOAD_PVLIM: `${COMMON_URL_PRESFOR}dtv/upload-pvlim-pdf`,
  DELETE_TRONCON_ALL: `${COMMON_URL_PRESFOR}dtv/remove-enquete-pvlim`,
  DELETE_PV_HISTO: `${COMMON_URL_PRESFOR}dtv/histo`,
  POST_HISTO_PIECE: `${COMMON_URL_PRESFOR}dtv/upload-histo-pdf`,

  DELETE_DTV_ANP: `${COMMON_URL_PRESFOR}dtv/anp`,
  DELETE_DTV_ANPO: `${COMMON_URL_PRESFOR}dtv/anpo`,

  POST_ANP_PIECE: `${COMMON_URL_PRESFOR}dtv/upload-anp-pdf`,
  POST_ANPO_PIECE: `${COMMON_URL_PRESFOR}dtv/upload-anpo-pdf`,

  GET_ANP_BY_ENQUETE: `${COMMON_URL_PRESFOR}dtv/anp-by-enquete`,
  UPDATE_DTV_ANPC: `${COMMON_URL_PRESFOR}dtv/anpc`,

  DELETE_DTV_ANPC: `${COMMON_URL_PRESFOR}dtv/anpc`,
  DELETE_ATTESTATION_APPROBATION_ENQUETE: `${COMMON_URL_PRESFOR}dtv/attestation-approb`,
  DELETE_ATTESTATION_VALIDATION_ENQUETE: `${COMMON_URL_PRESFOR}dtv/attestation-valid`,

  UPLOAD_DTV_ANPC: `${COMMON_URL_PRESFOR}dtv/upload-anpc-pdf`,
  UPLOAD_ATTESTATION_APPROBATION_ENQUETE: `${COMMON_URL_PRESFOR}dtv/upload-approb-pdf`,
  UPLOAD_ATTESTATION_VALIDATION_ENQUETE: `${COMMON_URL_PRESFOR}dtv/upload-valid-pdf`,

  GENERER_PDF_CONSTAT_LIMITE_TRONCON: `${COMMON_URL_PRESFOR}dtv/generate-pvlim-pdf`,

  GET_CALENDRIER_OUVERTURE: `${COMMON_URL_PRESFOR}isf/calendrier-ouverture`,
  POST_CALENDRIER_OUVERTURE: `${COMMON_URL_PRESFOR}isf/calendrier-ouverture`,
  PUT_CALENDRIER_OUVERTURE: `${COMMON_URL_PRESFOR}isf/calendrier-ouverture`,
  DELETE_CALENDRIER_OUVERTURE: `${COMMON_URL_PRESFOR}isf/delete-calendrier-ouverture`,

  UPLOAD_CALENDRIER_OUVERTURE: `${COMMON_URL_PRESFOR}isf/upload-calendrier-ouverture-pdf`,
  GENERER_PDF_CALENDRIER_OUVERTURE: `${COMMON_URL_PRESFOR}isf/calendrier-ouverture`,

  GET_LISTE_PRESENCE_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/prise-contact`,
  POST_LISTE_PRESENCE_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/prise-contact`,
  PUT_LISTE_PRESENCE_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/prise-contact`,
  DELETE_LISTE_PRESENCE_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/delete-prise-contact`,

  UPLOAD_LISTE_PRESENCE_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/upload-prise-contact-pdf`,
  GENERER_PDF_LISTE_PRESENCE_CONTACT: `${COMMON_URL_PRESFOR}prise-contact`,

  GET_COMPTE_RENDU_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/compte-rendu`,
  POST_COMPTE_RENDU_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/compte-rendu`,
  PUT_COMPTE_RENDU_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/compte-rendu`,
  DELETE_COMPTE_RENDU_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/delete-compte-rendu`,
  DELETE_COMPTE_RENDU_CONTACT_SP: `${COMMON_URL_PRESFOR}prise-contact/delete-compte-rendu-by-sp`,
  GET_COMPTE_RENDU_CONTACT_SP: `${COMMON_URL_PRESFOR}prise-contact/compte-rendu-by-sp`,
  PUT_COMPTE_RENDU_CONTACT_SP: `${COMMON_URL_PRESFOR}prise-contact/compte-rendu-by-sp`,

  UPLOAD_COMPTE_RENDU_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/upload-compte-rendu-pdf`,
  GENERER_PDF_COMPTE_RENDU_CONTACT: `${COMMON_URL_PRESFOR}prise-contact`,

  POST_PVCFIDCP: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dcp`,
  PUT_PVCFIDCP: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dcp`,
  DELETE_PVCFIDCP: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dcp`,

  UPLOAD_PDF_PVCFIDCP: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dcp`,
  GENERER_PDF_PVCFIDCP: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dcp`,

  POST_PVCFIDCI: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dci`,
  PUT_PVCFIDCI: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dci`,
  DELETE_PVCFIDCI: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dci`,

  UPLOAD_PDF_PVCFIDCI: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dci`,
  GENERER_PDF_PVCFIDCI: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dci`,

  POST_PVCFIDCC: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dcc`,
  PUT_PVCFIDCC: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dcc`,
  DELETE_PVCFIDCC: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dcc`,

  UPLOAD_PDF_PVCFIDCC: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dcc`,
  GENERER_PDF_PVCFIDCC: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi-dcc`,

  GET_DIALOGUE_SOCIAL: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi`,
  DELETE_PVCFIDC: `${COMMON_URL_PRESFOR}dialogue-social/pvcfi`,
  UPLOAD_PDF_PVCFIDC: `${COMMON_URL_PRESFOR}dialogue-social/upload-pvcfi-pdf`,

  POST_CHARTERELATION: `${COMMON_URL_PRESFOR}charte/new`,
  GET_CHARTERELATION: `${COMMON_URL_PRESFOR}charte`,
  PUT_CHARTERELATION: `${COMMON_URL_PRESFOR}charte`,
  DELETE_CHARTERELATION: `${COMMON_URL_PRESFOR}charte`,
  UPLOADS_CHARTE_PDF: `${COMMON_URL_PRESFOR}charte/upload-charte-pdf`,

  // Protocole de gestion foncière (PGF)
  GET_PGF_BY_NUMERO: `${COMMON_URL_PRESFOR}dialogue-social/pgf`,
  POST_NEW_PGF: `${COMMON_URL_PRESFOR}dialogue-social/pgf/new`,
  PUT_UPDATE_PGF: `${COMMON_URL_PRESFOR}dialogue-social/pgf`,
  DELETE_PGF: `${COMMON_URL_PRESFOR}dialogue-social/delete-pgf`,
  POST_UPLOAD_PGF_PDF: `${COMMON_URL_PRESFOR}dialogue-social/upload-pgf-pdf`,

  // GET_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL_PRESFOR}reunion-periodique/decision-designation-activite`,

  POST_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL_PRESFOR}reunion-periodique/decision-designation-activite`,
  PUT_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL_PRESFOR}reunion-periodique/decision-designation-activite`,
  DELETE_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL_PRESFOR}reunion-periodique/delete-decision-designation-activite`,

  UPLOAD_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL_PRESFOR}reunion-periodique/upload-decision-pdf`,
  GENERER_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE: `${COMMON_URL_PRESFOR}reunion-periodique/decision-designation-activite`,

  GET_REUNION_PERIODIQUE: `${COMMON_URL_PRESFOR}reunion-periodique`,

  // GET_REUNION_PERIODIQUE: `${COMMON_URL_PRESFOR}reunion-periodique/resume-resolution`,
  POST_REUNION_PERIODIQUE_RESUME: `${COMMON_URL_PRESFOR}reunion-periodique/resume-resolution`,
  PUT_REUNION_PERIODIQUE_RESUME: `${COMMON_URL_PRESFOR}reunion-periodique/resume-resolution`,
  DELETE_REUNION_PERIODIQUE_RESUME: `${COMMON_URL_PRESFOR}reunion-periodique/delete-resume-resolution`,

  UPLOAD_PDF_REUNION_PERIODIQUE_RESUME: `${COMMON_URL_PRESFOR}reunion-periodique/upload-resume-pdf`,
  GENERER_PDF_REUNION_PERIODIQUE_RESUME: `${COMMON_URL_PRESFOR}reunion-periodique/resume-resolution`,

  POST_DECISION_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/decision-creation-cvgfr`,
  GET_DECISION_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/decision-creation-cvgfr`,
  PUT_DECISION_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/decision-creation-cvgfr`,
  DELETE_DECISION_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/delete-decision-creation-cvgfr`,

  UPLOAD_PDF_DECISION_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/decision-creation-cvgfr-pdf`,
  GENERER_PDF_DECISION_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/decision-creation-cvgfr`,

  POST_PV_CONSTITUTION_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/pv-constitution-cvgfr`,
  PUT_PV_CONSTITUTION_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/pv-constitution-cvgfr`,
  GET_PV_CONSTITUTION_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/pv-constitution-cvgfr`,
  DELETE_PV_CONSTITUTION_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/delete-pv-constitution`,

  UPLOAD_PDF_PV_CONSTITUTION_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/pv-constitution-cvgfr-pdf`,
  GENERER_PDF_PV_CONSTITUTION_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/pv-constitution-cvgfr`,

  POST_LIVRABLE_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/diagnostic-cvgfr`,
  GET_LIVRABLE_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/diagnostic-cvgfr`,
  PUT_LIVRABLE_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/diagnostic-cvgfr`,
  DELETE_LIVRABLE_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/delete-diagnostic-cvgfr`,
  UPDATE_LIVRABLE_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/diagnostic-cvgfr`,

  UPLOAD_PDF_LIVRABLE_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/upload-diagnostic-cvgfr-pdf`,
  GENERER_PDF_LIVRABLE_ISF_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/diagnostic-cvgfr`,

  POST_CACHIERS_INTENTIONS_CF: `${COMMON_URL_PRESFOR}registre-intention/dcf`,
  GET_CACHIERS_INTENTIONS_CF: `${COMMON_URL_PRESFOR}registre-intention/dcf`,
  PUT_CACHIERS_INTENTIONS_CF: `${COMMON_URL_PRESFOR}registre-intention/dcf`,

  POST_CACHIERS_INTENTIONS_CONTRAT: `${COMMON_URL_PRESFOR}registre-intention/dcc`,
  GET_CACHIERS_INTENTIONS_CONTRAT: `${COMMON_URL_PRESFOR}registre-intention`,
  PUT_CACHIERS_INTENTIONS_CONTRAT: `${COMMON_URL_PRESFOR}registre-intention/dcc`,

  GET_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/reglement-interieur-cvgfr`,
  POST_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/reglement-interieur-cvgfr`,
  PUT_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/reglement-interieur-cvgfr`,
  DELETE_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/reglement-interieur-cvgfr`,
  UPLOAD_PDF_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/upload-reglement-interieur-cvgfr-pdf`,
  GENERER_PDF_REGLEMENT_INTERIEUR_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/reglement-interieur-cvgfr`,

  GET_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/attestation-formation-cvgfr`,
  POST_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/attestation-formation-cvgfr`,
  PUT_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/attestation-formation-cvgfr`,
  DELETE_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/attestation-formation-cvgfr`,
  UPLOAD_PDF_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/upload-attestation-formation-cvgfr-pdf`,
  GENERER_PDF_ATTESTATION_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/attestation-formation-cvgfr`,

  GET_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/attestation-formation-cvgfr`,
  POST_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/liste-presence`,
  PUT_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/liste-presence`,
  DELETE_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/liste-presence`,
  UPLOAD_PDF_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/upload-liste-presence-pdf`,
  GENERER_PDF_LISTE_PRESENCE_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/liste-presence`,

  DELETE_CACHIERS_INTENTIONS_CF: `${COMMON_URL_PRESFOR}registre-intention/delete-dcf`,
  DELETE_CACHIERS_INTENTIONS_CONTRAT: `${COMMON_URL_PRESFOR}registre-intention/delete-dcc`,
  UPLOAD_PDF_CACHIERS_INTENTIONS_CF: `${COMMON_URL_PRESFOR}registre-intention/upload-dcf-pdf`,
  UPLOAD_PDF_CACHIERS_INTENTIONS_CONTRAT: `${COMMON_URL_PRESFOR}registre-intention/upload-dcc-pdf`,

  POST_ISF_DECLARATION_OUVERTURE: `${COMMON_URL_PRESFOR}isf/declaration-ouverture`,
  PUT_ISF_DECLARATION_OUVERTURE: `${COMMON_URL_PRESFOR}isf/declaration-ouverture`,
  DELETE_ISF_DECLARATION_OUVERTURE: `${COMMON_URL_PRESFOR}isf/delete-declaration-ouverture`,
  UPLOAD_PDF_ISF_DECLARATION_OUVERTURE: `${COMMON_URL_PRESFOR}isf/upload-declaration-ouverture-pdf`,
  GET_ISFR_DECLARATION_OUVERTURE: `${COMMON_URL_PRESFOR}isf/declaration-ouverture`,

  POST_ISF_CEREMONIE_OUVERTURE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/ceremonie-ouverture`,
  PUT_ISF_CEREMONIE_OUVERTURE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/ceremonie-ouverture`,
  DELETE_ISF_CEREMONIE_OUVERTURE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/delete-co`,
  UPLOAD_PDF_ISF_CEREMONIE_OUVERTURE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/upload-co-pdf`,
  GET_ISFR_CEREMONIE_OUVERTURE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/ceremonie-ouverture`,

  POST_ISF_COMPTE_RENDU: `${COMMON_URL_PRESFOR}ceremonie-ouverture/compte-rendu`,
  PUT_ISF_COMPTE_RENDU: `${COMMON_URL_PRESFOR}ceremonie-ouverture/compte-rendu`,
  DELETE_ISF_COMPTE_RENDU: `${COMMON_URL_PRESFOR}ceremonie-ouverture/delete-compte-rendu`,
  UPLOAD_PDF_ISF_COMPTE_RENDU: `${COMMON_URL_PRESFOR}ceremonie-ouverture/upload-compte-rendu-pdf`,
  GET_ISF_COMPTE_RENDU: `${COMMON_URL_PRESFOR}ceremonie-ouverture/compte-rendu`,

  POST_ISF_RAPPORT_VILLAGE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/rapport-isf`,
  PUT_ISF_RAPPORT_VILLAGE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/rapport-isf`,
  DELETE_ISF_RAPPORT_VILLAGE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/delete-rapport-isf`,
  UPLOAD_PDF_ISF_RAPPORT_VILLAGE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/upload-rapport-isf-pdf`,
  GET_ISF_RAPPORT_VILLAGE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/rapport-isf`,

  POST_ISF_CALENDRIER_PREV: `${COMMON_URL_PRESFOR}elaboration-calendrier/calendrier-prev`,
  PUT_ISF_CALENDRIER_PREV: `${COMMON_URL_PRESFOR}elaboration-calendrier/calendrier-prev`,
  DELETE_ISF_CALENDRIER_PREV: `${COMMON_URL_PRESFOR}elaboration-calendrier/delete-calendrier-prev`,
  UPLOAD_PDF_ISF_CALENDRIER_PREV: `${COMMON_URL_PRESFOR}elaboration-calendrier/upload-calendrier-prev-pdf`,
  GET_ISF_CALENDRIER_PREV: `${COMMON_URL_PRESFOR}elaboration-calendrier/calendrier-prev`,

  POST_ISF_COURRIER_TRANS: `${COMMON_URL_PRESFOR}elaboration-calendrier/courrier-trans`,
  PUT_ISF_COURRIER_TRANS: `${COMMON_URL_PRESFOR}elaboration-calendrier/courrier-trans`,
  DELETE_ISF_COURRIER_TRANS: `${COMMON_URL_PRESFOR}elaboration-calendrier/delete-courrier-trans`,
  UPLOAD_PDF_ISF_COURRIER_TRANS: `${COMMON_URL_PRESFOR}elaboration-calendrier/upload-courrier-trans-pdf`,
  GET_ISF_COURRIER_TRANS: `${COMMON_URL_PRESFOR}elaboration-calendrier/courrier-trans`,

  LOGIN_WITH_TOKEN: `${COMMON_URL_PRESFOR}user/login-with-token`,
  GET_USER: `${COMMON_URL_PRESFOR}user`,
  POST_CALENDRIER_PREVISIONEL: `${COMMON_URL_PRESFOR}dialogue-social/calendrier-previsionel`,
  PUT_CALENDRIER_PREVISIONEL: `${COMMON_URL_PRESFOR}dialogue-social/calendrier-previsionel`,
  GET_CALENDRIER_PREVISIONEL: `${COMMON_URL_PRESFOR}dialogue-social/calendrier-previsionel`,
  UPLOAD_PDF_CALENDRIER_PREVISIONNEL: `${COMMON_URL_PRESFOR}dialogue-social/upload-calendrier-previsionel-pdf`,
  DELETE_CALENDRIER_PREVSIONNEL: `${COMMON_URL_PRESFOR}dialogue-social/calendrier-previsionel`,

  POST_PROCES_VERBAL_REGLEMENT_LITIGE: `${COMMON_URL_PRESFOR}dialogue-social/pvrlf`,
  PUT_PROCES_VERBAL_REGLEMENT_LITIGE: `${COMMON_URL_PRESFOR}dialogue-social/pvrlf`,
  DELETE_PROCES_VERBAL_REGLEMENT_LITIGE: `${COMMON_URL_PRESFOR}dialogue-social/pvrlf`,
  UPLOAD_PDF_PROCES_VERBAL_REGLEMENT_LITIGE: `${COMMON_URL_PRESFOR}dialogue-social/upload-pvrlf-pdf`,
  GET_PROCES_VERBAL_REGLEMENT_LITIGE: `${COMMON_URL_PRESFOR}dialogue-social/pvrlf`,

  POST_ISF_DEMANDE_IDENTITE: `${COMMON_URL_PRESFOR}activites-dialogue-social/new`,
  PUT_ISF_DEMANDE_IDENTITE: `${COMMON_URL_PRESFOR}activites-dialogue-social`,
  DELETE_ISF_DEMANDE_IDENTITE: `${COMMON_URL_PRESFOR}activites-dialogue-social/delete-demande-identite`,
  UPLOAD_PDF_ISF_DEMANDE_IDENTITE: `${COMMON_URL_PRESFOR}activites-dialogue-social/upload-demande-identite-pdf`,
  GET_ISF_DEMANDE_IDENTITE: `${COMMON_URL_PRESFOR}activites-dialogue-social`,

  POST_ISF_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL_PRESFOR}dialogue-social/pvca/new`,
  PUT_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL_PRESFOR}dialogue-social/pvca`,
  DELETE_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL_PRESFOR}dialogue-social/delete-pvca`,
  UPLOAD_PDF_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL_PRESFOR}dialogue-social/upload-pvca-pdf`,
  GET_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL_PRESFOR}dialogue-social/pvca`,
  UPLOAD_PDF_ISF_PROCES_VERBAL_ACHEVEMENT: `${COMMON_URL_PRESFOR}dialogue-social/upload-pvca-pdf`,

  POST_ISF_RAPPORT_ACTIVITE: `${COMMON_URL_PRESFOR}rapport/activite`,
  PUT_ISF_RAPPORT_ACTIVITE: `${COMMON_URL_PRESFOR}rapport/activite`,
  DELETE_ISF_RAPPORT_ACTIVITE: `${COMMON_URL_PRESFOR}rapport/activite`,
  UPLOAD_PDF_ISF_RAPPORT_ACTIVITE: `${COMMON_URL_PRESFOR}rapport/upload-activite-pdf`,
  GET_ISF_RAPPORT_ACTIVITE: `${COMMON_URL_PRESFOR}rapport`,

  POST_ISF_RAPPORT_ACTIVITE_OS: `${COMMON_URL_PRESFOR}rapport/osf`,
  PUT_ISF_RAPPORT_ACTIVITE_OS: `${COMMON_URL_PRESFOR}rapport/osf`,
  DELETE_ISF_RAPPORT_ACTIVITE_OS: `${COMMON_URL_PRESFOR}rapport/osf`,
  UPLOAD_PDF_ISF_RAPPORT_ACTIVITE_OS: `${COMMON_URL_PRESFOR}rapport/osf/upload-pdf`,
  GET_ISF_RAPPORT_ACTIVITE_OS: `${COMMON_URL_PRESFOR}rapport/osf`,

  POST_ISF_GUIDE_ENTRETIEN: `${COMMON_URL_PRESFOR}dialogue-social/guide-entretien`,
  PUT_GUIDE_ENTRETIEN: `${COMMON_URL_PRESFOR}dialogue-social/guide-entretien`,
  DELETE_GUIDE_ENTRETIEN: `${COMMON_URL_PRESFOR}dialogue-social/guide-entretien`,
  UPLOAD_PDF_GUIDE_ENTRETIEN: `${COMMON_URL_PRESFOR}dialogue-social/guide-entretien`,
  GET_GUIDE_ENTRETIEN: `${COMMON_URL_PRESFOR}dialogue-social/guide-entretien`,
  UPLOAD_PDF_ISF_GUIDE_ENTRETIEN: `${COMMON_URL_PRESFOR}dialogue-social/upload-guide-entretien-pdf`,

  POST_ISF_RAPPORT_SENSIBILISATION_ISF: `${COMMON_URL_PRESFOR}information-sensibilisation/is-rapport-isf`,
  PUT_RAPPORT_SENSIBILISATION_ISF: `${COMMON_URL_PRESFOR}information-sensibilisation/is-rapport-isf`,
  DELETE_RAPPORT_SENSIBILISATION_ISF: `${COMMON_URL_PRESFOR}information-sensibilisation/delete-rapport-isf`,
  GET_RAPPORT_SENSIBILISATION_ISF: `${COMMON_URL_PRESFOR}information-sensibilisation/is-rapport-isf`,
  UPLOAD_PDF_ISF_RAPPORT_SENSIBILISATION_ISF: `${COMMON_URL_PRESFOR}information-sensibilisation/upload-is-rapport-pdf`,

  POST_ISF_SENSIBILISATION: `${COMMON_URL_PRESFOR}information-sensibilisation/information-sensibilisation`,
  PUT_ISF_SENSIBILISATION: `${COMMON_URL_PRESFOR}information-sensibilisation/information-sensibilisation`,
  DELETE_ISF_SENSIBILISATION: `${COMMON_URL_PRESFOR}information-sensibilisation/delete-is-isf`,
  GET_ISF_SENSIBILISATION: `${COMMON_URL_PRESFOR}information-sensibilisation/information-sensibilisation`,
  UPLOAD_PDF_ISF_SENSIBILISATION: `${COMMON_URL_PRESFOR}information-sensibilisation/upload-is-pdf`,

  POST_ISF_RECUEIL_DONNEES_PERSONNELLES: `${COMMON_URL_PRESFOR}isf/recueil-donnee-personnel`,
  PUT_ISF_RECUEIL_DONNEES_PERSONNELLES: `${COMMON_URL_PRESFOR}isf/recueil-donnee-personnel`,
  DELETE_ISF_RECUEIL_DONNEES_PERSONNELLES: `${COMMON_URL_PRESFOR}isf/recueil-donnee-personnel`,
  GET_ISF_RECUEIL_DONNEES_PERSONNELLES: `${COMMON_URL_PRESFOR}isf/recueil-donnee-personnel`,
  UPLOAD_PDF_ISF_RECUEIL_DONNEES_PERSONNELLES: `${COMMON_URL_PRESFOR}isf/upload-recueil-donnee-personnel-pdf`,

  GET_ALL_PREFECTURE: `${COMMON_URL_PRESFOR}codification/sous-prefecture`,
  POST_DTV_RAPPORT_ACTIVITES: `${COMMON_URL_PRESFOR}dtv/rapport-activite`,
  PUT_DTV_RAPPORT_ACTIVITES: `${COMMON_URL_PRESFOR}dtv/rapport-activite`,
  DELETE_DTV_RAPPORT_ACTIVITES: `${COMMON_URL_PRESFOR}dtv/rapport-activite`,
  GET_DTV_RAPPORT_ACTIVITES: `${COMMON_URL_PRESFOR}dtv/rapport-by-enquete`,
  GET_CALENDRIER_OUVERTURE_BY_CODE_SP: `${COMMON_URL_PRESFOR}isf/calendrier-ouverture-by-sp`,
  GET_RECUEIL_DONNEES_PERSONNELLES_BY_CODE_SP: `${COMMON_URL_PRESFOR}isf/recueil-donnee-personnel-by-sp`,
  GET_ISF_CEREMONIE_OUVERTURE_BY_CODE_SP: `${COMMON_URL_PRESFOR}ceremonie-ouverture/ceremonie-ouverture-by-sp`,
  GET_ISF_DECLARATION_OUVERTURE_BY_CODE_SP: `${COMMON_URL_PRESFOR}isf/declaration-ouverture-by-sp`,
  PUT_ISF_DECLARATION_OUVERTURE_SP: `${COMMON_URL_PRESFOR}isf/update/declaration-ouverture-by-sp`,
  UPLOAD_PDF_DTV_RAPPORT_ACTIVITES: `${COMMON_URL_PRESFOR}dtv/upload-rapport-activite-pdf`,

  GET_ISF_COURRIER_TRANSMISSION_BY_CODE_SP: `${COMMON_URL_PRESFOR}elaboration-calendrier/courrier-trans-by-sp`,
  PUT_ISF_COURRIER_TRANSMISSION_BY_CODE_SP: `${COMMON_URL_PRESFOR}elaboration-calendrier/update/courrier-trans-by-sp`,
  DELETE_ISF_COURRIER_TRANSMISSION_BY_CODE_SP: `${COMMON_URL_PRESFOR}elaboration-calendrier/delete-courrier-trans`,

  DELETE_ISF_DECLARATION_OUVERTURE_BY_SP: `${COMMON_URL_PRESFOR}isf/delete-declaration-ouverture-by-sp`,
  POST_ISF_DECLARATION_OUVERTURE_SP: `${COMMON_URL_PRESFOR}isf/declaration-ouverture-by-sp`,
  GET_LIVRABLE_ISF_CVGFR_BY_CODE_SP: `${COMMON_URL_PRESFOR}diagnostic/diagnostic-cvgfr-by-sp`,
  POST_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP: `${COMMON_URL_PRESFOR}reunion-periodique/decision-designation-activite-by-sp`,
  PUT_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP: `${COMMON_URL_PRESFOR}reunion-periodique/decision-designation-activite-by-sp`,
  GET_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP: `${COMMON_URL_PRESFOR}reunion-periodique/decision-designation-activite-by-sp`,
  DELETE_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP: `${COMMON_URL_PRESFOR}reunion-periodique/decision-designation-activite-by-sp`,
  UPLOAD_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP: `${COMMON_URL_PRESFOR}reunion-periodique/upload-decision-pdf-sp`,

  GET_ISF_REUNION_PERIODIQUE_BY_CODE_SP: `${COMMON_URL_PRESFOR}reunion-periodique/reunion-periodique-by-sp`,
  DELETE_ISF_REUNION_PERIODIQUE_BY_CODE_SP: `${COMMON_URL_PRESFOR}reunion-periodique/delete-reunion-periodique-by-sp`,
  POST_ISF_REUNION_PERIODIQUE_SP: `${COMMON_URL_PRESFOR}reunion-periodique/resume-resolution-sp`,
  UPDATE_ISF_REUNION_PERIODIQUE_SP: `${COMMON_URL_PRESFOR}reunion-periodique/update-reunion-resolution-sp`,
  UPLOAD_PDF_REUNION_PERIODIQUE_SP: `${COMMON_URL_PRESFOR}reunion-periodique/upload-resume-pdf-sp`,

  UPLOAD_PDF_ISF_DECLARATION_OUVERTURE_SP: `${COMMON_URL_PRESFOR}isf/upload-declaration-ouverture-sp-pdf`,
  GET_ENQUETE_BY_CODE_SP: `${COMMON_URL_PRESFOR}enquete/by-sp`,
  POST_PVCL_WITH_DCF: `${COMMON_URL_PRESFOR}pvcl/new/with-dcf`,
  DELETE_DTV_ALL_RAPPORT_ACTIVITES: `${COMMON_URL_PRESFOR}dtv/all-rapports-activites`,

  GET_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION: `${COMMON_URL_PRESFOR}isf-complementaire/activite`,
  DELETE_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION: `${COMMON_URL_PRESFOR}isf-complementaire/activite`,
  POST_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION: `${COMMON_URL_PRESFOR}isf-complementaire/activite`,
  UPDATE_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION: `${COMMON_URL_PRESFOR}isf-complementaire/activite`,
  UPLOAD_PDF_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION: `${COMMON_URL_PRESFOR}isf-complementaire/upload-activite-pdf`,

  GET_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT: `${COMMON_URL_PRESFOR}isf-complementaire/formation-encadrement`,
  DELETE_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT: `${COMMON_URL_PRESFOR}isf-complementaire/formation-encadrement`,
  POST_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT: `${COMMON_URL_PRESFOR}isf-complementaire/formation-encadrement`,
  UPDATE_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT: `${COMMON_URL_PRESFOR}isf-complementaire/formation-encadrement`,
  UPLOAD_PDF_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT: `${COMMON_URL_PRESFOR}isf-complementaire/upload-formation-encadrement-pdf`,

  GET_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL_PRESFOR}isf-complementaire/facilitation`,
  DELETE_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL_PRESFOR}isf-complementaire/facilitation`,
  POST_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL_PRESFOR}isf-complementaire/facilitation`,
  UPDATE_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL_PRESFOR}isf-complementaire/facilitation`,
  UPLOAD_PDF_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL_PRESFOR}isf-complementaire/upload-facilitation-pdf`,

  GET_DTV_SCAN_DOCUMENT: `${COMMON_URL_PRESFOR}dtv/scan-document`,
  DELETE_DTV_SCAN_DOCUMENT: `${COMMON_URL_PRESFOR}dtv/delete-scan-document`,
  DELETE_DTV_ALL_SCAN_DOCUMENT: `${COMMON_URL_PRESFOR}dtv/delete-all-documents`,
  POST_DTV_SCAN_DOCUMENT: `${COMMON_URL_PRESFOR}dtv/upload-dtv-scan-fichiers`,
  UPDATE_DTV_SCAN_DOCUMENT: `${COMMON_URL_PRESFOR}dtv/update-dtv-scan-fichiers`,

  GET_TOTAL_DCF_LP: `${COMMON_URL_PRESFOR}registre-intention/dcf/lp/total`,
  VILLAGE_BY_SP: `${COMMON_URL_PRESFOR}codification/village-by-sp`,
  ENQUETE_BY_SP: `${COMMON_URL_PRESFOR}codification/enquetes-by-sp`,
  GET_TOTAL_DCF_LP_MONTH: `${COMMON_URL_PRESFOR}registre-intention/dcf-lp/stats/monthly`,

  GET_TOTAL_DCF_LP_USER: `${COMMON_URL_PRESFOR}registre-intention/dcf-lp/stats/by-user`,

  POST_REJECT_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/reject-dcf`,
  POST_VALIDATE_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/validate-dcf`,

  POST_REJECT_ID: `${COMMON_URL_PRESFOR}certificat-foncier/reject-fiche-id`,
  POST_VALIDATE_ID: `${COMMON_URL_PRESFOR}certificat-foncier/validate-fiche-id`,

  POST_REJECT_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/reject-pvrdc`,
  POST_VALIDATE_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/validate-pvrdc`,

  POST_REJECT_CECPDC: `${COMMON_URL_PRESFOR}constat/reject-cecpdc`,
  POST_VALIDATE_CECPDC: `${COMMON_URL_PRESFOR}constat/validate-cecpdc`,

  POST_REJECT_VALID: `${COMMON_URL_PRESFOR}constat/reject-valid`,
  POST_VALIDATE_VALID: `${COMMON_URL_PRESFOR}constat/validate-valid`,
  POST_VALID_BY_ANNONCE: `${COMMON_URL_PRESFOR}constat/valid-by-annonce`,
  GET_VALID_BY_ANNONCE: `${COMMON_URL_PRESFOR}constat/valid-by-annonce`,

  POST_REJECT_CLP: `${COMMON_URL_PRESFOR}clp/reject-clp`,
  POST_VALIDATE_CLP: `${COMMON_URL_PRESFOR}clp/validate-clp`,

  POST_REJECT_PVCL: `${COMMON_URL_PRESFOR}pvcl/reject-pvcl`,
  POST_VALIDATE_PVCL: `${COMMON_URL_PRESFOR}pvcl/validate-pvcl`,

  POST_REJECT_ANP: `${COMMON_URL_PRESFOR}certificat-foncier/reject-anp`,
  POST_VALIDATE_ANP: `${COMMON_URL_PRESFOR}certificat-foncier/validate-anp`,

  POST_REJECT_ANPO: `${COMMON_URL_PRESFOR}certificat-foncier/reject-anpo`,
  POST_VALIDATE_ANPO: `${COMMON_URL_PRESFOR}certificat-foncier/validate-anpo`,

  POST_REJECT_ANPC: `${COMMON_URL_PRESFOR}certificat-foncier/reject-anpc`,
  POST_VALIDATE_ANPC: `${COMMON_URL_PRESFOR}certificat-foncier/validate-anpc`,

  POST_VALIDATE_CALENDRIER_OUVERTURES: `${COMMON_URL_PRESFOR}isf/validate-cco`,
  POST_REJECT_CALENDRIER_OUVERTURES: `${COMMON_URL_PRESFOR}isf/reject-cco`,

  POST_VALIDATE_COMPTE_RENDU_PRISE_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/validate-cr`,
  POST_REJECT_COMPTE_RENDU_PRISE_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/reject-cr`,

  POST_VALIDATE_PRISE_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/validate-prise-contact`,
  POST_REJECT_PRISE_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/reject-prise-contact`,

  POST_VALIDATE_RECUEIL_DONNEE: `${COMMON_URL_PRESFOR}isf/validate-recueil-donnee`,
  POST_REJECT_RECUEIL_DONNEE: `${COMMON_URL_PRESFOR}isf/reject-recueil-donnee`,

  POST_VALIDATE_DECLARATION_OUVERTURE: `${COMMON_URL_PRESFOR}isf/validate-declaration`,
  POST_REJECT_DECLARATION_OUVERTURE: `${COMMON_URL_PRESFOR}isf/reject-declaration`,

  POST_VALIDATE_CEREMONIE_OUVERTURE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/validate-ceremonie`,
  POST_REJECT_CEREMONIE_OUVERTURE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/reject-ceremonie`,

  POST_VALIDATE_COMPTE_RENDU: `${COMMON_URL_PRESFOR}ceremonie-ouverture/validate-compte-rendu`,
  POST_REJECT_COMPTE_RENDU: `${COMMON_URL_PRESFOR}ceremonie-ouverture/reject-compte-rendu`,

  POST_VALIDATE_RAPPORT_VILLAGE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/validate-rapport`,
  POST_REJECT_RAPPORT_VILLAGE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/reject-rapport`,

  POST_VALIDATE_CALENDRIER: `${COMMON_URL_PRESFOR}elaboration-calendrier/validate-calendrier`,
  POST_REJECT_CALENDRIER: `${COMMON_URL_PRESFOR}elaboration-calendrier/reject-calendrier`,

  POST_VALIDATE_COURRIER: `${COMMON_URL_PRESFOR}elaboration-calendrier/validate-courrier`,
  POST_REJECT_COURRIER: `${COMMON_URL_PRESFOR}elaboration-calendrier/reject-courrier`,

  POST_VALIDATE_INFORMATION_SENSIBILISATION: `${COMMON_URL_PRESFOR}information-sensibilisation/validate-is`,
  POST_REJECT_INFORMATION_SENSIBILISATION: `${COMMON_URL_PRESFOR}information-sensibilisation/reject-is`,

  POST_VALIDATE_RAPPORT_ISF: `${COMMON_URL_PRESFOR}information-sensibilisation/validate-rapport-isf`,
  POST_REJECT_RAPPORT_ISF: `${COMMON_URL_PRESFOR}information-sensibilisation/reject-rapport-isf`,

  POST_VALIDATE_REGISTRE_DCF: `${COMMON_URL_PRESFOR}registre-intention/validate-dcf`,
  POST_REJECT_REGISTRE_DCF: `${COMMON_URL_PRESFOR}registre-intention/reject-dcf`,

  POST_VALIDATE_REGISTRE_DCC: `${COMMON_URL_PRESFOR}registre-intention/validate-dcc`,
  POST_REJECT_REGISTRE_DCC: `${COMMON_URL_PRESFOR}registre-intention/reject-dcc`,

  POST_VALIDATE_CONSTITUTION_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/validate-consitution-cvgfr`,
  POST_REJECT_CONSTITUTION_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/reject-consitution-cvgfr`,

  POST_VALIDATE_CREATION_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/validate-creation-cvgfr`,
  POST_REJECT_CREATION_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/reject-creation-cvgfr`,

  POST_VALIDATE_DIAGNOSTIC_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/validate-diagnostic-cvgfr`,
  POST_REJECT_DIAGNOSTIC_CVGFR: `${COMMON_URL_PRESFOR}diagnostic/reject-diagnostic-cvgfr`,

  POST_VALIDATE_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/validate-formation-cvgfr`,
  POST_REJECT_FORMATION_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/reject-formation-cvgfr`,

  POST_VALIDATE_FORMATION_LP_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/validate-formation-lp-cvgfr`,
  POST_REJECT_FORMATION_LP_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/reject-formation-lp-cvgfr`,

  POST_VALIDATE_REGLEMENT_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/validate-reglement-cvgfr`,
  POST_REJECT_REGLEMENT_CVGFR: `${COMMON_URL_PRESFOR}formation-cvgfr/reject-reglement-cvgfr`,

  POST_VALIDATE_DECISION: `${COMMON_URL_PRESFOR}reunion-periodique/validate-decision`,
  POST_REJECT_DECISION: `${COMMON_URL_PRESFOR}reunion-periodique/reject-decision`,

  POST_VALIDATE_RESUME: `${COMMON_URL_PRESFOR}reunion-periodique/validate-resume`,
  POST_REJECT_RESUME: `${COMMON_URL_PRESFOR}reunion-periodique/reject-resume`,

  POST_VALIDATE_CALENDRIER_PREVISIONNEL: `${COMMON_URL_PRESFOR}dialogue-social/validate-calendrier-activite`,
  POST_REJECT_CALENDRIER_PREVISIONNEL: `${COMMON_URL_PRESFOR}dialogue-social/reject-calendrier-activite`,

  POST_VALIDATE_GUIDE_ENTRETIEN: `${COMMON_URL_PRESFOR}dialogue-social/validate-guide`,
  POST_REJECT_GUIDE_ENTRETIEN: `${COMMON_URL_PRESFOR}dialogue-social/reject-guide`,

  POST_VALIDATE_CHARTE: `${COMMON_URL_PRESFOR}dialogue-social/validate-charte`,
  POST_REJECT_CHARTE: `${COMMON_URL_PRESFOR}dialogue-social/reject-charte`,

  POST_VALIDATE_GESTION_FONCIERE: `${COMMON_URL_PRESFOR}dialogue-social/validate-protocole`,
  POST_REJECT_GESTION_FONCIERE: `${COMMON_URL_PRESFOR}dialogue-social/reject-protocole`,

  POST_VALIDATE_PROCES_VERBAL: `${COMMON_URL_PRESFOR}dialogue-social/validate-proces`,
  POST_REJECT_PROCES_VERBAL: `${COMMON_URL_PRESFOR}dialogue-social/reject-proces`,

  POST_VALIDATE_PROCES_VERBAL_REGLEMENT: `${COMMON_URL_PRESFOR}dialogue-social/validate-proces-litige`,
  POST_REJECT_PROCES_VERBAL_REGLEMENT: `${COMMON_URL_PRESFOR}dialogue-social/reject-proces-litige`,

  POST_VALIDATE_PROCES_VERBAL_CLARIFICATION: `${COMMON_URL_PRESFOR}dialogue-social/validate-proces-clarification`,
  POST_REJECT_PROCES_VERBAL_CLARIFICATION: `${COMMON_URL_PRESFOR}dialogue-social/reject-proces-clarification`,

  POST_VALIDATE_RAPPORT: `${COMMON_URL_PRESFOR}rapport/validate-rapport`,
  POST_REJECT_RAPPORT: `${COMMON_URL_PRESFOR}rapport/reject-rapport`,

  POST_VALIDATE_ACTIVITE: `${COMMON_URL_PRESFOR}isf-complementaire/validate-activite`,
  POST_REJECT_ACTIVITE: `${COMMON_URL_PRESFOR}isf-complementaire/reject-activite`,

  POST_VALIDATE_FACILITATION: `${COMMON_URL_PRESFOR}isf-complementaire/validate-facilitation`,
  POST_REJECT_FACILITATION: `${COMMON_URL_PRESFOR}isf-complementaire/reject-facilitation`,

  POST_VALIDATE_FORMATION: `${COMMON_URL_PRESFOR}isf-complementaire/validate-formation`,
  POST_REJECT_FORMATION: `${COMMON_URL_PRESFOR}isf-complementaire/reject-formation`,

  POST_VALIDATE_DEMANDE_IDENTITE: `${COMMON_URL_PRESFOR}activites-dialogue-social/validate-demande`,
  POST_REJECT_DEMANDE_IDENTITE: `${COMMON_URL_PRESFOR}activites-dialogue-social/reject-demande`,

  POST_VALIDATE_DTV_HISTO: `${COMMON_URL_PRESFOR}dtv/validate-dtv-histo`,
  POST_REJECT_DTV_HISTO: `${COMMON_URL_PRESFOR}dtv/reject-dtv-histo`,

  POST_VALIDATE_DTV_ANP: `${COMMON_URL_PRESFOR}dtv/validate-dtv-anp`,
  POST_REJECT_DTV_ANP: `${COMMON_URL_PRESFOR}dtv/reject-dtv-anp`,

  POST_VALIDATE_DTV_ANPO: `${COMMON_URL_PRESFOR}dtv/validate-dtv-anpo`,
  POST_REJECT_DTV_ANPO: `${COMMON_URL_PRESFOR}dtv/reject-dtv-anpo`,

  POST_VALIDATE_DTV_ANPC: `${COMMON_URL_PRESFOR}dtv/validate-dtv-anpc`,
  POST_REJECT_DTV_ANPC: `${COMMON_URL_PRESFOR}dtv/reject-dtv-anpc`,

  POST_VALIDATE_DTV_ATTESTION_VALIDATION: `${COMMON_URL_PRESFOR}dtv/validate-dtv-attestation-validation`,
  POST_REJECT_DTV_ATTESTION_VALIDATION: `${COMMON_URL_PRESFOR}dtv/reject-dtv-attestation-validation`,

  POST_VALIDATE_DTV_ATTESTION_APPROBATION: `${COMMON_URL_PRESFOR}dtv/validate-dtv-attestation-approbation`,
  POST_REJECT_DTV_ATTESTION_APPROBATION: `${COMMON_URL_PRESFOR}dtv/reject-dtv-attestation-approbation`,

  POST_VALIDATE_DTV_TRONCON_LIMITE: `${COMMON_URL_PRESFOR}dtv/validate-dtv-troncon-limite`,
  POST_REJECT_DTV_TRONCON_LIMITE: `${COMMON_URL_PRESFOR}dtv/reject-dtv-troncon-limite`,

  POST_VALIDATE_DTV_RAPPORT_ACTIVITES: `${COMMON_URL_PRESFOR}dtv/validate-dtv-rapport-activite`,
  POST_REJECT_DTV_RAPPORT_ACTIVITES: `${COMMON_URL_PRESFOR}dtv/reject-dtv-rapport-activite`,

  POST_VALIDATE_DTV_SCAN_DOCUEMENT: `${COMMON_URL_PRESFOR}dtv/validate-dtv-scan-document`,
  POST_REJECT_DTV_SCAN_DOCUEMENT: `${COMMON_URL_PRESFOR}dtv/reject-dtv-scan-document`,

  POST_VALIDATE_CONTRAT: `${COMMON_URL_PRESFOR}contrat/validate-contrat`,
  POST_REJECT_CONTRAT: `${COMMON_URL_PRESFOR}contrat/reject-contrat`,

  POST_LISTE_PRESENCE_RECUEIL: `${COMMON_URL_PRESFOR}isf/liste-presence-receuil`,
  PUT_LISTE_PRESENCE_RECUEIL: `${COMMON_URL_PRESFOR}isf/liste-presence-receuil`,
  GET_LISTE_PRESENCE_RECUEIL: `${COMMON_URL_PRESFOR}isf/liste-presence-receuil`,
  DELETE_LISTE_PRESENCE_RECUEIL: `${COMMON_URL_PRESFOR}isf/delete-liste-presence-recueil`,
  VALIDATE_LISTE_PRESENCE_RECUEIL: `${COMMON_URL_PRESFOR}isf/validate-liste-presence-recueil`,
  REJECT_LISTE_PRESENCE_RECUEIL: `${COMMON_URL_PRESFOR}isf/reject-liste-presence-recueil`,
  UPLOAD_LISTE_PRESENCE_RECUEIL: `${COMMON_URL_PRESFOR}isf/upload-liste-presence-recueil-pdf`,

  GENERATE_ANNEXE_LIVRABLE: `${COMMON_URL_PRESFOR}isf/annexe-liste-presence-receuil`,

  POST_VALIDATE_RAPPORT_OSF: `${COMMON_URL_PRESFOR}rapport/validate-rapport-os`,
  POST_REJECT_RAPPORT_OSF: `${COMMON_URL_PRESFOR}rapport/reject-rapport-os`,
  GET_ISF_PREALABLE_STATS: `${COMMON_URL_PRESFOR}enquete/opening-stats`,
  GET_ISF_COMPLEMENTAIRE_STATS: `${COMMON_URL_PRESFOR}enquete/opening-stats/isf-complementaire`,
  GET_ISF_DTV_STATS: `${COMMON_URL_PRESFOR}enquete/opening-stats/dtv`,
  GET_ISF_DCF_STATS: `${COMMON_URL_PRESFOR}enquete/opening-stats/dcf`,
  GET_ISF_TRANSMISSION_STATS: `${COMMON_URL_PRESFOR}isf/transmission-stats`,
  GET_ISF_PREALABLE_VALIDATE: `${COMMON_URL_PRESFOR}enquete/validate-stats/isf`,
  GET_DCF_VALIDATE: `${COMMON_URL_PRESFOR}enquete/validate-stats/dcf`,

  GET_SUPERFICIE_ENQ: `${COMMON_URL_PRESFOR}certificat-foncier/get-total-superficie-dcf`,
  GET_CE_DTV: `${COMMON_URL_PRESFOR}user/ce/dtv`,
  GET_CE_DCF: `${COMMON_URL_PRESFOR}user/ce/cf`,
  GET_CE_PVCL: `${COMMON_URL_PRESFOR}user/ce/pvcl`,

  GET_PV_BY_ENQ: `${COMMON_URL_PRESFOR}certificat-foncier/dcf-pv-byenquete`,
  POST_VALIDATE_COMPTE_RENDU_PRISE_CONTACT_SP: `${COMMON_URL_PRESFOR}prise-contact/validate-compte-rendu-by-sp`,
  POST_REJECT_COMPTE_RENDU_PRISE_CONTACT_SP: `${COMMON_URL_PRESFOR}prise-contact/reject-compte-rendu-by-sp`,
  GET_LISTE_PRESENCE_CONTACT_SP: `${COMMON_URL_PRESFOR}prise-contact/prise-contact-by-sp`,

  ADD_QUESTIONNAIRE_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/add/question`,
  UPDATE_QUESTIONNAIRE_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/update/question`,
  POST_LISTE_PRESENCE_CONTACT_SP: `${COMMON_URL_PRESFOR}prise-contact/prise-contact-by-sp`,
  PUT_LISTE_PRESENCE_CONTACT_SP: `${COMMON_URL_PRESFOR}prise-contact/prise-contact-by-sp`,
  DELETE_LISTE_PRESENCE_CONTACT_SP: `${COMMON_URL_PRESFOR}prise-contact/delete-prise-contact-by-sp`,
  POST_VALIDATE_LISTE_PRESENCE_CONTACT_SP: `${COMMON_URL_PRESFOR}prise-contact/validate-compte-rendu-lp-by-sp`,
  POST_REJECT_LISTE_PRESENCE_CONTACT_SP: `${COMMON_URL_PRESFOR}prise-contact/reject-compte-rendu-lp-by-sp`,

  GET_ISF_CONTRAT_STATS: `${COMMON_URL_PRESFOR}enquete/opening-stats/contrat`,
  IMPORT_DCF_EXCEL_FILE: `${COMMON_URL_PRESFOR}certificat-foncier/import-equipe-topo-excel`,
  EXPORT_CONTRATS: `${COMMON_URL_PRESFOR}contrat/export-contrats`,
  GET_HISTORY_IMPORT_LIVRABLE: `${COMMON_URL_PRESFOR}certificat-foncier/history-import-livrable`,
  DOWNLOAD_FILE: `${COMMON_URL_PRESFOR}certificat-foncier/download-file`,
  GET_PVRDC_ANNEXE01: `${COMMON_URL_PRESFOR}certificat-foncier/pvrdc/groupe-annexe-01`,
  GET_PVRDC_ANNEXE1: `${COMMON_URL_PRESFOR}certificat-foncier/pvrdc/groupe-annexe-1`,
  GET_PVRDC_ANNEXE2: `${COMMON_URL_PRESFOR}certificat-foncier/pvrdc/groupe-annexe-2`,
  GET_PVRDC_ANNEXE3: `${COMMON_URL_PRESFOR}certificat-foncier/pvrdc/groupe-annexe-3`,
  GET_PVRDC_ANNEXE4: `${COMMON_URL_PRESFOR}certificat-foncier/pvrdc/groupe-annexe-4`,
  GET_PVRDC_ANNEXE5: `${COMMON_URL_PRESFOR}certificat-foncier/pvrdc/groupe-annexe-5`,
  GET_PVRDC_ANNEXE6: `${COMMON_URL_PRESFOR}certificat-foncier/pvrdc/groupe-annexe-6`,

  EXPORT_CONTRAT_PDF: `${COMMON_URL_PRESFOR}contrat/contrats`,

  EXPORT_SUPERFICIES_XLSX: `${COMMON_URL_PRESFOR}user/ce/export/superficies/xlsx`,

  DELETE_PVRDC_QUESTIONAIRE: `${COMMON_URL_PRESFOR}pvrdc/delete/question`,

  GET_LISTE_CF_BY_ENQ: `${COMMON_URL_PRESFOR}certificat-foncier/list-dcfs-by-enquete`,
  GET_SINGLE_DCF_WITH_PVRDC: `${COMMON_URL_PRESFOR}certificat-foncier/minimize-dcf`,
  GET_DCF_CONSTAT_LIMITE: `${COMMON_URL_PRESFOR}certificat-foncier/minimize-constat-limite`,
  GET_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/dcf`,

  // Filtered APIs by enquete with status
  GET_FILTERED_CF_BY_ENQUETE: `${COMMON_URL_PRESFOR}certificat-foncier/filtered-by-enquete`,
  GET_FILTERED_PVRDC_BY_ENQUETE: `${COMMON_URL_PRESFOR}pvrdc/filtered-by-enquete`,
  GET_FILTERED_PVCL_BY_ENQUETE: `${COMMON_URL_PRESFOR}pvcl/filtered-by-enquete`,
  GET_PVRDC_MEMEBRE_EQUIPE_ENQUETE: `${COMMON_URL_PRESFOR}pvrdc/equipe-enquete`,
  GET_PVRDC_FICHE_DEMOGRAPHIQUE: `${COMMON_URL_PRESFOR}pvrdc/fiche-demographique`,
  GET_PVRDC_DECLARATIONS: `${COMMON_URL_PRESFOR}pvrdc/declarations-auditionnee`,
  GET_PVRDC_OCCUPANTS_PARCELLE: `${COMMON_URL_PRESFOR}pvrdc/occupant-parcelle`,
  GET_PVRDC_LISTE_DETENTEURS_DROITS: `${COMMON_URL_PRESFOR}pvrdc/listeddcc`,
  GET_PVRDC_LISTE_ETATS_DROITS: `${COMMON_URL_PRESFOR}pvrdc/etatdroits`,
  GET_PVRDC_DESIGNATION_GESTIONNAIRE: `${COMMON_URL_PRESFOR}pvrdc/gbfc`,
  GET_PVRDC_LISTE_SERVITUDE: `${COMMON_URL_PRESFOR}pvrdc/listeservitude`,

  GET_DEMANDEUR_BY_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/demandeur-by-dcf`,

  GET_FICHE_LITIGE_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/fiche-litige`,
  GET_PVRDC_CREATED: `${COMMON_URL_PRESFOR}pvrdc/equipe-enquete/type-pvrdc`,
  GET_MINIMIZE_PVCL: `${COMMON_URL_PRESFOR}pvcl/minimize-pvcl`,
  GET_ONE_PVCL: `${COMMON_URL_PRESFOR}pvcl`,
  GET_ONE_SINGLE_PVCL: `${COMMON_URL_PRESFOR}pvcl/single-pvcl`,
  GET_PVRDC_ETATS_DROITS: `${COMMON_URL_PRESFOR}pvrdc/etat-droits`,
  GET_PVRDC_DETENTEURS_DROITS: `${COMMON_URL_PRESFOR}pvrdc/listeddcc-pvrdc`,

  GET_MINIMIZE_LISTE_CF_BY_ENQ: `${COMMON_URL_PRESFOR}certificat-foncier/minimize-dcfs-by-enquete`,
  GET_PVRDC_DESIGNATION_GBFC: `${COMMON_URL_PRESFOR}pvrdc/designation-gbfc`,

  GET_PVRDC_QUESTIONNAIRE: `${COMMON_URL_PRESFOR}pvrdc/questionnaire`,
  GET_FICHE_IDENTIFICATION: `${COMMON_URL_PRESFOR}certificat-foncier/fiche-identification`,
  GET_MINIMIZE_FICHE_ID: `${COMMON_URL_PRESFOR}certificat-foncier/minimize-fiche-id`,

  GET_MINIMIZE_CF_BY_ENQ: `${COMMON_URL_PRESFOR}certificat-foncier/minimize-by-enquete`,
  POST_REGENERATE_PVRDC_PDF: `${COMMON_URL_PRESFOR}pvrdc/regenerate-pvrdc-pdf`,
  REGENERATE_QUESTIONNAIRE_PDF: `${COMMON_URL_PRESFOR}pvrdc/regenerate-questionnaire-pdf`,

  POST_COT_REJECT_ID: `${COMMON_URL_PRESFOR}certificat-foncier/cot-reject-id`,
  POST_COT_VALIDATE_ID: `${COMMON_URL_PRESFOR}certificat-foncier/cot-approuve-id`,
  POST_COT_VALIDATE_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/cot-approuve-dcf`,
  POST_COT_REJECT_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/cot-reject-dcf`,

  POST_COT_REJECT_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/cot-reject-pvrdc`,
  POST_COT_VALIDATE_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/cot-approuve-pvrdc`,

  POST_COT_REJECT_CLP: `${COMMON_URL_PRESFOR}clp/cot-reject-clp`,
  POST_COT_VALIDATE_CLP: `${COMMON_URL_PRESFOR}clp/cot-approuve-clp`,

  POST_COT_REJECT_PVCL: `${COMMON_URL_PRESFOR}pvcl/cot-reject-pvcl`,
  POST_COT_VALIDATE_PVCL: `${COMMON_URL_PRESFOR}pvcl/cot-approuve-pvcl`,

  POST_COT_REJECT_CECPDC: `${COMMON_URL_PRESFOR}constat/cot-reject-cecpdc`,
  POST_COT_VALIDATE_CECPDC: `${COMMON_URL_PRESFOR}constat/cot-approuve-cecpdc`,

  POST_COT_REJECT_VALID: `${COMMON_URL_PRESFOR}constat/cot-reject-valid`,
  POST_COT_VALIDATE_VALID: `${COMMON_URL_PRESFOR}constat/cot-approuve-valid`,

  POST_COT_REJECT_DTV_HISTO: `${COMMON_URL_PRESFOR}dtv/cot-reject-histo`,
  POST_COT_VALIDATE_DTV_HISTO: `${COMMON_URL_PRESFOR}dtv/cot-approuve-histo`,

  // ANP: PROCES VERBAL D'ANNONCE DE PUBLICITE
  POST_COT_VALIDATE_DTV_ANP: `${COMMON_URL_PRESFOR}dtv/cot-approuve-anp`,
  POST_COT_REJECT_DTV_ANP: `${COMMON_URL_PRESFOR}dtv/cot-reject-anp`,

  // ANPO: PROCES VERBAL D'OUVERTURE DE PUBLICITE
  POST_COT_VALIDATE_DTV_ANPO: `${COMMON_URL_PRESFOR}dtv/cot-approuve-anpo`,
  POST_COT_REJECT_DTV_ANPO: `${COMMON_URL_PRESFOR}dtv/cot-reject-anpo`,

  // ANPC: PROCES VERBAL DE CLOTURE DE PUBLICITE
  POST_COT_VALIDATE_DTV_ANPC: `${COMMON_URL_PRESFOR}dtv/cot-approuve-anpc`,
  POST_COT_REJECT_DTV_ANPC: `${COMMON_URL_PRESFOR}dtv/cot-reject-anpc`,

  // APPROBATION: ATTESTATION D'APPROBATION
  POST_COT_VALIDATE_DTV_APPROBATION: `${COMMON_URL_PRESFOR}dtv/cot-approuve-approbation`,
  POST_COT_REJECT_DTV_APPROBATION: `${COMMON_URL_PRESFOR}dtv/cot-reject-approbation`,

  // VALIDATION: ATTESTATION DE VALIDATION
  POST_COT_VALIDATE_DTV_VALIDATION: `${COMMON_URL_PRESFOR}dtv/cot-approuve-validation`,
  POST_COT_REJECT_DTV_VALIDATION: `${COMMON_URL_PRESFOR}dtv/cot-reject-validation`,

  //validation cot isf
  POST_COT_VALIDATE_ISF_COMPTE_RENDU: `${COMMON_URL_PRESFOR}prise-contact/cot-approuve-cr`,
  POST_COT_REJECT_ISF_COMPTE_RENDU: `${COMMON_URL_PRESFOR}prise-contact/cot-reject-cr`,

  POST_COT_VALIDATE_PC: `${COMMON_URL_PRESFOR}prise-contact/cot-approuve-pc`,
  POST_COT_REJECT_PC: `${COMMON_URL_PRESFOR}prise-contact/cot-reject-pc`,

  POST_COT_VALIDATE_CCO: `${COMMON_URL_PRESFOR}isf/cot-approuve-cco`,
  POST_COT_REJECT_CCO: `${COMMON_URL_PRESFOR}isf/cot-reject-cco`,

  POST_COT_VALIDATE_RECUEIL: `${COMMON_URL_PRESFOR}isf/cot-approuve-recueil`,
  POST_COT_REJECT_RECUEIL: `${COMMON_URL_PRESFOR}isf/cot-reject-recueil`,

  POST_COT_VALIDATE_LISTE_PRESENCE_RECUEIL: `${COMMON_URL_PRESFOR}isf/cot-approuve-liste-presence-recueil`,
  POST_COT_REJECT_LISTE_PRESENCE_RECUEIL: `${COMMON_URL_PRESFOR}isf/cot-reject-liste-presence-recueil`,

  POST_COT_VALIDATE_DECLARATION: `${COMMON_URL_PRESFOR}isf/cot-approuve-declaration`,
  POST_COT_REJECT_DECLARATION: `${COMMON_URL_PRESFOR}isf/cot-reject-declaration`,

  POST_COT_VALIDATE_DEMANDE: `${COMMON_URL_PRESFOR}activitedialoguesocial/cot-approuve-demande`,
  POST_COT_REJECT_DEMANDE: `${COMMON_URL_PRESFOR}activitedialoguesocial/cot-reject-demande`,

  POST_COT_VALIDATE_CEREMONIE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cot-approuve-ceremonie`,
  POST_COT_REJECT_CEREMONIE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cot-reject-ceremonie`,

  POST_COT_VALIDATE_COMPTE_RENDU: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cot-approuve-compte-rendu`,
  POST_COT_REJECT_COMPTE_RENDU: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cot-reject-compte-rendu`,

  POST_COT_VALIDATE_RAPPORT_VILLAGE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cot-approuve-rapport-village`,
  POST_COT_REJECT_RAPPORT_VILLAGE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cot-reject-rapport-village`,

  POST_COT_VALIDATE_DECISION_CREATION: `${COMMON_URL_PRESFOR}diagnostic/cot-approuve-decision-creation`,
  POST_COT_REJECT_DECISION_CREATION: `${COMMON_URL_PRESFOR}diagnostic/cot-reject-decision-creation`,

  POST_COT_VALIDATE_PV_CONSTITUTION: `${COMMON_URL_PRESFOR}diagnostic/cot-approuve-pv-constitution`,
  POST_COT_REJECT_PV_CONSTITUTION: `${COMMON_URL_PRESFOR}diagnostic/cot-reject-pv-constitution`,

  POST_COT_VALIDATE_DIAGNOSTIC: `${COMMON_URL_PRESFOR}diagnostic/cot-approuve-diagnostic`,
  POST_COT_REJECT_DIAGNOSTIC: `${COMMON_URL_PRESFOR}diagnostic/cot-reject-diagnostic`,

  POST_COT_VALIDATE_CALENDRIER: `${COMMON_URL_PRESFOR}dialogue-social/cot-approuve-calendrier`,
  POST_COT_REJECT_CALENDRIER: `${COMMON_URL_PRESFOR}dialogue-social/cot-reject-calendrier`,

  POST_COT_VALIDATE_GUIDE: `${COMMON_URL_PRESFOR}dialogue-social/cot-approuve-guide`,
  POST_COT_REJECT_GUIDE: `${COMMON_URL_PRESFOR}dialogue-social/cot-reject-guide`,

  POST_COT_VALIDATE_PROTOCOLE: `${COMMON_URL_PRESFOR}dialogue-social/cot-approuve-protocole`,
  POST_COT_REJECT_PROTOCOLE: `${COMMON_URL_PRESFOR}dialogue-social/cot-reject-protocole`,
  POST_COT_VALIDATE_PROTOCOLE: `${COMMON_URL_PRESFOR}dialogue-social/cot-approuve-protocole`,
  POST_COT_REJECT_PROTOCOLE: `${COMMON_URL_PRESFOR}dialogue-social/cot-reject-protocole`,

  POST_COT_VALIDATE_PVCA: `${COMMON_URL_PRESFOR}dialogue-social/cot-approuve-pvca`,
  POST_COT_REJECT_PVCA: `${COMMON_URL_PRESFOR}dialogue-social/cot-reject-pvca`,
  POST_COT_VALIDATE_PVCA: `${COMMON_URL_PRESFOR}dialogue-social/cot-approuve-pvca`,
  POST_COT_REJECT_PVCA: `${COMMON_URL_PRESFOR}dialogue-social/cot-reject-pvca`,

  POST_COT_VALIDATE_PVCFI: `${COMMON_URL_PRESFOR}dialogue-social/cot-approuve-pvcfi`,
  POST_COT_REJECT_PVCFI: `${COMMON_URL_PRESFOR}dialogue-social/cot-reject-pvcfi`,
  POST_COT_VALIDATE_PVCFI: `${COMMON_URL_PRESFOR}dialogue-social/cot-approuve-pvcfi`,
  POST_COT_REJECT_PVCFI: `${COMMON_URL_PRESFOR}dialogue-social/cot-reject-pvcfi`,

  POST_COT_VALIDATE_PVRLF: `${COMMON_URL_PRESFOR}dialogue-social/cot-approuve-pvrlf`,
  POST_COT_REJECT_PVRLF: `${COMMON_URL_PRESFOR}dialogue-social/cot-reject-pvrlf`,
  POST_COT_VALIDATE_PVRLF: `${COMMON_URL_PRESFOR}dialogue-social/cot-approuve-pvrlf`,
  POST_COT_REJECT_PVRLF: `${COMMON_URL_PRESFOR}dialogue-social/cot-reject-pvrlf`,

  POST_COT_VALIDATE_COURRIER: `${COMMON_URL_PRESFOR}elaboration-calendrier/cot-approuve-courrier`,
  POST_COT_REJECT_COURRIER: `${COMMON_URL_PRESFOR}elaboration-calendrier/cot-reject-courrier`,

  POST_COT_VALIDATE_REGLEMENT: `${COMMON_URL_PRESFOR}formation-cvgfr/cot-approuve-reglement`,
  POST_COT_REJECT_REGLEMENT: `${COMMON_URL_PRESFOR}formation-cvgfr/cot-reject-reglement`,

  POST_COT_VALIDATE_ATTESTATION_FORMATION: `${COMMON_URL_PRESFOR}formation-cvgfr/cot-approuve-attestation-formation`,
  POST_COT_REJECT_ATTESTATION_FORMATION: `${COMMON_URL_PRESFOR}formation-cvgfr/cot-reject-attestation-formation`,

  POST_COT_VALIDATE_LISTE_PRESENCE: `${COMMON_URL_PRESFOR}formation-cvgfr/cot-approuve-liste-presence`,
  POST_COT_REJECT_LISTE_PRESENCE: `${COMMON_URL_PRESFOR}formation-cvgfr/cot-reject-liste-presence`,

  POST_COT_VALIDATE_IS: `${COMMON_URL_PRESFOR}information-sensibilisation/cot-approuve-is`,
  POST_COT_REJECT_IS: `${COMMON_URL_PRESFOR}information-sensibilisation/cot-reject-is`,

  POST_COT_VALIDATE_RAPPORT_ISF: `${COMMON_URL_PRESFOR}information-sensibilisation/cot-approuve-rapport-isf`,
  POST_COT_REJECT_RAPPORT_ISF: `${COMMON_URL_PRESFOR}information-sensibilisation/cot-reject-rapport-isf`,

  POST_COT_VALIDATE_RAPPORT_ACTIVITE: `${COMMON_URL_PRESFOR}rapport/cot-approuve-rapport-activite`,
  POST_COT_REJECT_RAPPORT_ACTIVITE: `${COMMON_URL_PRESFOR}rapport/cot-reject-rapport-activite`,

  POST_COT_VALIDATE_RAPPORT_OSF: `${COMMON_URL_PRESFOR}rapport/cot-approuve-rapport-osf`,
  POST_COT_REJECT_RAPPORT_OSF: `${COMMON_URL_PRESFOR}rapport/cot-reject-rapport-osf`,

  POST_COT_VALIDATE_ISF_DCF: `${COMMON_URL_PRESFOR}registre-intention/cot-approuve-dcf`,
  POST_COT_REJECT_ISF_DCF: `${COMMON_URL_PRESFOR}registre-intention/cot-reject-dcf`,

  POST_COT_VALIDATE_DCC: `${COMMON_URL_PRESFOR}registre-intention/cot-approuve-dcc`,
  POST_COT_REJECT_DCC: `${COMMON_URL_PRESFOR}registre-intention/cot-reject-dcc`,

  POST_COT_VALIDATE_DECISION: `${COMMON_URL_PRESFOR}reunion-periodique/cot-approuve-decision`,
  POST_COT_REJECT_DECISION: `${COMMON_URL_PRESFOR}reunion-periodique/cot-reject-decision`,

  POST_COT_VALIDATE_RESUME: `${COMMON_URL_PRESFOR}reunion-periodique/cot-approve-resume`,
  POST_COT_REJECT_RESUME: `${COMMON_URL_PRESFOR}reunion-periodique/cot-reject-resume`,

  // ISF COMPLEMENTAIRE COT VALIDATION
  POST_COT_VALIDATE_ISF_COMPLEMENTAIRE_ACTIVITE: `${COMMON_URL_PRESFOR}isf-complementaire/cot-approve-activite`,
  POST_COT_REJECT_ISF_COMPLEMENTAIRE_ACTIVITE: `${COMMON_URL_PRESFOR}isf-complementaire/cot-reject-activite`,
  POST_COT_VALIDATE_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL_PRESFOR}isf-complementaire/cot-approve-facilitation`,
  POST_COT_REJECT_ISF_COMPLEMENTAIRE_FACILITATION: `${COMMON_URL_PRESFOR}isf-complementaire/cot-reject-facilitation`,
  POST_COT_VALIDATE_ISF_COMPLEMENTAIRE_FORMATION: `${COMMON_URL_PRESFOR}isf-complementaire/cot-approve-formation`,
  POST_COT_REJECT_ISF_COMPLEMENTAIRE_FORMATION: `${COMMON_URL_PRESFOR}isf-complementaire/cot-reject-formation`,

  // TRONCON LIMITE
  POST_COT_VALIDATE_DTV_TRONCON_LIMITE: `${COMMON_URL_PRESFOR}dtv/cot-approuve-troncon-limite`,
  POST_COT_REJECT_DTV_TRONCON_LIMITE: `${COMMON_URL_PRESFOR}dtv/cot-reject-troncon-limite`,

  POST_COT_VALIDATE_CALENDRIER_PREV: `${COMMON_URL_PRESFOR}elaboration-calendrier/cot-approve-calendrier`,
  POST_COT_REJECT_CALENDRIER_PREV: `${COMMON_URL_PRESFOR}elaboration-calendrier/cot-reject-calendrier`,

  // DEMANDE IDENTITE
  POST_COT_VALIDATE_DEMANDE_ID: `${COMMON_URL_PRESFOR}activites-dialogue-social/cot-approve-demande`,
  POST_COT_REJECT_DEMANDE_ID: `${COMMON_URL_PRESFOR}activites-dialogue-social/cot-reject-demande`,

  // CONTRAT
  POST_COT_VALIDATE_CONTRAT: `${COMMON_URL_PRESFOR}contrat/cot-approuve-contrat`,
  POST_COT_REJECT_CONTRAT: `${COMMON_URL_PRESFOR}contrat/cot-reject-contrat`,

  GET_ONLY_VALIDATE_ENQUETE_ALL: `${COMMON_URL_PRESFOR}enquete/all-validate-enquete`,

  POST_COT_VALIDATE_CHARTE: `${COMMON_URL_PRESFOR}dialogue-social/cot-approuve-charte`,
  POST_COT_REJECT_CHARTE: `${COMMON_URL_PRESFOR}dialogue-social/cot-reject-charte`,

  // Annonce de pub
  POST_COT_VALIDATE_ANP: `${COMMON_URL_PRESFOR}certificat-foncier/cot-approuve-anp`,
  POST_COT_REJECT_ANP: `${COMMON_URL_PRESFOR}certificat-foncier/cot-reject-anp`,

  POST_COT_VALIDATE_ANPO: `${COMMON_URL_PRESFOR}certificat-foncier/cot-approuve-anpo`,
  POST_COT_REJECT_ANPO: `${COMMON_URL_PRESFOR}certificat-foncier/cot-reject-anpo`,

  POST_COT_VALIDATE_ANPC: `${COMMON_URL_PRESFOR}certificat-foncier/cot-approuve-anpc`,
  POST_COT_REJECT_ANPC: `${COMMON_URL_PRESFOR}certificat-foncier/cot-reject-anpc`,

  GET_ONLY_CQ_VALIDATE_ENQUETE_ALL: `${COMMON_URL_PRESFOR}enquete/all-cq-validate-enquete`,
  GET_PVRDC_LISTE_DATE_SERVITUDE: `${COMMON_URL_PRESFOR}pvrdc/listeddcc-pvrdc`,

  POST_REVIEW_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/cq-review-dcf`,
  POST_COT_REVIEW_DCF: `${COMMON_URL_PRESFOR}certificat-foncier/cot-review-dcf`,
  POST_REVIEW_ID: `${COMMON_URL_PRESFOR}certificat-foncier/cq-review-id`,
  POST_COT_REVIEW_ID: `${COMMON_URL_PRESFOR}certificat-foncier/cot-review-id`,
  POST_REVIEW_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/cq-review-pvrdc`,
  POST_COT_REVIEW_PVRDC: `${COMMON_URL_PRESFOR}pvrdc/cot-review-pvrdc`,
  POST_REVIEW_PVCL: `${COMMON_URL_PRESFOR}pvcl/cq-review-pvcl`,
  POST_COT_REVIEW_PVCL: `${COMMON_URL_PRESFOR}pvcl/cot-review-pvcl`,
  POST_REVIEW_CLP: `${COMMON_URL_PRESFOR}clp/cq-review-clp`,
  POST_COT_REVIEW_CLP: `${COMMON_URL_PRESFOR}clp/cot-review-clp`,
  POST_REVIEW_CECPDC: `${COMMON_URL_PRESFOR}constat/cq-review-cecpdc`,
  POST_COT_REVIEW_CECPDC: `${COMMON_URL_PRESFOR}constat/cot-review-cecpdc`,
  POST_REVIEW_VALID: `${COMMON_URL_PRESFOR}constat/cq-review-valid`,
  POST_COT_REVIEW_VALID: `${COMMON_URL_PRESFOR}constat/cot-review-valid`,

  POST_COT_REVIEW_ANP: `${COMMON_URL_PRESFOR}certificat-foncier/cot-review-anp`,
  POST_COT_REVIEW_ANPO: `${COMMON_URL_PRESFOR}certificat-foncier/cot-review-anpo`,
  POST_COT_REVIEW_ANPC: `${COMMON_URL_PRESFOR}certificat-foncier/cot-review-anpc`,

  POST_REVIEW_ANP: `${COMMON_URL_PRESFOR}certificat-foncier/cq-review-anp`,
  POST_REVIEW_ANPO: `${COMMON_URL_PRESFOR}certificat-foncier/cq-review-anpo`,
  POST_REVIEW_ANPC: `${COMMON_URL_PRESFOR}certificat-foncier/cq-review-anpc`,

  POST_COT_REVIEW_CONTRAT: `${COMMON_URL_PRESFOR}contrat/cot-review-contrat`,
  POST_REVIEW_CONTRAT: `${COMMON_URL_PRESFOR}contrat/cq-review-contrat`,

  POST_REVIEW_DTV_HISTO: `${COMMON_URL_PRESFOR}dtv/cq-review-histo`,
  POST_COT_REVIEW_DTV_HISTO: `${COMMON_URL_PRESFOR}dtv/cot-review-histo`,

  // ANP: PROCES VERBAL D'ANNONCE DE PUBLICITE
  POST_COT_REVIEW_DTV_ANP: `${COMMON_URL_PRESFOR}dtv/cot-review-anp`,
  POST_REVIEW_DTV_ANP: `${COMMON_URL_PRESFOR}dtv/cq-review-anp`,

  // ANPO: PROCES VERBAL D'OUVERTURE DE PUBLICITE
  POST_COT_REVIEW_DTV_ANPO: `${COMMON_URL_PRESFOR}dtv/cot-review-anpo`,
  POST_REVIEW_DTV_ANPO: `${COMMON_URL_PRESFOR}dtv/cq-review-anpo`,

  // ANPC: PROCES VERBAL DE CLOTURE DE PUBLICITE
  POST_COT_REVIEW_DTV_ANPC: `${COMMON_URL_PRESFOR}dtv/cot-review-anpc`,
  POST_REVIEW_DTV_ANPC: `${COMMON_URL_PRESFOR}dtv/cq-review-anpc`,

  // APPROBATION: ATTESTATION D'APPROBATION
  POST_COT_REVIEW_DTV_APPROBATION: `${COMMON_URL_PRESFOR}dtv/cot-review-approbation`,
  POST_REVIEW_DTV_APPROBATION: `${COMMON_URL_PRESFOR}dtv/cq-review-approbation`,

  // VALIDATION: ATTESTATION DE VALIDATION
  POST_COT_REVIEW_DTV_VALIDATION: `${COMMON_URL_PRESFOR}dtv/cot-review-validation`,
  POST_REVIEW_DTV_VALIDATION: `${COMMON_URL_PRESFOR}dtv/cq-review-validation`,

  // TRONCON LIMITE
  POST_COT_REVIEW_DTV_TRONCON_LIMITE: `${COMMON_URL_PRESFOR}dtv/cot-review-pvlim`,
  POST_DTV_TRONCON_LIMITE: `${COMMON_URL_PRESFOR}dtv/cq-review-pvlim`,

  // --- NOUVEAUX ENDPOINTS REVIEW ISF ---

  // Demande Identité
  POST_COT_REVIEW_DEMANDE_IDENTITE: `${COMMON_URL_PRESFOR}activites-dialogue-social/cot-review-demande-identite`,
  POST_CQ_REVIEW_DEMANDE_IDENTITE: `${COMMON_URL_PRESFOR}activites-dialogue-social/cq-review-demande-identite`,

  // Cérémonie Ouverture
  POST_COT_REVIEW_CEREMONIE_OUVERTURE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cot-review-ceremonie-ouverture`,
  POST_CQ_REVIEW_CEREMONIE_OUVERTURE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cq-review-ceremonie-ouverture`,
  POST_COT_REVIEW_CEREMONIE_COMPTE_RENDU: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cot-review-compte-rendu`,
  POST_CQ_REVIEW_CEREMONIE_COMPTE_RENDU: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cq-review-compte-rendu`,
  POST_COT_REVIEW_RAPPORT_VILLAGE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cot-review-rapport-village`,
  POST_CQ_REVIEW_RAPPORT_VILLAGE: `${COMMON_URL_PRESFOR}ceremonie-ouverture/cq-review-rapport-village`,

  // Diagnostic
  POST_COT_REVIEW_DIAGNOSTIC: `${COMMON_URL_PRESFOR}diagnostic/cot-review-diagnostic`,
  POST_CQ_REVIEW_DIAGNOSTIC: `${COMMON_URL_PRESFOR}diagnostic/cq-review-diagnostic`,

  // Dialogue Social
  POST_COT_REVIEW_CALENDRIER_PREVISIONNEL_DS: `${COMMON_URL_PRESFOR}dialogue-social/cot-review-calendrier-previsionnel`,
  POST_CQ_REVIEW_CALENDRIER_PREVISIONNEL_DS: `${COMMON_URL_PRESFOR}dialogue-social/cq-review-calendrier-previsionnel`,
  POST_COT_REVIEW_GUIDE: `${COMMON_URL_PRESFOR}dialogue-social/cot-review-guide`,
  POST_CQ_REVIEW_GUIDE: `${COMMON_URL_PRESFOR}dialogue-social/cq-review-guide`,
  POST_COT_REVIEW_PROTOCOLE: `${COMMON_URL_PRESFOR}dialogue-social/cot-review-protocole`,
  POST_CQ_REVIEW_PROTOCOLE: `${COMMON_URL_PRESFOR}dialogue-social/cq-review-protocole`,
  POST_COT_REVIEW_PVCA: `${COMMON_URL_PRESFOR}dialogue-social/cot-review-pvca`,
  POST_CQ_REVIEW_PVCA: `${COMMON_URL_PRESFOR}dialogue-social/cq-review-pvca`,
  POST_COT_REVIEW_PVCFI: `${COMMON_URL_PRESFOR}dialogue-social/cot-review-pvcfi`,
  POST_CQ_REVIEW_PVCFI: `${COMMON_URL_PRESFOR}dialogue-social/cq-review-pvcfi`,
  POST_COT_REVIEW_PVRLF: `${COMMON_URL_PRESFOR}dialogue-social/cot-review-pvrlf`,
  POST_CQ_REVIEW_PVRLF: `${COMMON_URL_PRESFOR}dialogue-social/cq-review-pvrlf`,
  POST_COT_REVIEW_CHARTE: `${COMMON_URL_PRESFOR}dialogue-social/cot-review-charte`,
  POST_CQ_REVIEW_CHARTE: `${COMMON_URL_PRESFOR}dialogue-social/cq-review-charte`,

  // Elaboration Calendrier
  POST_COT_REVIEW_CALENDRIER: `${COMMON_URL_PRESFOR}elaboration-calendrier/cot-review-calendrier`,
  POST_CQ_REVIEW_CALENDRIER: `${COMMON_URL_PRESFOR}elaboration-calendrier/cq-review-calendrier`,

  // Formation
  POST_COT_REVIEW_ATTESTATION_FORMATION: `${COMMON_URL_PRESFOR}formation-cvgfr/cot-review-attestation-formation`,
  POST_CQ_REVIEW_ATTESTATION_FORMATION: `${COMMON_URL_PRESFOR}formation-cvgfr/cq-review-attestation-formation`,
  POST_COT_REVIEW_REGLEMENT_INTERIEUR: `${COMMON_URL_PRESFOR}formation-cvgfr/cot-review-reglement-interieur`,
  POST_CQ_REVIEW_REGLEMENT_INTERIEUR: `${COMMON_URL_PRESFOR}formation-cvgfr/cq-review-reglement-interieur`,

  // Information Sensibilisation
  POST_COT_REVIEW_INFO_SENSIBILISATION: `${COMMON_URL_PRESFOR}information-sensibilisation/cot-review-information-sensibilisation`,
  POST_CQ_REVIEW_INFO_SENSIBILISATION: `${COMMON_URL_PRESFOR}information-sensibilisation/cq-review-information-sensibilisation`,
  POST_COT_REVIEW_RAPPORT_ISF: `${COMMON_URL_PRESFOR}information-sensibilisation/cot-review-rapport-isf`,
  POST_CQ_REVIEW_RAPPORT_ISF: `${COMMON_URL_PRESFOR}information-sensibilisation/cq-review-rapport-isf`,

  // ISF Complémentaire
  POST_COT_REVIEW_ACTIVITE: `${COMMON_URL_PRESFOR}isf-complementaire/cot-review-activite`,
  POST_CQ_REVIEW_ACTIVITE: `${COMMON_URL_PRESFOR}isf-complementaire/cq-review-activite`,
  POST_COT_REVIEW_FACILITATION: `${COMMON_URL_PRESFOR}isf-complementaire/cot-review-facilitation`,
  POST_CQ_REVIEW_FACILITATION: `${COMMON_URL_PRESFOR}isf-complementaire/cq-review-facilitation`,
  POST_COT_REVIEW_FORMATION: `${COMMON_URL_PRESFOR}isf-complementaire/cot-review-formation`,
  POST_CQ_REVIEW_FORMATION: `${COMMON_URL_PRESFOR}isf-complementaire/cq-review-formation`,

  // ISF Service
  POST_COT_REVIEW_CCO: `${COMMON_URL_PRESFOR}isf/cot-review-cco`,
  POST_CQ_REVIEW_CCO: `${COMMON_URL_PRESFOR}isf/cq-review-cco`,
  POST_COT_REVIEW_RECUEIL: `${COMMON_URL_PRESFOR}isf/cot-review-recueil`,
  POST_CQ_REVIEW_RECUEIL: `${COMMON_URL_PRESFOR}isf/cq-review-recueil`,
  POST_COT_REVIEW_LISTE_PRESENCE_RECUEIL: `${COMMON_URL_PRESFOR}isf/cot-review-liste-presence-recueil`,
  POST_CQ_REVIEW_LISTE_PRESENCE_RECUEIL: `${COMMON_URL_PRESFOR}isf/cq-review-liste-presence-recueil`,
  POST_COT_REVIEW_DECLARATION: `${COMMON_URL_PRESFOR}isf/cot-review-declaration`,
  POST_CQ_REVIEW_DECLARATION: `${COMMON_URL_PRESFOR}isf/cq-review-declaration`,

  // Rapport
  POST_COT_REVIEW_RAPPORT_ACTIVITE: `${COMMON_URL_PRESFOR}rapport/cot-review-rapport-activite`,
  POST_CQ_REVIEW_RAPPORT_ACTIVITE: `${COMMON_URL_PRESFOR}rapport/cq-review-rapport-activite`,
  POST_COT_REVIEW_RAPPORT_OSF: `${COMMON_URL_PRESFOR}rapport/cot-review-rapport-osf`,
  POST_CQ_REVIEW_RAPPORT_OSF: `${COMMON_URL_PRESFOR}rapport/cq-review-rapport-osf`,

  // Registre Intention
  POST_COT_REVIEW_DCF_INTENTION: `${COMMON_URL_PRESFOR}registre-intention/cot-review-dcf`,
  POST_CQ_REVIEW_DCF_INTENTION: `${COMMON_URL_PRESFOR}registre-intention/cq-review-dcf`,
  POST_COT_REVIEW_DCC: `${COMMON_URL_PRESFOR}registre-intention/cot-review-dcc`,
  POST_CQ_REVIEW_DCC: `${COMMON_URL_PRESFOR}registre-intention/cq-review-dcc`,

  // Reunion Periodique
  POST_COT_REVIEW_DECISION: `${COMMON_URL_PRESFOR}reunion-periodique/cot-review-decision`,
  POST_CQ_REVIEW_DECISION: `${COMMON_URL_PRESFOR}reunion-periodique/cq-review-decision`,
  POST_COT_REVIEW_RESUME: `${COMMON_URL_PRESFOR}reunion-periodique/cot-review-resume`,
  POST_CQ_REVIEW_RESUME: `${COMMON_URL_PRESFOR}reunion-periodique/cq-review-resume`,

  // --- SUITE NOUVEAUX ENDPOINTS REVIEW (Ajouts manquants) ---

  // Formation - Liste de présence
  POST_COT_REVIEW_LISTE_PRESENCE: `${COMMON_URL_PRESFOR}formation-cvgfr/cot-review-liste-presence`,
  POST_CQ_REVIEW_LISTE_PRESENCE: `${COMMON_URL_PRESFOR}formation-cvgfr/cq-review-liste-presence`,

  // Elaboration Calendrier - Courrier
  POST_COT_REVIEW_COURRIER: `${COMMON_URL_PRESFOR}elaboration-calendrier/cot-review-courrier`,
  POST_CQ_REVIEW_COURRIER: `${COMMON_URL_PRESFOR}elaboration-calendrier/cq-review-courrier`,

  // Diagnostic - Décision Création (DCC)
  POST_COT_REVIEW_DECISION_CREATION: `${COMMON_URL_PRESFOR}diagnostic/cot-review-decision-creation`,
  POST_CQ_REVIEW_DECISION_CREATION: `${COMMON_URL_PRESFOR}diagnostic/cq-review-decision-creation`,

  // Diagnostic - PV Constitution (PVC)
  POST_COT_REVIEW_PV_CONSTITUTION: `${COMMON_URL_PRESFOR}diagnostic/cot-review-pv-constitution`,
  POST_CQ_REVIEW_PV_CONSTITUTION: `${COMMON_URL_PRESFOR}diagnostic/cq-review-pv-constitution`,

  // Prise de Contact (PC)
  POST_COT_REVIEW_PC: `${COMMON_URL_PRESFOR}prise-contact/cot-review-pc`,
  POST_CQ_REVIEW_PC: `${COMMON_URL_PRESFOR}prise-contact/cq-review-pc`,

  // Prise de Contact - Compte Rendu (CR)
  POST_COT_REVIEW_CR_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/cot-review-cr`,
  POST_CQ_REVIEW_CR_CONTACT: `${COMMON_URL_PRESFOR}prise-contact/cq-review-cr`,

  POST_REVIEW_SHAPE: `${COMMON_URL_PRESFOR}certificat-foncier/review-shape`,
  POST_VALIDATE_SHAPE: `${COMMON_URL_PRESFOR}certificat-foncier/validate-shape`,
  POST_REJECT_SHAPE: `${COMMON_URL_PRESFOR}certificat-foncier/reject-shape`,
  GET_ONE_SINGLE_PPP_SHAPE_FILE: `${COMMON_URL_PRESFOR}certificat-foncier/ppp-shape`,
  GET_ONE_SINGLE_PPD_SHAPE_FILE: `${COMMON_URL_PRESFOR}certificat-foncier/ppd-shape`,

  GET_RAPPORT_DCF_STATS: `${COMMON_URL_PRESFOR}certificat-foncier/rapport-dcf`,
  GET_RAPPORT_PVRDC_STATS: `${COMMON_URL_PRESFOR}pvrdc/rapport-pvrdc`,
  GET_RAPPORT_PVCL_STATS: `${COMMON_URL_PRESFOR}pvcl/rapport-pvcl`,
  GET_RAPPORT_PPP_STATS: `${COMMON_URL_PRESFOR}certificat-foncier/rapport-ppp`,
  GET_RAPPORT_ATTESTATION_STATS: `${COMMON_URL_PRESFOR}constat/rapport-attestation`,
  GET_RAPPORT_CECPDC_STATS: `${COMMON_URL_PRESFOR}constat/rapport-cecpdc`,
  // À ajouter dans API_URLS_PRESFOR
  GET_RAPPORT_ANP_STATS: `${COMMON_URL_PRESFOR}certificat-foncier/rapport-anp`,
  GET_RAPPORT_ANPO_STATS: `${COMMON_URL_PRESFOR}certificat-foncier/rapport-anpo`,
  GET_RAPPORT_ANPC_STATS: `${COMMON_URL_PRESFOR}certificat-foncier/rapport-anpc`,

  GET_RAPPORT_CLP_STATS: `${COMMON_URL_PRESFOR}clp/rapport-clp`,
  GET_RAPPORT_PPD_STATS: `${COMMON_URL_PRESFOR}certificat-foncier/rapport-ppd`,

  GET_RAPPORT_CF19_STATS: `${COMMON_URL_PRESFOR}certificat-foncier/rapport-cf19`,
  GET_MEMBRES_EQUIPE_ENQUETE: `${COMMON_URL_PRESFOR}certificat-foncier/membres-equipe-enquete`,
  GET_RAPPORT_NON_PARTICIPATION_BY_NNNNN: `${COMMON_URL_PRESFOR}rapport-non-participation/by-nnnnn`,
  POST_RAPPORT_NON_PARTICIPATION_CREATE: `${COMMON_URL_PRESFOR}rapport-non-participation/create`,
  PUT_RAPPORT_NON_PARTICIPATION_UPDATE: `${COMMON_URL_PRESFOR}rapport-non-participation/update`,
  DELETE_RAPPORT_NON_PARTICIPATION: `${COMMON_URL_PRESFOR}rapport-non-participation/delete`,
  UPLOAD_PPP_V2: `${COMMON_URL_PRESFOR}certificat-foncier/upload-ppp-v2`,
  GET_RAPPORT_DOSSIER_PROVISOIRE_STATS: `${COMMON_URL_PRESFOR}certificat-foncier/rapport-dossier-prov`,
  DELETE_PPP_V2: `${COMMON_URL_PRESFOR}certificat-foncier/delete-ppp-v2`,

  GET_REGENERATE_PDF_RAPPORT_ACTIVITE: `${COMMON_URL_PRESFOR}rapport/regenerate-rapport-pdf`,
  GET_REGENERATE_PDF_RAPPORT_OSF: `${COMMON_URL_PRESFOR}rapport/regenerate-rosof-pdf`,

  MINIMIZE_LIST_PUB_BY_ENQUETE: `${COMMON_URL_PRESFOR}certificat-foncier/minimize-anp-by-enquete`,
  GET_ANPDS_BY_ANNONCE_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/anpds-by-anp`,
  GET_ANPDS_BY_ENQUETE: `${COMMON_URL_PRESFOR}certificat-foncier/anpds-by-enquete`,
  GET_ANPO_LPS_BY_ANNONCE_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/anpo-lps-by-anp`,
  GET_ANPC_LPS_BY_ANNONCE_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/anpc-lps-by-anp`,
  DELETE_CECPDC_BY_ANNONCE_PUB: `${COMMON_URL_PRESFOR}constat/cecpdc-by-annonce`,
  DELETE_VALID_BY_ANNONCE_PUB: `${COMMON_URL_PRESFOR}constat/valid-by-annonce`,

  GET_RAPPORT_DOSSIER_PROVISOIRE2_STATS: `${COMMON_URL_PRESFOR}certificat-foncier/rapport-dossier-prov2`,
  GET_RAPPORT_DOSSIER_DEFINITIF_STATS: `${COMMON_URL_PRESFOR}certificat-foncier/rapport-dossier-definitif1`,
  GET_DTV_PVLIM_BY_ENQUETE: `${COMMON_URL_PRESFOR}dtv/pvlim-by-enquete`,

  GET_DTV_ANPC_BY_ENQUETE: `${COMMON_URL_PRESFOR}dtv/anpc-by-enquete`,
  GET_PLAN_PARCEL_STATISTIQUE_BY_ENQUETE: `${COMMON_URL_PRESFOR}certificat-foncier/plan-statistique`,

  REGENERATE_PDF_RAPPORT_ACTIVITE: `${COMMON_URL_PRESFOR}rapport/regenerate-rapport-pdf`,
  REGENERATE_PDF_RAPPORT_OSF: `${COMMON_URL_PRESFOR}rapport/regenerate-rosof-pdf`,

  REGENERATE_ANP_PDF: `${COMMON_URL_PRESFOR}certificat-foncier/create-anp-pdf`,
  REGENERATE_ANPO_PDF: `${COMMON_URL_PRESFOR}certificat-foncier/regenerate-anpo-pdf`,

  REGENERATE_DCF_ANP_PDF: `${COMMON_URL_PRESFOR}certificat-foncier/regenerate-dcf-anp-pdf`,
  REGENERATE_DCF_ANPO_PDF: `${COMMON_URL_PRESFOR}certificat-foncier/regenerate-dcf-anpo-pdf`,
  REGENERATE_DCF_ANPC_PDF: `${COMMON_URL_PRESFOR}certificat-foncier/regenerate-dcf-anpc-pdf`,
  REGENERATE_DTV_HISTO_PDF: `${COMMON_URL_PRESFOR}dtv/regenerate-dtv-histo-pdf`,

  GET_DTV_HISTO_BY_ENQUETE: `${COMMON_URL_PRESFOR}dtv/histo-by-enquete`,
  GET_DTV_ATTESTATION_APPROBATION_BY_ENQUETE: `${COMMON_URL_PRESFOR}dtv/attestation-approbation-by-enquete`,
  GET_DTV_ATTESTATION_VALID_BY_ENQUETE: `${COMMON_URL_PRESFOR}dtv/valid-by-enquete`,
  GET_TRANSMISSION_TAGS_BY_CODE_CF: `${COMMON_URL_PRESFOR}certificat-foncier/transmission-tags-by-code-cf`,
  GET_LIVRABLE_TRANSMIS: `${COMMON_URL_PRESFOR}transmission-afor/list-livrables-transmis`,
  TOGGLE_LIVRABLE_TRANSMIS_EDITABILITY: `${COMMON_URL_PRESFOR}transmission-afor/toggle-livrable-transmis-editability`,
  GET_LIVRABLE_VISIBILITY: `${COMMON_URL_PRESFOR}transmission-afor/get-livrable-visibility`,
  GET_DEMANDES_PRES_A_TRANSMETTRE: `${COMMON_URL_PRESFOR}transmission-afor/list-livrables-a-transmettre`,

  POST_REGENERATE_PVCL_PDF: `${COMMON_URL_PRESFOR}pvcl/regenerate-pvcl-pdf`,
  POST_REGENERATE_DCF_PDF: `${COMMON_URL_PRESFOR}certificat-foncier/create-single-dcf-pdf`,
  GET_AFOR_VALIDATION_MESSAGE_BY_NNNNN: `${COMMON_URL_PRESFOR}transmission-afor/afor-message-validation`,

  TRANSMIT_OR_UPDATE_DCF_PIECES: `${COMMON_URL_PRESFOR}transmission-afor/dcfs-pieces/transmit-or-update`,
  TRANSMIT_OR_UPDATE_ANPS: `${COMMON_URL_PRESFOR}transmission-afor/anps/transmit-or-update`,
  TRANSMIT_OR_UPDATE_ANPOS: `${COMMON_URL_PRESFOR}transmission-afor/anpos/transmit-or-update`,
  TRANSMIT_OR_UPDATE_ANPCS: `${COMMON_URL_PRESFOR}transmission-afor/anpcs/transmit-or-update`,

  GET_CODE_CERTIF_BY_ANNONCE_PUB: `${COMMON_URL_PRESFOR}certificat-foncier/find-code-certif`,
  REGENERATE_CECPDC_PDF_BY_CODEDCF: `${COMMON_URL_PRESFOR}constat/regenerate-cecpdc-pdf-by-codedcf`,
  GET_SP_BY_CODE_REG: `${COMMON_URL_PRESFOR}codification/region-sp`,

  RAPPORT_TRANSMISSION_CF: `${COMMON_URL_PRESFOR}transmission-afor/rapport-transmission-cf`,
  RAPPORT_TRANSMISSION_CONTRAT: `${COMMON_URL_PRESFOR}transmission-afor/rapport-transmission-contrat`,
  STATS_CF_EXCEL: `${COMMON_URL_PRESFOR}transmission-afor/stats-cf-excel`,
  STATS_CF_EXCEL_HISTORY: `${COMMON_URL_PRESFOR}transmission-afor/stats-cf-excel/history`,
  STATS_CONTRAT_EXCEL: `${COMMON_URL_PRESFOR}transmission-afor/stats-contrat-excel`,
  STATS_CONTRAT_EXCEL_HISTORY: `${COMMON_URL_PRESFOR}transmission-afor/stats-contrat-excel/history`,

  // Plans délimitation PDF
  UPLOAD_DTV_PLAN_PROVISOIRE: `${COMMON_URL_PRESFOR}dtv/upload-plan-provisoire-delimitation-pdf`,
  UPLOAD_DTV_PLAN_DEFINITIF: `${COMMON_URL_PRESFOR}dtv/upload-plan-definitif-delimitation-pdf`,

  // Shapefiles ZIP
  UPLOAD_DTV_PLAN_PROVISOIRE_SHP: `${COMMON_URL_PRESFOR}dtv/upload-plan-provisoire-delimitation-shapefile`,
  UPLOAD_DTV_PLAN_DEFINITIF_SHP: `${COMMON_URL_PRESFOR}dtv/upload-plan-definitif-delimitation-shapefile`,

  // Suppression fichiers délimitation
  DELETE_DTV_DELIMITATION_FILE: `${COMMON_URL_PRESFOR}dtv/delete-delimitation-file`,
  DELETE_DTV_PLAN_DEFINITIF_PDF: `${COMMON_URL_PRESFOR}dtv/delete-plan-definitif-delimitation-pdf`,
  DELETE_DTV_PLAN_DEFINITIF_SHP: `${COMMON_URL_PRESFOR}dtv/delete-plan-definitif-delimitation-shapefile`,
  GET_DTV_PLAN_DELIMITATION: `${COMMON_URL_PRESFOR}dtv/plan-delimitation`,

  // Validation/Rejet COT
  POST_COT_VALIDATE_DTV_DELIMITATION_FILE: `${COMMON_URL_PRESFOR}dtv/cot-delimitation-file`,
  POST_COT_REJECT_DTV_DELIMITATION_FILE: `${COMMON_URL_PRESFOR}dtv/cot-reject-delimitation-file`,

  // Validation/Rejet CQ
  POST_CQ_VALIDATE_DTV_DELIMITATION_FILE: `${COMMON_URL_PRESFOR}dtv/cq-delimitation-file`,
  POST_CQ_REJECT_DTV_DELIMITATION_FILE: `${COMMON_URL_PRESFOR}dtv/cq-reject-delimitation-file`,

  POST_COT_REVIEW_DTV_DELIMITATION_FILE: `${COMMON_URL_PRESFOR}dtv/cot-review-delimitation-file`,
  POST_CQ_REVIEW_DTV_DELIMITATION_FILE: `${COMMON_URL_PRESFOR}dtv/cq-review-delimitation-file`,

  GET_ONE_SINGLE_PPP_V2_SHAPE_FILE: `${COMMON_URL_PRESFOR}certificat-foncier/ppp-shape-v2`,

  RECOVERY_DTV_PLAN_DELIMITATION_FROM_DRIVE: `${COMMON_URL_PRESFOR}dtv/recovery-dtv-plan-delimitation-from-drive`,

  GET_HISTO_IMPORT_DELIMITATION_DRIVE: `${COMMON_URL_PRESFOR}dtv/histo-import-delimitation-drive`,

  REGENERATE_VALID_PDF_BY_CODEDCF: `${COMMON_URL_PRESFOR}constat/regenerate-valid-pdf-by-codedcf`,

  GET_DTV_A_TRANSMETTRE: `${COMMON_URL_PRESFOR}transmission-afor/dtv/list-livrables-a-transmettre`,
  TRANSMIT_DTV_HISTO: `${COMMON_URL_PRESFOR}transmission-afor/dtv/transmit-histo`,
  TRANSMIT_DTV_DECLARATION_OUVERTURE_PDF: `${COMMON_URL_PRESFOR}transmission-afor/dtv/transmit-declaration-ouverture-pdf`,
  TRANSMIT_DTV_TRONCON: `${COMMON_URL_PRESFOR}transmission-afor/dtv/transmit-troncon`,
  TRANSMIT_DTV_ANP: `${COMMON_URL_PRESFOR}transmission-afor/dtv/transmit-anp`,
  TRANSMIT_DTV_ANPO: `${COMMON_URL_PRESFOR}transmission-afor/dtv/transmit-anpo`,
  TRANSMIT_DTV_ANPC: `${COMMON_URL_PRESFOR}transmission-afor/dtv/transmit-anpc`,
  TRANSMIT_DTV_APPROBATION: `${COMMON_URL_PRESFOR}transmission-afor/dtv/transmit-approbation`,
  TRANSMIT_DTV_VALIDATION: `${COMMON_URL_PRESFOR}transmission-afor/dtv/transmit-validation`,
  TRANSMIT_DTV_PPP: `${COMMON_URL_PRESFOR}transmission-afor/dtv/transmit-ppp`,
  TRANSMIT_DTV_PPD: `${COMMON_URL_PRESFOR}transmission-afor/dtv/transmit-ppd`,

  GET_PVRDC_DOCUMENTS_ANNEXE: `${COMMON_URL_PRESFOR}pvrdc/autres-documents-annexes`,
  POST_PVRDC_DOCUMENTS_ANNEXE: `${COMMON_URL_PRESFOR}pvrdc/upload-autres-documents-annexes`,
  DELETE_PVRDC_DOCUMENTS_ANNEXE: `${COMMON_URL_PRESFOR}pvrdc/autres-documents-annexe`,
  POST_VALIDATE_PVRDC_DOCUMENTS_ANNEXE: `${COMMON_URL_PRESFOR}pvrdc/cq-approuve-autres-documents`,
  POST_REJECT_PVRDC_DOCUMENTS_ANNEXE: `${COMMON_URL_PRESFOR}pvrdc/cq-reject-autres-documents`,
  POST_REVIEW_PVRDC_DOCUMENTS_ANNEXE: `${COMMON_URL_PRESFOR}pvrdc/cq-review-autres-documents`,
  GET_PVRDC_ANNEXE7: `${COMMON_URL_PRESFOR}certificat-foncier/pvrdc/groupe-annexe-7`,
  GET_CONTRATS_HISTORY: `${COMMON_URL_PRESFOR}contrat/contrats/history`,
  DOWNLOAD_CONTRAT_EXPORT: `${COMMON_URL_PRESFOR}contrat/contrats/history`,

  GET_RAPPORT_DTV_LIVRABLES: `${COMMON_URL_PRESFOR}dtv/rapport/livrables`,
  GET_RAPPORT_DTV_VILLAGES: `${COMMON_URL_PRESFOR}dtv/rapport/villages`,
  GET_RAPPORT_CONTRAT_STATS: `${COMMON_URL_PRESFOR}contrat/rapport/stats`,
  GET_RAPPORT_CONTRAT_LISTE: `${COMMON_URL_PRESFOR}contrat/rapport/contrats`,

};

export const contactApi = (payload) => {
  return apis.post(API_URLS_PRESFOR.SEND_MESSAGE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getMembresEquipeEnquete = (NNNNN, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_MEMBRES_EQUIPE_ENQUETE}/${NNNNN}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getRapportNonParticipationByNnnnn = (nnnnn, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_RAPPORT_NON_PARTICIPATION_BY_NNNNN}/${nnnnn}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postRapportNonParticipationCreate = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_RAPPORT_NON_PARTICIPATION_CREATE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putRapportNonParticipationUpdate = (id, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.PUT_RAPPORT_NON_PARTICIPATION_UPDATE}/${id}`;
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteRapportNonParticipation = (id, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_RAPPORT_NON_PARTICIPATION}/${id}`;
  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putDesignationGestionnaireCFC = (codepvrdc, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.PUT_DESIGNATION_GESTIONNAIRECFC}/${codepvrdc}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const updateDO = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPDATE_DECLARATION_OUVERTURE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const findTransmissionByCodeCla = (code_cla, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_TL}/${code_cla}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateTL = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPDATE_TRANSMISSION_LETTRE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteDO = (code_cla, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_DO}/${code_cla}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteTL = (code_cla, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_TL}/${code_cla}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const createAnpPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.PDF_DEMANDES_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDeclarationOuverture = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_DECLARATION_OUVERTURE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postTransmissionLettre = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_TRANSMISSION_LETTRE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const get_list_pub_unique = (codepub, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.LIST_PUB_UNIQUE}/${codepub}`;

  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const get_list_pub = (code, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.LIST_PUB}/${code}`;

  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateAnnoncePub = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPDATE_ANNONCE_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const generateContrat = (payload) => {
  return apis.post(API_URLS_PRESFOR.GENERATE_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addServitude = (payload) => {
  return apis.post(API_URLS_PRESFOR.ADD_SERVITUDE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addDateServitude = (payload) => {
  return apis.post(`${COMMON_URL_PRESFOR}pvrdc/add-servitude`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateServitude = (code_pvrdc, payload) => {
  return apis.put(`${COMMON_URL_PRESFOR}pvrdc/update-servitude/${code_pvrdc}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addEtatDeDroit = (payload) => {
  return apis.post(API_URLS_PRESFOR.ADD_ETAT_DE_DROIT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateEtatDeDroitCF = (code, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.UPDATE_ETAT_DE_DROIT}/${code}`;

  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteVALID = (codevalid, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_VALID}/${codevalid}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteCECPDC = (codececpdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_CECPDC}/${codececpdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteANP = (code_annonce_pub, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_ANP}/${code_annonce_pub}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteANPC = (code_annonce_pub, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_ANPC}/${code_annonce_pub}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteANPO = (code_annonce_pub, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_ANPO}/${code_annonce_pub}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteCLP = (codeclp, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_CLP}/${codeclp}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePVCL = (codepvcl, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVCL}/${codepvcl}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeFicheDemographique = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC_FICHE_DEMOGRAPHIQUE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeEquipeEnquete = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC_ANNEXE_EQUIPE_ENQUETE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeDeclarationOccupant = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC_ANNEXE_DECLARATION_OCCUPANT}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeOccupantParcelle = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC_ANNEXE_OCCUPANT_PARCELLE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeFicheLitige = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC_ANNEXE_FICHE_LITIGE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeDetenteurDroit = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC_ANNEXE_DETENTEUR_DROIT}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeEtatDroit = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC_ANNEXE_ETAT_DROIT}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePVRDC = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeDesignationGestionnaire = (
  codepvrdc,
  payload
) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC_ANNEXE_DESIGNATION_GESTIONNAIRE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeServitude = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC_ANNEXE_SERVITUDE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcAnnexeSignatureDesignationGestionnaire = (
  codepvrdc,
  payload
) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC_ANNEXE_SIGNATURE_DESIGNATION_GESTIONNAIRE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteDCF = (codedcf, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_DCF}/${codedcf}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const TransmissionDCF = (NNNNN, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.TRANSMISSION_DCF}/${NNNNN}`;

  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const TransmissionDCFbyenquete = (numero_enquete, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.TRANSMISSION_DCF_ENQUETE}/${numero_enquete}`;

  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const transmitOrUpdateDcfs = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_DCFS,
    {
      // Backend attend la valeur NNNNN dans le body
      ...payload,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        ...payload?.headers,
      },
    }
  );
};

export const transmitOrUpdatePvcls = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_PVCLS,
    {
      ...payload,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        ...payload?.headers,
      },
    }
  );
};

export const transmitOrUpdatePvrdcs = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_PVRDCS,
    {
      ...payload,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        ...payload?.headers,
      },
    }
  );
};

export const transmitOrUpdateOccupantsParcelle = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_OCCUPANTS_PARCELLE,
    {
      ...payload,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        ...payload?.headers,
      },
    }
  );
};

export const deleteCF = (codedcf, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_CF}/${codedcf}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getNumContratByEnquete = (ide, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_NUM_CONTRAT_ENQUETE}/${ide}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updatePVCL = (payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.UPDATE_PVCL}`;
  // Make the GET request with the constructed URL
  return apis.post(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteAnnexesPVCL = (ida, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.DELETE_ANNEXES_PVCL}/${ida}`;
  // Make the GET request with the constructed URL
  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateAnnexesPVCL = (ida, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.UPDATE_ANNEXES_PVCL}/${ida}`;
  // Make the GET request with the constructed URL
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getParcelleGeomatic = async (num_dcf) => {
  const response = await axios.get(
    `${API_URLS_PRESFOR.GET_PARCELLE_GEOMATIC}/${num_dcf}`,
    {
      headers: {
        Authorization: `Bearer ${GEOMATIC_TOKEN}`,
      },
    }
  );
  return response;
};

export const updateDemandeCF = (codedcf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.UPDATE_DEMANDE_CF}/${codedcf}`;
  // Make the GET request with the constructed URL
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getAllNumDCF = (payload) => {
  return apis.get(API_URLS_PRESFOR.GET_ALL_NUM_DCF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const refreshToken = (idu, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.REFRESH_TOKEN_USER}/${idu}`;
  // Make the GET request with the constructed URL
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const changePSWD = (idu, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.CHANGE_PSWD_USER}/${idu}`;
  // Make the GET request with the constructed URL
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const forgotPSWD = (payload) => {
  return apis.post(API_URLS_PRESFOR.FORGOT_PSWD_USER, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPDFCLP = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_CLP, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getCLP = (codeCLP, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_CLP}/${codeCLP}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const downloadApp = async (payload) => {
  try {
    const apiUrl = `${API_URLS_PRESFOR.DOWNLOAD_MOBILE_APP}/${payload.ENV}/${payload.os}`;
    const response = await axios.get(apiUrl, {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    const app_name = `CGEDS_${payload.ENV}_${payload.os}.apk`;
    link.setAttribute('download', app_name); // Nom du fichier à télécharger
    document.body.appendChild(link);
    link.click();

    // Optionnel : Nettoyer après téléchargement
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading the APK:', error);
  }
};

export const getEnqueteByCode = (code_enquete, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_ENQUETE_BY_CODE}/${code_enquete}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAnnexesCLP = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ANNEXES_CLP, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postCLP = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_CLP, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const downloadPPDSHP = (nnnnn, payload) => {
  // Construct the URL for fetching the zip file by name
  let apiUrl = `${API_URLS_PRESFOR.GET_PPD_SHP}/${nnnnn}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: {
      'Content-Type': 'application/json',
      ...payload?.headers,
    },
    responseType: 'arraybuffer',
  });
};

export const downloadPPPSHP = (nnnnn, payload) => {
  // Construct the URL for fetching the zip file by name
  let apiUrl = `${API_URLS_PRESFOR.GET_PPP_SHP}/${nnnnn}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: {
      'Content-Type': 'application/json',
      ...payload?.headers,
    },
    responseType: 'arraybuffer',
  });
};

export const readPPDPDF = (nnnnn, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  let apiUrl = `${API_URLS_PRESFOR.GET_PPD_PDF}/${nnnnn}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: {
      'Content-Type': 'application/json',
      ...payload?.headers,
    },
    responseType: 'arraybuffer',
  });
};

export const readPPPPDF = (nnnnn, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  let apiUrl = `${API_URLS_PRESFOR.GET_PPP_PDF}/${nnnnn}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: {
      'Content-Type': 'application/json',
      ...payload?.headers,
    },
    responseType: 'arraybuffer',
  });
};

export const patchInfoCF = (payload) => {
  const apiUrl = `${API_URLS_PRESFOR.UPDATE_INFO_CF}`;
  // Make the GET request with the constructed URL
  return apis.patch(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const patchStatusDemande = (payload) => {
  const apiUrl = `${API_URLS_PRESFOR.UPDATE_STATUS_DEMANDE}`;
  // Make the GET request with the constructed URL
  return apis.patch(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const findUser = (code, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.UPDATE_USER}/${code}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// export const deleteUser = (payload) =>
//   apis.delete(API_URLS_PRESFOR.UPDATE_USER, {
//     ...payload?.data,
//     headers: { "Content-Type": "application/json", ...payload?.headers },
//   });

export const postPDFPVO = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_PVO, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const patchEtatDemande = (payload) => {
  return apis.patch(API_URLS_PRESFOR.UPDATE_ETAT_DEMANDE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPVO = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PVO, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postANPO = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ANPO, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateANPO = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPDATE_ANPO, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updatepvo = (code_dcfpvo, payload) => {
  return apis.put(
    `${COMMON_URL_PRESFOR}certificat-foncier/update-dcf-pvo/${code_dcfpvo}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const postPVOPresence = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PVO_PRESENCE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const readPDF = (payload) => {
  // Construct the URL by appending the contract ID to the base URL
  let apiUrl = `${API_URLS_PRESFOR.READ_PDF_CF}`;

  // Make the GET request with the constructed URL
  return apis.post(apiUrl, {
    ...payload,
    headers: {
      'Content-Type': 'application/json',
      ...payload?.headers,
    },
    responseType: 'arraybuffer',
  });
};

export const postPDFCF = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_CF, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPDFDCF = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_DCF, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const post_PDF_PVRDC = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_PVRDC, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPDFCFPiece = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_CFPIECE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPDFCFPieceClient = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_CFPIECE_CLIENT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updatePDFCFPiece = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPDATE_PDF_CFPIECE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPDFConstat = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_CONSTAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getConstat = (codeconstat, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_CONSTAT}/${codeconstat}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAnnexesConstat = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ANNEXES_CONSTAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postConstat = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_CONSTAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postValidByAnnonce = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_VALID_BY_ANNONCE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getValidByAnnonce = (code_annonce, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_VALID_BY_ANNONCE}/${code_annonce}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putValidByAnnonce = (code_annonce, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_VALID_BY_ANNONCE}/${code_annonce}`;
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateconstat = (code_constat, payload) => {
  return apis.put(
    `${COMMON_URL_PRESFOR}constat/update-constat/${code_constat}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

/* export const updateconstat = (code_constat, payload) =>
    apis.put(`${COMMON_URL_PRESFOR}constat/update-constat/${code_constat}`, {
      ...payload,
      headers: { "Content-Type": "application/json", ...payload?.headers },
    });
   */

export const postPDFCloturePub = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_CLOTUREPUB, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPDFOuverturePub = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_OUVERTUREPUB, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const createCloturePubPDF = (payload) => {
  return apis.post(API_URLS_PRESFOR.CREATE_CLOTUREPUB_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPDFPub = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_PUB, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getAnnoncePub = (codepub, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.ANNONCE_PUB}/${codepub}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPDFPVCL = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_PVCL, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getPVCL = (codepvcl, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_PVCL}/${codepvcl}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getLogActivity = (codeId, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.LOG_ACTIVITY_BY_ID}/${codeId}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// Journal d'audit des transmissions (admin) : seuls les filtres non vides partent en query params.
export const getTransmissionAudit = (params = {}) => {
  const filtres = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  );
  return apis.get(API_URLS_PRESFOR.TRANSMISSION_AUDIT, {
    params: filtres,
    headers: { 'Content-Type': 'application/json' },
  });
};

// Listes des auteurs et régions présents dans le journal (alimente les filtres).
export const getTransmissionAuditFiltres = () =>
  apis.get(API_URLS_PRESFOR.TRANSMISSION_AUDIT_FILTRES, {
    headers: { 'Content-Type': 'application/json' },
  });

export const getLogActivityByIds = (req, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.LOG_ACTIVITY}`;

  // Construct query parameters - convert array to comma-separated string
  const queryParams = new URLSearchParams();
  if (req?.idtab && Array.isArray(req.idtab)) {
    queryParams.append('idtab', req.idtab.join(','));
  }

  const urlWithParams = `${apiUrl}?${queryParams.toString()}`;
  //console.log("Making request to:", urlWithParams);

  // Make the GET request with query parameters
  return apis.get(urlWithParams, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDemandesPub = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_DEMANDES_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// export const updateCloturePub = (payload) => {
//   console.log("payload depuis service api ", payload)
//   apis.post(API_URLS_PRESFOR.UPDATE_PV_CLOTURE_PUB, {
//     ...payload,
//     headers: { "Content-Type": "application/json", ...payload?.headers },
//   });
// }

export const updateCloturePub = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPDATE_PV_CLOTURE_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postCloturePub = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_CLOTURE_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAnnoncePub = (payload) => {
  return apis.post(API_URLS_PRESFOR.ANNONCE_PUB, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAnnexesPVCL = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ANNEXES_PVCL, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPVCL = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PVCL, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getCF = (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_CF}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getPVRDC = async (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_PVRDC}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getDcfConstats = async (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_DCF_CONSTATS}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getAnnoncePublicite = async (code_certif, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_DCF_ANNONCE_PUBLICITE}/${code_certif}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDemandeCF = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_DEMANDE_CF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDesignationGestionnaireCFC = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_DESIGNATION_GESTIONNAIRECFC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAEFC = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_AEFC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postAEFJ = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_AEFJ, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addSignataireDesignationGestionnaireCFC = (payload) => {
  return apis.post(API_URLS_PRESFOR.ADD_SIGNATAIRE_BIEN_FONCIER, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateSignataireDesignationGestionnaireCFC = (
  code_pvrdc,
  payload
) => {
  return apis.put(
    `${COMMON_URL_PRESFOR}pvrdc/update-design-gestion/${code_pvrdc}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const postPVRDC = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updatePVRDC = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPDATE_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addMembreEquipEnqPVRDC = (payload) => {
  return apis.post(API_URLS_PRESFOR.ADD_MEMBRE_EQUIPE_ENQ_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateMembreEquipEnqPVRDC = (payload) => {
  return apis.put(API_URLS_PRESFOR.UPDATE_MEMBRE_EQUIPE_ENQ_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteMembreEquipEnqPVRDC = (payload) => {
  return apis.delete(API_URLS_PRESFOR.DELETE_MEMBRE_EQUIPE_ENQ_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addmembreFicheDemo = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_FICHE_DEMO_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addDeclarationPVRDC = (payload) => {
  return apis.post(API_URLS_PRESFOR.ADD_DECLARATION_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateDeclarationPVRDC = (payload) => {
  return apis.put(`${API_URLS_PRESFOR.UPDATE_DECLARATION_PVRDC}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteDeclarationPVRDC = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_DECLARATION_PVRDC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addLitigePVRDC = (payload) => {
  return apis.post(API_URLS_PRESFOR.ADD_LITIGE_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addFicheLitigePVRDC = (payload) => {
  return apis.post(API_URLS_PRESFOR.ADD_FICHE_LITIGE_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};
export const updateFicheLitigePVRDC = async (code_pvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.UPDATE_FICHE_LITIGE_PVRDC}/${code_pvrdc}`;
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addOccupantParcelle = (payload) =>
  apis.post(API_URLS_PRESFOR.ADD_OCCUPANT_PARCELLE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const deleteOccupantParcelle = async (
  code_occ_parcelle,
  payload = {}
) => {
  const lastUrl = `${API_URLS_PRESFOR.DELETE_OCCUPANT_PARCELLE}/${code_occ_parcelle}`;
  return apis.delete(lastUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateOccupantParcelle = async (code_occ_parcelle, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.UPDATE_OCCUPANT_PARCELLE}/${code_occ_parcelle}`;
  apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addOccupantParcelleDate = (payload) =>
  apis.post(API_URLS_PRESFOR.ADD_OCCUP_PARCELLE_DATE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
//updte
export const updateOccupantParcelleDate = async (code_occ_date, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.UPDATE_OCCUP_PARCELLE_DATE}/${code_occ_date}`;
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addListeServitude = (payload) =>
  apis.post(API_URLS_PRESFOR.ADD_LISTE_SERVITUDE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const addDetenteursDeDroitsCF = (payload) => {
  return apis.post(API_URLS_PRESFOR.ADD_DETENTEURS_DE_DROITS_CF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addDateDetenteursDeDroitsCF = (payload) => {
  return apis.post(`${COMMON_URL_PRESFOR}pvrdc/add-listeddcc`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateDetenteursDeDroitsCF = async (code_pvrdc, payload) => {
  return apis.put(`${COMMON_URL_PRESFOR}pvrdc/update-listeddcc/${code_pvrdc}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updatePvPublicite = (payload) => {
  const apiUrl = `${COMMON_URL_PRESFOR}/certificat-foncier/update-anp`;
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addEtatDeDroitCF = (payload) =>
  apis.post(API_URLS_PRESFOR.ADD_ETAT_DE_DROIT_PROP, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const addAyantDroit = (payload) =>
  apis.post(API_URLS_PRESFOR.ADD_AYANT_DROIT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const postTemoinContrat = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_TEMOIN_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const updateTemoinContrat = (payload) =>
  apis.post(API_URLS_PRESFOR.UPDATE_TEMOIN_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const postCecpdcByAnnonce = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_CECPDC_BY_ANNONCE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const updateCecpdcByAnnonce = (code_annonce_pub, payload) =>
  apis.put(`${API_URLS_PRESFOR.UPDATE_CECPDC_BY_ANNONCE}/${code_annonce_pub}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const getCecpdcByAnnonce = (codeAnnonce) =>
  apis.get(`${API_URLS_PRESFOR.GET_CECPDC_BY_ANNONCE}/${codeAnnonce}`, {
    headers: { 'Content-Type': 'application/json' },
  });

export const getCecpdcAnnonceById = (id) =>
  apis.get(`${API_URLS_PRESFOR.GET_CECPDC_ANNONCE_BY_ID}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });

export const deleteValidByAnnonce = (code_annonce_pub, payload) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_VALID_BY_ANNONCE_PUB}/${code_annonce_pub}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const postCecpdcPdf = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_CECPDC_PDF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const postValidPdf = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_VALID_PDF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const postPDFContrat = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_PDF_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const updateProcurationContrat = (payload) =>
  apis.put(API_URLS_PRESFOR.UPDATE_PROCURATION_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const postPDFCNI = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PDF_CNI_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postFicheIdentification = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_FICHE_IDENTIFICATION, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updateFicheIdentification = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.UPDATE_FICHE_IDENTIFICATION}/${id}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updatePDFCNI = (payload) =>
  apis.put(API_URLS_PRESFOR.UPDATE_PDF_CNI_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const postPDFCroquis = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_PDF_CROQUIS_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const postPDFProcuration = (payload) => {
  console.log('payload', payload);
  return apis.post(API_URLS_PRESFOR.POST_PDF_PROCURATION_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updatePDFProcuration = (payload) =>
  apis.put(API_URLS_PRESFOR.UPDATE_PROCURATION_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const postAnnexesContrat = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ANNEXES_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updateAnnexesContrat = (payload) =>
  apis.put(API_URLS_PRESFOR.UPDATE_ANNEXES_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

// Pas de PUT croquis côté backend : remplacement via POST + remove_files.
export const updatePDFCroquis = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_PDF_CROQUIS_CONTRAT, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });

export const readContractFiles = (payload) => {
  return apis.post(API_URLS_PRESFOR.READ_PDF_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
    responseType: 'arraybuffer',
  });
};

export const getContratByEnquete = (codeenquete, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_CONTRAT_ENQ}/${codeenquete}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const readpdfprocuration = (idproducration, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.READ_PDF_PROCURATION}/${idproducration}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const readpdfcroquis = (idcroquis, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.READ_PDF_CROQUIS}/${idcroquis}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const readpdfpiece = (idpiece, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.READ_PDF_PIECESID}/${idpiece}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const readPDFAnnexesContrat = (idAnnexe, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.READ_PDF_ANNEXES}/${idAnnexe}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getCertificatByEnquete = (codeEnquete, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_CF_BY_ENQ}/${codeEnquete}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getContrat = (codecontrat, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_CONTRAT}/${codecontrat}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postSoussigneContrat = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_SOUSSIGNE_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const updateSoussigneContrat = (person_id, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.PUT_SOUSSIGNE_CONTRAT}/${person_id}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postContrat = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const updateContrat = (code_contrat, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.UPDATE_CONTRAT}/${code_contrat}`;
  // Make the GET request with the constructed URL
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteContrat = (codecontrat, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_DELETE_CONTRAT}/${codecontrat}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getEnqueteByUser = (payload) =>
  apis.get(API_URLS_PRESFOR.GET_ENQUETE_USER, payload);

export const getEnqueteAll = (payload) =>
  apis.get(API_URLS_PRESFOR.GET_ENQUETE_ALL, payload);

export const getOnlyEnqueteAll = (payload) => {
  const url = `${API_URLS_PRESFOR.GET_ONLY_ENQUETE_ALL}?with_dcf=${payload.with_dcf}&with_contract=${payload.with_contract}&with_isf=${payload.with_isf}`;
  return apis.get(url, payload);
};

export const checkEnqueteNumero = (payload) =>
  apis.post(API_URLS_PRESFOR.GET_ONLY_ENQUETE_ALL_CLIENT, {
    ...payload,
    headers: { ...payload?.headers },
  });

export const postDemandeClient = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_DCF_DEMANDE_CLIENT, {
    ...payload,
    headers: { ...payload?.headers },
  });

export const createClientEnquete = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_ENQUETE_CLIENT, {
    ...payload,
    headers: { ...payload?.headers },
  });

// export const createClientEnquete = async (payload) => {
//   return apis.post(API_URLS_PRESFOR.POST_ENQUETE_CLIENT, payload)
//     .then(response => {
//       return response.data;
//     })
//     .catch(error => {
//       console.error("Erreur lors de l'envoi de l'enquête :", error);
//       throw error;
//     });
// }

export const getContratAll = (payload) =>
  apis.get(API_URLS_PRESFOR.GET_CONTRAT_ALL, payload);

export const getContratsTransmis = (page, limit, numeroDossier, sousPrefecture, village) => {
  return apis.get(API_URLS_PRESFOR.GET_CONTRATS_TRANSMIS, {
    params: {
      page,
      limit,
      ...(numeroDossier ? { numeroDossier } : {}),
      ...(sousPrefecture ? { code_sp: sousPrefecture } : {}),
      ...(village ? { code_vil: village } : {}),
    },
  });
};
export const getCommuneVil = (codecommune, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_COMMUNE_VIL}/${codecommune}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getSpCommune = (codesp, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_SP_COMMUNE}/${codesp}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getDepSp = (codedep, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_DEP_SP}/${codedep}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const regionDep = (coderegion, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_REGION_DEP}/${coderegion}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getRegions = (payload) =>
  apis.get(API_URLS_PRESFOR.GET_REGIONS, payload);

export const postUserResendEmail = (payload) =>
  apis.post(API_URLS_PRESFOR.POST_USER_RESEND_EMAIL, payload);

export const postUserConfirmEmail = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_USER_CONFIRM_EMAIL, payload);
};

export const postEnquete = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ENQUETE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const signinUser = (payload) =>
  apis.post(API_URLS_PRESFOR.SIGNIN_USER, payload);

export const signupUser = (payload) =>
  apis.post(API_URLS_PRESFOR.SIGNUP_USER, payload);

export const listUser = (payload) =>
  apis.post(API_URLS_PRESFOR.LIST_USER, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

// api for Contrat and User Management
const createHeaders = (accessToken) => ({
  Authorization: `Bearer ${accessToken}`,
  'Content-Type': 'application/json',
});

export const listUsersApi = (accessToken, page = 1, limit = 10) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));
  return apis.get(
    `${COMMON_URL_PRESFOR}user/all?page=${validPage}&limit=${validLimit}`,
    {
      headers: createHeaders(accessToken),
    }
  );
};

// export const listUsersByTargetRegionsApi = (accessToken) => {
//   return apis.get(`${COMMON_URL_PRESFOR}user/all/target-regions`, {
//     headers: createHeaders(accessToken),
//   });
// };

export const listDeteledUsersApi = (accessToken) => {
  return apis.get(`${COMMON_URL_PRESFOR}user/all-user-trashed`, {
    headers: createHeaders(accessToken),
  });
};

export const listContractsApi = (accessToken) => {
  return apis.get(`${COMMON_URL_PRESFOR}contrat/total-contract`, {
    headers: createHeaders(accessToken),
  });
};

export const listDcfApi = (accessToken) => {
  return apis.get(`${COMMON_URL_PRESFOR}certificat-foncier/total-dcf`, {
    headers: createHeaders(accessToken),
  });
};

export const listPvConstatApi = (accessToken) => {
  return apis.get(`${COMMON_URL_PRESFOR}dtv/total-pv-constat`, {
    headers: createHeaders(accessToken),
  });
};

export const getUserApi = (accessToken, userId) => {
  return apis.get(`${COMMON_URL_PRESFOR}user/${userId}`, {
    headers: createHeaders(accessToken),
  });
};

export const checkAdmin = () => {
  return apis.get(`${COMMON_URL_PRESFOR}user/check-admin`, {});
};

export const changePassword = async (accessToken, userId, data) => {
  try {
    const response = await axios.put(
      `${COMMON_URL_PRESFOR}user/change-password/${userId}`,
      data,
      {
        headers: createHeaders(accessToken),
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const deleteUserApi = (accessToken, userId) => {
  return apis.delete(`${COMMON_URL_PRESFOR}user/${userId}`, {
    headers: createHeaders(accessToken),
  });
};

export const recoveryUserApi = (accessToken, userId) => {
  return apis.put(`${COMMON_URL_PRESFOR}user/recover/${userId}`, {
    headers: createHeaders(accessToken),
  });
};

export const getallCf = (payload) =>
  apis.get(`${COMMON_URL_PRESFOR}certificat-foncier/cf/all`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

// export const getAllDcfClient = () =>{
//   apis.get(API_URLS_PRESFOR.GET_ALL_DCF_CLIENT);
//   };

export const getAllDcfClient = (payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_ALL_DCF_CLIENT}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getallDcf = (payload, numero_enquete = null) =>
  apis.get(
    `${COMMON_URL_PRESFOR}${numero_enquete
      ? 'certificat-foncier/by-enquete/' + numero_enquete
      : 'certificat-foncier/list-dcf'
    }`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );

export const updateUser = async (payload, userId) => {
  return apis.put(`${COMMON_URL_PRESFOR}user/${userId}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateFicheDemo = (code_pvrdc, payload) => {
  return apis.put(
    `${COMMON_URL_PRESFOR}pvrdc/update-fiche-demo/${code_pvrdc}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const addFicheDemoDate = (payload) =>
  apis.post(`${COMMON_URL_PRESFOR}pvrdc/add-fiche-demo`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const addSignatairesDesignGestDate = (payload) => {
  return apis.post(`${COMMON_URL_PRESFOR}pvrdc/add-design-gestion`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateclp = (code_clp, payload) =>
  apis.put(`${COMMON_URL_PRESFOR}clp/update-clp/${code_clp}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const updatelppcl = (lppclId, payload) => {
  const apiUrl = `${COMMON_URL_PRESFOR}clp/update-clp-lppc/${lppclId}`;
  return apis.put(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateUserStatus = async (payload, userId) => {
  return apis.put(`${COMMON_URL_PRESFOR}user/active/${userId}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateUserRole = async (payload, userId) => {
  return apis.put(`${COMMON_URL_PRESFOR}user/add-role/${userId}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// statisticsApi.js

export const fetchUserData = async (accessToken) => {
  try {
    const response = await axios.get(`${COMMON_URL_PRESFOR}user/all`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response?.data?.data || [];
  } catch (error) {
    console.error('Error fetching contract data:', error);
    throw error;
  }
};

export const fetchContractData = async (accessToken, numero_enquete = null) => {
  try {
    const response = await axios.get(
      `${COMMON_URL_PRESFOR}${numero_enquete ? 'contrat/by-enquete/' + numero_enquete : 'contrat/all'
      }`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return numero_enquete ? response.data || [] : response?.data?.data || [];
  } catch (error) {
    console.error('Error fetching contract data:', error);
    throw error;
  }
};

export const fetchAllVillages = async (accessToken, sousPrefecture) => {
  try {
    const url = sousPrefecture
      ? `${COMMON_URL_PRESFOR}codification/village-by-sp/${sousPrefecture}`
      : `${COMMON_URL_PRESFOR}codification/all-villages`;

    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    const raw = response?.data;
    return Array.isArray(raw) ? raw : raw?.data || [];
  } catch (error) {
    console.error('Error fetching all villages:', error);
    throw error;
  }
};

export const findNumeroEnqueteForRegion = async (accessToken, region) => {
  try {
    // Fetch data to get numero_enquete for the selected region
    const response = await axios.get(
      `${COMMON_URL_PRESFOR}enquete/by-region/${region}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    // Assuming the response is an array
    const data = response?.data?.data || [];
    return data;
  } catch (error) {
    console.error(`Error fetching numero_enquete for region ${region}:`, error);
    throw error; // Propagate the error for the caller to handle
  }
};

export const fetchCertificateData = async (
  accessToken,
  numero_enquete = null
) => {
  try {
    const response = await axios.get(
      `${COMMON_URL_PRESFOR}${numero_enquete
        ? 'certificat-foncier/by-enquete/' + numero_enquete
        : 'certificat-foncier/cf/all'
      }`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return numero_enquete ? response.data || [] : response?.data?.data || [];
  } catch (error) {
    console.error('Error fetching contract data:', error);
    throw error;
  }
};

export const fetchCertificateDataByEnquete = async (accessToken) => {
  try {
    const response = await axios.get(
      `${COMMON_URL_PRESFOR}certificat-foncier/list-dcf`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // console.log(response);
    return response.data || [];
  } catch (error) {
    console.error('Error fetching certificate data:', error);
    throw error;
  }
};

export const fetchDcfData = async (accessToken, numero_enquete = null) => {
  try {
    const response = await axios.get(
      `${COMMON_URL_PRESFOR}${numero_enquete
        ? 'certificat-foncier/by-enquete/' + numero_enquete
        : 'certificat-foncier/list-dcf'
      }`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    // console.log(response);
    return numero_enquete ? response.data || [] : response?.data?.data || [];
  } catch (error) {
    console.error('Error fetching contract data:', error);
    throw error;
  }
};

export const getOneOta = (id, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_ONE_OTA}/${id}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const listAllOtaApi = (payload) => {
  const apiUrl = `${COMMON_URL_PRESFOR}ota/all`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addOtaApi = (payload) =>
  apis.post(API_URLS_PRESFOR.ADD_OTA, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const deleteOtaApi = (accessToken, otaId) => {
  return apis.delete(`${COMMON_URL_PRESFOR}ota/${otaId}`, {
    headers: createHeaders(accessToken),
  });
};

export const updateOtaApi = async (accessToken, otaId, otaData) => {
  try {
    const response = await axios.put(
      `${COMMON_URL_PRESFOR}ota/${otaId}`,
      otaData,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const recoveryOtaApi = (accessToken, otaId) => {
  return apis.put(`${COMMON_URL_PRESFOR}ota/recover/${otaId}`, {
    headers: createHeaders(accessToken),
  });
};

export const listDeteledOtasApi = (accessToken) => {
  return apis.get(`${COMMON_URL_PRESFOR}ota/all-ota-trashed`, {
    headers: createHeaders(accessToken),
  });
};

export const getVillagesByCodeSpVil = (code_enquete) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_VILLAGES_BY_CODE_ENQUETE}/${code_enquete}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// export const createDcfAnpPdfs = (payload) => {
//   return apis.post(API_URLS_PRESFOR.CREATE_DCF_ANP_PDFS, {
//     ...payload,
//     headers: { 'Content-Type': 'application/json', ...payload?.headers },
//   });
// }

export const post_tv_Histo = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_DTV_HISTO, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDtvAttestationApprobationEnquete = (payload) => {
  console.log(payload);
  return apis.post(API_URLS_PRESFOR.POST_ATTESTATION_APPROBATION_ENQUETE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDtvAttestationValidationEnquete = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ATTESTATION_VALIDATION_ENQUETE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getParticipantsAttestationValidationEnqueteFonciereRurale = (
  code_enquete
) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_PARTICIPANTS_ATTESTATION_VALIDATION_ENQUETE_RURAL}/${code_enquete}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getEnqueteDtv = (numero_enquete) => {
  return apis.get(`${API_URLS_PRESFOR.GET_DTV_BY_ENQUETE}/${numero_enquete}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const putDtvAttestationApprobationEnquete = (id, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.PUT_ATTESTATION_APPROBATION_ENQUETE}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const putDtvAttestationValidationEnquete = (id, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.PUT_ATTESTATION_VALIDATION_ENQUETE}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const put_tv_Histo = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.POST_DTV_HISTO}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getTroncons = (code_pvrdc, page = 1, limit = 10) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));
  return apis.get(`${API_URLS_PRESFOR.GET_TRONCONS}/${code_pvrdc}`, {
    params: {
      page: validPage,
      limit: validLimit,
    },
    headers: { 'Content-Type': 'application/json' },
    params: { page, limit },
  });
};

export const createTroncon = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_TRONCON}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateTroncon = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_TRONCON}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteTroncon = (payload) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_TRONCON}/${payload}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteTronconByEnquete = (payload) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_TRONCON_ALL}/${payload}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDTVANP = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_DTV_ANP, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putDTVANP = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_DTV_ANP}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postDTVANPO = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_DTV_ANPO, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};
export const putDTVANPO = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_DTV_ANPO}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const createAnpc = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_ANPC}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvHisto = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_PV_HISTO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postHistoPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_HISTO_PIECE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const deleteDTVANP = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_DTV_ANP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteDTVANPO = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_DTV_ANPO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postANPPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ANP_PIECE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postANPOPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ANPO_PIECE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};
export const getAnpByEnquete = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ANP_BY_ENQUETE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const putAnpc = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.UPDATE_DTV_ANPC}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteAnpc = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_DTV_ANPC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteDtvAttestationApprobationEnquete = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ATTESTATION_APPROBATION_ENQUETE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const deleteDtvAttestationValidationEnquete = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ATTESTATION_VALIDATION_ENQUETE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadAnpcPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPLOAD_DTV_ANPC, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadApprobPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPLOAD_ATTESTATION_APPROBATION_ENQUETE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadValidationPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPLOAD_ATTESTATION_VALIDATION_ENQUETE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updloadPVLIM = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPLOAD_PVLIM, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const genererPdfConstatLimiteTroncon = async (payload) => {
  return await apis.post(API_URLS_PRESFOR.GENERER_PDF_CONSTAT_LIMITE_TRONCON, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const addIsfCalendrierOuverture = (payload) => {
  // console.log(payload);
  return apis.post(API_URLS_PRESFOR.POST_CALENDRIER_OUVERTURE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};
export const getIsfCalendrierOuverture = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_CALENDRIER_OUVERTURE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCalendrierOuverture = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_CALENDRIER_OUVERTURE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const genererPdfIsfCalendrierOuverture = (id) => {
  return apis.get(
    `${API_URLS_PRESFOR.GENERER_PDF_CALENDRIER_OUVERTURE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const updateIsfCalendrierOuverture = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_CALENDRIER_OUVERTURE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCalendrierOuverture = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_CALENDRIER_OUVERTURE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addIsfListePresenceContact = (payload) => {
  // console.log(payload);
  return apis.post(API_URLS_PRESFOR.POST_LISTE_PRESENCE_CONTACT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};
export const getIsfListePresenceContact = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_LISTE_PRESENCE_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfListePresenceContact = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_LISTE_PRESENCE_CONTACT}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const genererPdfIsfListePresenceContact = (id) => {
  return apis.get(
    `${API_URLS_PRESFOR.GENERER_PDF_LISTE_PRESENCE_CONTACT}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const updateIsfListePresenceContact = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_LISTE_PRESENCE_CONTACT}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfListePresenceContact = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_LISTE_PRESENCE_CONTACT}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addIsfCompteRenduContact = (payload) => {
  // console.log(payload);
  return apis.post(API_URLS_PRESFOR.POST_COMPTE_RENDU_CONTACT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};
export const getIsfCompteRenduContact = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_COMPTE_RENDU_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCompteRenduContact = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_COMPTE_RENDU_CONTACT}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const genererPdfIsfCompteRenduContact = (id) => {
  return apis.get(
    `${API_URLS_PRESFOR.GENERER_PDF_COMPTE_RENDU_CONTACT}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const updateIsfCompteRenduContact = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_COMPTE_RENDU_CONTACT}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCompteRenduContact = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_COMPTE_RENDU_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postDecisionIsfCvgfr = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_DECISION_ISF_CVGFR, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putDecisionIsfCvgfr = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_DECISION_ISF_CVGFR}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getDecisionIsfCvgfr = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_DECISION_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteDecisionIsfCvgfr = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_DECISION_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const genererPdfDecisionIsfCvgfr = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GENERER_PDF_DECISION_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfDecisionIsfCvgfr = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_DECISION_ISF_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postPvConstitutionCvgfr = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PV_CONSTITUTION_CVGFR, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putPvConstitutionCvgfr = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_PV_CONSTITUTION_CVGFR}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getPvConstitutionCvgfr = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_PV_CONSTITUTION_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deletePvConstitutionCvgfr = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_PV_CONSTITUTION_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const genererPdfPvConstitutionCvgfr = (id) => {
  return apis.get(
    `${API_URLS_PRESFOR.GENERER_PDF_PV_CONSTITUTION_CVGFR}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfPvConstitutionCvgfr = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_PV_CONSTITUTION_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postLivrableIsfCvgfr = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_LIVRABLE_ISF_CVGFR, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putLivrableIsfCvgfr = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_LIVRABLE_ISF_CVGFR}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteLivrableIsfCvgfr = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_LIVRABLE_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfLivrableIsfCvgfr = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_LIVRABLE_ISF_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const genererPdfLivrableIsfCvgfr = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GENERER_PDF_LIVRABLE_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getLivrableIsfCvgfr = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_LIVRABLE_ISF_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getIsfCahiersIntentionsCF = (id, page = 1, limit = 10) => {
  const validPage = Math.max(1, parseInt(page, 10) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit, 10) || 10));

  return apis.get(`${API_URLS_PRESFOR.GET_CACHIERS_INTENTIONS_CF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
    params: { page: validPage, limit: validLimit },
  });
};

export const addIsfCahiersIntentionsCF = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_CACHIERS_INTENTIONS_CF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfCahiersIntentionsCF = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_CACHIERS_INTENTIONS_CF}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const genererPdfIsfRapportVillage = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GENERER_PDF_ISF_RAPPORT_VILLAGE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getIsfCahiersIntentionsContrat = (id, page = 1, limit = 10) => {
  const validPage = Math.max(1, parseInt(page, 10) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit, 10) || 10));

  return apis.get(`${API_URLS_PRESFOR.GET_CACHIERS_INTENTIONS_CONTRAT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
    params: { page: validPage, limit: validLimit },
  });
};

export const addIsfCahiersIntentionsContrat = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_CACHIERS_INTENTIONS_CONTRAT, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfCahiersIntentionsContrat = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_CACHIERS_INTENTIONS_CONTRAT}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfIsfCahiersIntentionsCF = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_CACHIERS_INTENTIONS_CF}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const deleteIsfIsfCahiersIntentionsContrat = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_CACHIERS_INTENTIONS_CONTRAT}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfIsfCahiersIntentionsDCF = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_CACHIERS_INTENTIONS_CF}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfIsfCahiersIntentionsDCC = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_CACHIERS_INTENTIONS_CONTRAT}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const addIsfDeclarationOuverture = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ISF_DECLARATION_OUVERTURE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfDeclarationOuverture = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_ISF_DECLARATION_OUVERTURE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfDeclarationOuvertureture = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ISF_DECLARATION_OUVERTURE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfIsfDeclarationOuvertureture = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_ISF_DECLARATION_OUVERTURE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getIsfDeclarationOuvertureture = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ISFR_DECLARATION_OUVERTURE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addIsfCeremonieOuverture = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ISF_CEREMONIE_OUVERTURE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfCeremonieOuverture = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_ISF_CEREMONIE_OUVERTURE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCeremonieOuvertureture = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ISF_CEREMONIE_OUVERTURE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfIsfCeremonieOuvertureture = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_ISF_CEREMONIE_OUVERTURE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getIsfCeremonieOuvertureture = (id, page = 1, limit = 10) => {
  const validPage =
    Number.isFinite(Number(page)) && Number(page) > 0 ? Number(page) : 1;
  const validLimit =
    Number.isFinite(Number(limit)) && Number(limit) > 0 ? Number(limit) : 10;
  return apis.get(`${API_URLS_PRESFOR.GET_ISFR_CEREMONIE_OUVERTURE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
    params: {
      page: validPage,
      limit: validLimit,
    },
  });
};

export const addIsfCoCompteRendu = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ISF_COMPTE_RENDU, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfCoCompteRendu = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_ISF_COMPTE_RENDU}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCoCompteRendu = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_ISF_COMPTE_RENDU}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCoCompteRendu = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_ISF_COMPTE_RENDU}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getIsfCoCompteRendu = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ISF_COMPTE_RENDU}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postIsfRapportVillage = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ISF_RAPPORT_VILLAGE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfRapportVillage = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ISF_RAPPORT_VILLAGE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const putIsfRapportVillage = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_ISF_RAPPORT_VILLAGE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfRapportVillage = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_ISF_RAPPORT_VILLAGE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfRapportVillage = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_ISF_RAPPORT_VILLAGE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postIsfCalendrierPrev = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ISF_CALENDRIER_PREV, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfCalendrierPrev = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ISF_CALENDRIER_PREV}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const putIsfCalendrierPrev = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_ISF_CALENDRIER_PREV}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCalendrierPrev = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_ISF_CALENDRIER_PREV}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCalendrierPrev = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_ISF_CALENDRIER_PREV}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postIsfCourrierTrans = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ISF_COURRIER_TRANS, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postIsfFermetureCeremonie = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_ISF_FERMETURE_CEREMONIE, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfCourrierTrans = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ISF_COURRIER_TRANS}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const putIsfCourrierTrans = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_ISF_COURRIER_TRANS}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfCourrierTrans = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_ISF_COURRIER_TRANS}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfCourrierTrans = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_ISF_COURRIER_TRANS}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};
// export const authUserWithToken = (token) => {
//   return apis.get(`${API_URLS_PRESFOR.LOGIN_WITH_TOKEN}?token=${token}`, {
//     headers: { 'Content-Type': 'application/json' },
//   });
// };

// export const getUser = (id) => {
//   return apis.get(`${API_URLS_PRESFOR.GET_USER}/${id}`, {
//     headers: { 'Content-Type': 'application/json', },
//   });
// };

export const getUser = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.GET_USER}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const authUserWithToken = async (token) => {
  return await apis.get(`${API_URLS_PRESFOR.LOGIN_WITH_TOKEN}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getReglementInterieurCvgfr = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_REGLEMENT_INTERIEUR_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfReglementInterieurCvgfr = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_REGLEMENT_INTERIEUR_CVGFR}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const generatePdfReglementInterieurCvgfr = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.GENERER_PDF_REGLEMENT_INTERIEUR_CVGFR}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const deleteReglementInterieurCvgfr = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_REGLEMENT_INTERIEUR_CVGFR}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

//create & update
export const createReglementInterieurCvgfr = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_REGLEMENT_INTERIEUR_CVGFR}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateReglementInterieurCvgfr = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_REGLEMENT_INTERIEUR_CVGFR}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getAttestationFormationCvgfr = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ATTESTATION_FORMATION_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfAttestationFormationCvgfr = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_ATTESTATION_FORMATION_CVGFR}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const generatePdfAttestationFormationCvgfr = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.GENERER_PDF_ATTESTATION_FORMATION_CVGFR}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const deleteAttestationFormationCvgfr = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ATTESTATION_FORMATION_CVGFR}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const createAttestationFormationCvgfr = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_ATTESTATION_FORMATION_CVGFR}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateAttestationFormationCvgfr = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_ATTESTATION_FORMATION_CVGFR}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getListePresenceFormationCvgfr = (id, page = 1, limit = 10) => {
  const validPage =
    Number.isFinite(Number(page)) && Number(page) > 0 ? Number(page) : 1;
  const validLimit =
    Number.isFinite(Number(limit)) && Number(limit) > 0 ? Number(limit) : 10;
  return apis.get(
    `${API_URLS_PRESFOR.GET_LISTE_PRESENCE_FORMATION_CVGFR}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
      params: {
        page: validPage,
        limit: validLimit,
      },
    }
  );
};

export const addListePresenceFormationCvgfr = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_LISTE_PRESENCE_FORMATION_CVGFR}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateListePresenceFormationCvgfr = (id, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.PUT_LISTE_PRESENCE_FORMATION_CVGFR}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const deleteListePresenceFormationCvgfr = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_LISTE_PRESENCE_FORMATION_CVGFR}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfIsfPresforListePresenceFormationCvgfr = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_LISTE_PRESENCE_FORMATION_CVGFR}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const generatePdfListePresenceFormationCvgfr = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.GENERER_PDF_LISTE_PRESENCE_FORMATION_CVGFR}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

// export const getReunionPeriodiqueDecisionSousPrefectorale = (id) => {
//   return apis.get(`${API_URLS_PRESFOR.GET_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}/${id}`, {
//     headers: { 'Content-Type': 'application/json' },
//   });
// };

export const postReunionPeriodiqueDecisionSousPrefectorale = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.POST_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const putReunionPeriodiqueDecisionSousPrefectorale = (id, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.PUT_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const deleteReunionPeriodiqueDecisionSousPrefectorale = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfReunionPeriodiqueDecisionSousPrefectorale = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const generatePdfReunionPeriodiqueDecisionSousPrefectorale = (
  payload
) => {
  return apis.post(
    `${API_URLS_PRESFOR.GENERER_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getReunionPeriodique = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_REUNION_PERIODIQUE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postReunionPeriodiqueResume = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_REUNION_PERIODIQUE_RESUME}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putReunionPeriodiqueResume = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_REUNION_PERIODIQUE_RESUME}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteReunionPeriodiqueResume = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_REUNION_PERIODIQUE_RESUME}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfReunionPeriodiqueResume = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_REUNION_PERIODIQUE_RESUME}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const generatePdfReunionPeriodiqueResume = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.GENERER_PDF_REUNION_PERIODIQUE_RESUME}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const postPvcfidcp = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_PVCFIDCP}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putPvcfidcp = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_PVCFIDCP}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPvcfidci = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_PVCFIDCI}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putPvcfidci = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_PVCFIDCI}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postPvcfidcc = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_PVCFIDCC}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const putPvcfidcc = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_PVCFIDCC}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvcfid = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_PVCFIDC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deletePvcfidc = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_PVCFIDC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const deletePvcfidci = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_PVCFIDCI}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deletePvcfidcp = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_PVCFIDCP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deletePvcfidcc = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_PVCFIDCC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfPvcfid = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_PVCFIDC}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfPvcfidcp = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_PVCFIDCP}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfPvcfidcc = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_PVCFIDCC}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfPvcfidci = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_PVCFIDCI}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfPvcfidc = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_PVCFIDC}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getDialogueSocial = (id, page = 1, limit = 10) => {
  const validPage =
    Number.isFinite(Number(page)) && Number(page) > 0 ? Number(page) : 1;
  const validLimit =
    Number.isFinite(Number(limit)) && Number(limit) > 0 ? Number(limit) : 10;
  return apis.get(`${API_URLS_PRESFOR.GET_DIALOGUE_SOCIAL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
    params: {
      page: validPage,
      limit: validLimit,
    },
  });
};

export const addCalendrierPrevisionnel = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_CALENDRIER_PREVISIONEL}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateCalendrierPrevisionnel = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_CALENDRIER_PREVISIONEL}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getCalendrierPrevisionnel = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_CALENDRIER_PREVISIONEL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteCalendrierPrevisionnel = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_CALENDRIER_PREVSIONNEL}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadCalendrierPrevisionnel = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_CALENDRIER_PREVISIONNEL}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getPvrlf = (id, page = 1, limit = 10) => {
  const validPage =
    Number.isFinite(Number(page)) && Number(page) > 0 ? Number(page) : 1;
  const validLimit =
    Number.isFinite(Number(limit)) && Number(limit) > 0 ? Number(limit) : 10;
  return apis.get(
    `${API_URLS_PRESFOR.GET_PROCES_VERBAL_REGLEMENT_LITIGE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
      params: {
        page: validPage,
        limit: validLimit,
      },
    }
  );
};

export const deletePvrlf = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_PROCES_VERBAL_REGLEMENT_LITIGE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addPvrl = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_PROCES_VERBAL_REGLEMENT_LITIGE}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updatePvrlf = (id, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.PUT_PROCES_VERBAL_REGLEMENT_LITIGE}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const uploadPdfIsfPresforPvrlf = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_PROCES_VERBAL_REGLEMENT_LITIGE}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const addIsfDemandeIdentite = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_ISF_DEMANDE_IDENTITE}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfDemandeIdentite = (id, page = 1, limit = 10) => {
  const validPage =
    Number.isFinite(Number(page)) && Number(page) > 0 ? Number(page) : 1;
  const validLimit =
    Number.isFinite(Number(limit)) && Number(limit) > 0 ? Number(limit) : 10;
  return apis.get(`${API_URLS_PRESFOR.GET_ISF_DEMANDE_IDENTITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
    params: {
      page: validPage,
      limit: validLimit,
    },
  });
};

export const updateIsfDemandeIdentite = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_ISF_DEMANDE_IDENTITE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfDemandeIdentite = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_ISF_DEMANDE_IDENTITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfDemandeIdentite = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_ISF_DEMANDE_IDENTITE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const addProcesVerbalConstatAchevement = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_ISF_PROCES_VERBAL_ACHEVEMENT}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getProcesVerbalConstatAchevement = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_PROCES_VERBAL_ACHEVEMENT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateProcesVerbalConstatAchevement = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_PROCES_VERBAL_ACHEVEMENT}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteProcesVerbalConstatAchevement = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_PROCES_VERBAL_ACHEVEMENT}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfProcesVerbalConstatAchevement = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_ISF_PROCES_VERBAL_ACHEVEMENT}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};
// Ajouter une charte relation tuteur-planteur
export const addCharteRelationTuteurPlanteur = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_CHARTERELATION}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// Récupérer une charte par ID
export const getCharteRelationTuteurPlanteur = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_CHARTERELATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Mettre à jour une charte relation tuteur-planteur
export const updateCharteRelationTuteurPlanteur = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_CHARTERELATION}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// Supprimer une charte relation tuteur-planteur
export const deleteCharteRelationTuteurPlanteur = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_CHARTERELATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Upload PDF pour une charte relation tuteur-planteur
export const uploadPdfCharteRelationTuteurPlanteur = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOADS_CHARTE_PDF}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

// Ajouter un protocole de gestion foncière
export const addProtocoleGestionFonciere = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_NEW_PGF}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// Récupérer un protocole par numéro d'enquête
export const getProtocoleGestionFonciere = (numero_enquete) => {
  return apis.get(`${API_URLS_PRESFOR.GET_PGF_BY_NUMERO}/${numero_enquete}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Mettre à jour un protocole de gestion foncière
export const updateProtocoleGestionFonciere = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_UPDATE_PGF}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// Supprimer un protocole de gestion foncière
export const deleteProtocoleGestionFonciere = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_PGF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Upload PDF pour un protocole de gestion foncière
export const uploadPdfProtocoleGestionFonciere = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_UPLOAD_PGF_PDF}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const addIsfRapportActivite = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_ISF_RAPPORT_ACTIVITE}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfRapportActivite = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ISF_RAPPORT_ACTIVITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addGuideEntretien = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_ISF_GUIDE_ENTRETIEN}`, payload, {
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getGuideEntretien = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_GUIDE_ENTRETIEN}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateGuideEntretien = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_GUIDE_ENTRETIEN}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteGuideEntretien = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_GUIDE_ENTRETIEN}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadGuideEntretien = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_ISF_GUIDE_ENTRETIEN}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const addRapportIsfSensibilisation = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.POST_ISF_RAPPORT_SENSIBILISATION_ISF}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getRapportIsfSensibilisation = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_RAPPORT_SENSIBILISATION_ISF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateRapportIsfSensibilisation = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_RAPPORT_SENSIBILISATION_ISF}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteRapportIsfSensibilisation = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_RAPPORT_SENSIBILISATION_ISF}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadRapportIsfSensibilisation = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_ISF_RAPPORT_SENSIBILISATION_ISF}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};
export const getIsfSensibilisation = (id, page = 1, limit = 10) => {
  const validPage =
    Number.isFinite(Number(page)) && Number(page) > 0 ? Number(page) : 1;
  const validLimit =
    Number.isFinite(Number(limit)) && Number(limit) > 0 ? Number(limit) : 10;
  return apis.get(`${API_URLS_PRESFOR.GET_ISF_SENSIBILISATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
    params: {
      page: validPage,
      limit: validLimit,
    },
  });
};

export const addIsfSensibilisation = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_ISF_SENSIBILISATION}`, payload, {
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfSensibilisation = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_ISF_SENSIBILISATION}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfSensibilisation = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_ISF_SENSIBILISATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadIsfSensibilisation = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_ISF_SENSIBILISATION}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updateIsfRapportActivite = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_ISF_RAPPORT_ACTIVITE}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfRapportActivite = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_ISF_RAPPORT_ACTIVITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfRapportActivite = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_ISF_RAPPORT_ACTIVITE}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getIsfRecueilPersonnelles = (id) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_ISF_RECUEIL_DONNEES_PERSONNELLES}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addIsfRecueilPersonnelles = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.POST_ISF_RECUEIL_DONNEES_PERSONNELLES}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const updateIsfRecueilPersonnelles = (id, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.PUT_ISF_RECUEIL_DONNEES_PERSONNELLES}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const deleteIsfRecueilPersonnelles = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ISF_RECUEIL_DONNEES_PERSONNELLES}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadIsfRecueilPersonnelles = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_ISF_RECUEIL_DONNEES_PERSONNELLES}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const getAllPrefecture = (payload) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ALL_PREFECTURE}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getIsfCalendrierOuvertureByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_CALENDRIER_OUVERTURE_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getIsfRecueilPersonnellesByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_RECUEIL_DONNEES_PERSONNELLES_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getIsfCeremonieOuverturetureByCodeSp = (
  code_sp,
  page = 1,
  limit = 10
) => {
  const validPage =
    Number.isFinite(Number(page)) && Number(page) > 0 ? Number(page) : 1;
  const validLimit =
    Number.isFinite(Number(limit)) && Number(limit) > 0 ? Number(limit) : 10;
  return apis.get(
    `${API_URLS_PRESFOR.GET_ISF_CEREMONIE_OUVERTURE_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
      params: {
        page: validPage,
        limit: validLimit,
      },
    }
  );
};

export const getIsfDeclarationOuvertureByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_ISF_DECLARATION_OUVERTURE_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const updateIsfDeclarationOuvertureSp = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.PUT_ISF_DECLARATION_OUVERTURE_SP}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getDtvRapportActivites = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_DTV_RAPPORT_ACTIVITES}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const addDtvRapportActivites = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_DTV_RAPPORT_ACTIVITES}`, payload, {
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateDtvRapportActivites = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_DTV_RAPPORT_ACTIVITES}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteDtvRapportActivites = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_DTV_RAPPORT_ACTIVITES}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteDtvAllRapportActivites = (numero_enquete) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_DTV_ALL_RAPPORT_ACTIVITES}/${numero_enquete}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadDtvRapportActivites = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_DTV_RAPPORT_ACTIVITES}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const deleteIsfDeclarationOuverturetureBySp = (code_sp) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ISF_DECLARATION_OUVERTURE_BY_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addIsfDeclarationOuvertureSp = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_ISF_DECLARATION_OUVERTURE_SP}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getLivrableIsfCvgfrByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_LIVRABLE_ISF_CVGFR_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postReunionPeriodiqueDecisionSousPrefectoraleSp = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.POST_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getReunionPeriodiqueDecisionSousPrefectoraleSp = (code_sp) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getIsfCourrierTransByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_ISF_COURRIER_TRANSMISSION_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getReunionPeriodiqueByCodeSp = (code_sp) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_ISF_REUNION_PERIODIQUE_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const updateIsfCourrierTransByCodeSp = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.PUT_ISF_COURRIER_TRANSMISSION_BY_CODE_SP}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const deleteIsfCourrierTransByCodeSp = (code_sp) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ISF_COURRIER_TRANSMISSION_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const putReunionPeriodiqueDecisionSousPrefectoraleSp = (id, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.PUT_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const deleteReunionPeriodiqueDecisionSousPrefectoraleSp = (code_sp) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfReunionPeriodiqueDecisionSousPrefectoraleSp = (
  payload
) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_REUNION_PERIODIQUE_DECISION_SOUS_PREFECTORALE_SP}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const addReunionPeriodiqueByCodeSp = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_ISF_REUNION_PERIODIQUE_SP}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateReunionPeriodiqueByCodeSp = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPDATE_ISF_REUNION_PERIODIQUE_SP}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteReunionPeriodiqueByCodeSp = (code_sp) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ISF_REUNION_PERIODIQUE_BY_CODE_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfReunionPeriodiqueSp = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_REUNION_PERIODIQUE_SP}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const uploadPdfIsfDeclarationOuverturetureSp = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_ISF_DECLARATION_OUVERTURE_SP}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const getEnqueteByCodeSp = (code_sp) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ENQUETE_BY_CODE_SP}/${code_sp}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postPVCLWithDcf = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_PVCL_WITH_DCF}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfComplementaireInformationSensibilisation = (id) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const deleteIsfComplementaireInformationSensibilisation = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addIsfComplementaireInformationSensibilisation = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.POST_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const updateIsfComplementaireInformationSensibilisation = (
  id,
  payload
) => {
  return apis.put(
    `${API_URLS_PRESFOR.UPDATE_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const uploadPdfIsfComplementaireInformationSensibilisation = (
  payload
) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_ISF_COMPLEMENTAIRE_INFORMATION_SENSIBILISATION}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const getIsfComplementaireFacilitation = (id) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_ISF_COMPLEMENTAIRE_FACILITATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const deleteIsfComplementaireFacilitation = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ISF_COMPLEMENTAIRE_FACILITATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addIsfComplementaireFacilitation = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_ISF_COMPLEMENTAIRE_FACILITATION}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfComplementaireFacilitation = (id, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.UPDATE_ISF_COMPLEMENTAIRE_FACILITATION}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const uploadPdfIsfComplementaireFacilitation = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_ISF_COMPLEMENTAIRE_FACILITATION}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const getIsfComplementaireFormationEncadrement = (id) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const deleteIsfComplementaireFormationEncadrement = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addIsfComplementaireFormationEncadrement = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.POST_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const updateIsfComplementaireFormationEncadrement = (id, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.UPDATE_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT}/${id}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const uploadPdfIsfComplementaireFormationEncadrement = (payload) => {
  return apis.post(
    `${API_URLS_PRESFOR.UPLOAD_PDF_ISF_COMPLEMENTAIRE_FORMATION_ENCADREMENT}`,
    {
      ...payload?.data,
      headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
    }
  );
};

export const getDtvScanDocument = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_DTV_SCAN_DOCUMENT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteDtvScanDocument = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_DTV_SCAN_DOCUMENT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const deleteDtvAllScanDocument = (numero_enquete) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_DTV_ALL_SCAN_DOCUMENT}/${numero_enquete}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addDtvScanDocument = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_DTV_SCAN_DOCUMENT}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const updateDtvScanDocument = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.UPDATE_DTV_SCAN_DOCUMENT}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getTotalDcfLp = () => {
  return apis.get(`${API_URLS_PRESFOR.GET_TOTAL_DCF_LP}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const codificationSP = (code_sp) => {
  return apis.get(`${API_URLS_PRESFOR.VILLAGE_BY_SP}/${code_sp}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const enquetesBySp = (code_sp) => {
  return apis.get(`${API_URLS_PRESFOR.ENQUETE_BY_SP}/${code_sp}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getIntentionStatsMonthly = (year, month) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_TOTAL_DCF_LP_MONTH}?year=${year}&month=${month}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getDcfLpStatsByUser = (userId) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_TOTAL_DCF_LP_USER}?userId=${userId}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getActivitySummaryStats = () => {
  return apis.get(
    `${COMMON_URL_PRESFOR}isf-complementaire/stats/activity-summary`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getFacilitationByPeriod = () => {
  return apis.get(
    `${COMMON_URL_PRESFOR}isf-complementaire/stats/facilitation-by-period`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getTrainingStats = () => {
  return apis.get(
    `${COMMON_URL_PRESFOR}isf-complementaire/stats/training-stats`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getUserActivityStats = (userId) => {
  return apis.get(
    `${COMMON_URL_PRESFOR}isf-complementaire/stats/user-activity?userId=${userId}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getVillageParticipationStats = () => {
  return apis.get(
    `${COMMON_URL_PRESFOR}isf-complementaire/stats/village-participation`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getDelimitationStats = () => {
  return apis.get(`${COMMON_URL_PRESFOR}dtv/stats/delimitations`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getDelimitationStatsByRegion = () => {
  return apis.get(`${COMMON_URL_PRESFOR}dtv/stats/delimitations/region`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getTotalDeclarations = () => {
  return apis.get(`${COMMON_URL_PRESFOR}isf/stats/declarations/total`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getDemandeurBadge = (codecf, req) => {
  return apis.get(
    `${COMMON_URL_PRESFOR}certificat-foncier/demandeur-dcf-badge/${codecf}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectDcf = (code_dcf, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_DCF}/${code_dcf}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateDcf = (code_dcf) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_DCF}/${code_dcf}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectID = (code_id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REJECT_ID}/${code_id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postValidateID = (code_id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_ID}/${code_id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectPVRDC = (code_pvrdc, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_PVRDC}/${code_pvrdc}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidatePVRDC = (code_pvrdc) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_PVRDC}/${code_pvrdc}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectCECPDC = (code_constat, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_CECPDC}/${code_constat}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateCECPDC = (code_constat) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_CECPDC}/${code_constat}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectVALID = (code_constat, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_VALID}/${code_constat}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateVALID = (code_constat) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_VALID}/${code_constat}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectCLP = (code_clp, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_CLP}/${code_clp}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateCLP = (code_clp) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_CLP}/${code_clp}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectPVCL = (code_pvcl, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_PVCL}/${code_pvcl}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidatePVCL = (code_pvcl) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_PVCL}/${code_pvcl}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectANP = (code_annonce_pub, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_ANP}/${code_annonce_pub}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateANP = (code_annonce_pub) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_ANP}/${code_annonce_pub}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectANPO = (code_annonce_pub, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_ANPO}/${code_annonce_pub}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateANPO = (code_annonce_pub) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_ANPO}/${code_annonce_pub}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectANPC = (code_annonce_pub, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_ANPC}/${code_annonce_pub}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateANPC = (code_annonce_pub) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_ANPC}/${code_annonce_pub}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectCalendrierOuvertures = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_CALENDRIER_OUVERTURES}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateCalendrierOuvertures = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_CALENDRIER_OUVERTURES}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateCompteRenduPriseContact = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_COMPTE_RENDU_PRISE_CONTACT}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectCompteRenduPriseContact = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_COMPTE_RENDU_PRISE_CONTACT}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidatePriseContact = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_PRISE_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getValidationLivrable = (req) => {
  return apis.get(`${COMMON_URL_PRESFOR}validations/all`, {
    params: req,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectPriseContact = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_PRISE_CONTACT}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateRecueilDonnee = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_RECUEIL_DONNEE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectRecueilDonnee = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_RECUEIL_DONNEE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateDeclaration = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_DECLARATION_OUVERTURE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectDeclaration = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_DECLARATION_OUVERTURE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateCeremonie = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_CEREMONIE_OUVERTURE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectCeremonie = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_CEREMONIE_OUVERTURE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateCompteRendu = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_COMPTE_RENDU}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectCompteRendu = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_COMPTE_RENDU}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateRapportVillage = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_RAPPORT_VILLAGE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectRapportVillage = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_RAPPORT_VILLAGE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateCalendrier = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_CALENDRIER}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectCalendrier = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_CALENDRIER}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateCourrier = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_COURRIER}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectCourrier = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REJECT_COURRIER}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postValidateRapportIsf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_RAPPORT_ISF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectRapportIsf = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_RAPPORT_ISF}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateIS = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_INFORMATION_SENSIBILISATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectIS = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_INFORMATION_SENSIBILISATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateRegistreDcf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_REGISTRE_DCF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectRegistreDcf = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_REGISTRE_DCF}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateRegistreDcc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_REGISTRE_DCC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectRegistreDcc = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_REGISTRE_DCC}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateConstitutionCvgfr = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_CONSTITUTION_CVGFR}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectConstitutionCvgfr = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_CONSTITUTION_CVGFR}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateCreationCvgfr = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_CREATION_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectCreationCvgfr = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_CREATION_CVGFR}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateDiagnosticCvgfr = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_DIAGNOSTIC_CVGFR}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectDiagnosticCvgfr = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_DIAGNOSTIC_CVGFR}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateFormationCvgfr = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_FORMATION_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectFormationCvgfr = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_FORMATION_CVGFR}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateFormationLpCvgfr = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_FORMATION_LP_CVGFR}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectFormationLpCvgfr = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_FORMATION_LP_CVGFR}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateReglementCvgfr = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_REGLEMENT_CVGFR}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectReglementCvgfr = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_REGLEMENT_CVGFR}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateDecision = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_DECISION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectDecision = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REJECT_DECISION}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postValidateResume = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_RESUME}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectResume = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REJECT_RESUME}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postValidateCalendrierPrevionnel = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_CALENDRIER_PREVISIONNEL}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectCalendrierPrevionnel = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_CALENDRIER_PREVISIONNEL}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateGuide = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_GUIDE_ENTRETIEN}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectGuide = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_GUIDE_ENTRETIEN}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateCharte = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_CHARTE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectCharte = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REJECT_CHARTE}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postValidateGestionFonciere = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_GESTION_FONCIERE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectGestionFonciere = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_GESTION_FONCIERE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateProcesVerbal = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_PROCES_VERBAL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectProcesVerbal = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_PROCES_VERBAL}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateRapportActivite = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_RAPPORT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectRapportActivite = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REJECT_RAPPORT}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postValidateActivite = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_ACTIVITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectActivite = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REJECT_ACTIVITE}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postValidateFacilitation = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_FACILITATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectFacilitation = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_FACILITATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateFormation = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_FORMATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectFormation = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_FORMATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateProcesVerbalReglement = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_PROCES_VERBAL_REGLEMENT}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectProcesVerbalReglement = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_PROCES_VERBAL_REGLEMENT}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateProcesVerbalClarification = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_PROCES_VERBAL_CLARIFICATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectProcesVerbalClarification = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_PROCES_VERBAL_CLARIFICATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateDemandeIdendite = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_DEMANDE_IDENTITE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectDemandeIdendite = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_DEMANDE_IDENTITE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateDtvHisto = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_DTV_HISTO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectDtvHisto = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_DTV_HISTO}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateDtvAnp = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_DTV_ANP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectDtvAnp = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REJECT_DTV_ANP}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postValidateDtvAnpo = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_DTV_ANPO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectDtvAnpo = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REJECT_DTV_ANPO}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postValidateDtvAnpc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_DTV_ANPC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectDtvAnpc = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REJECT_DTV_ANPC}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postValidateDtvAttestionValidation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_DTV_ATTESTION_VALIDATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectDtvAttestionValidation = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_DTV_ATTESTION_VALIDATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateDtvAttestionApprobation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_DTV_ATTESTION_APPROBATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectDtvAttestionApprobation = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_DTV_ATTESTION_APPROBATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateDtvTronconLimite = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_DTV_TRONCON_LIMITE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectDtvTronconLimite = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_DTV_TRONCON_LIMITE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateDtvRapportActivites = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_DTV_RAPPORT_ACTIVITES}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectDtvRapportActivites = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_DTV_RAPPORT_ACTIVITES}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateDtvScanDocuments = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_DTV_SCAN_DOCUEMENT}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectDtvScanDocuments = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_DTV_SCAN_DOCUEMENT}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateContrat = (code_contrat) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_CONTRAT}/${code_contrat}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectContrat = (code_contrat, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_CONTRAT}/${code_contrat}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addIsfListePresenceRecueil = (payload) => {
  // console.log(payload);
  return apis.post(API_URLS_PRESFOR.POST_LISTE_PRESENCE_RECUEIL, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfListePresenceRecueil = (id, payload) => {
  // console.log(payload);
  return apis.put(`${API_URLS_PRESFOR.PUT_LISTE_PRESENCE_RECUEIL}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfListePresenceRecueil = (id, page = 1, limit = 10) => {
  const validPage =
    Number.isFinite(Number(page)) && Number(page) > 0 ? Number(page) : 1;
  const validLimit =
    Number.isFinite(Number(limit)) && Number(limit) > 0 ? Number(limit) : 10;
  return apis.get(`${API_URLS_PRESFOR.GET_LISTE_PRESENCE_RECUEIL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
    params: {
      page: validPage,
      limit: validLimit,
    },
  });
};

export const generateAnnexeLivrable = (numero_enquete) => {
  return apis.get(
    `${API_URLS_PRESFOR.GENERATE_ANNEXE_LIVRABLE}/${numero_enquete}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const deleteIsfListePresenceRecueil = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_LISTE_PRESENCE_RECUEIL}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const validateIsfListePresenceRecueil = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.VALIDATE_LISTE_PRESENCE_RECUEIL}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const rejectIsfListePresenceRecueil = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.REJECT_LISTE_PRESENCE_RECUEIL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const uploadPdfIsfListePresenceRecueil = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_LISTE_PRESENCE_RECUEIL}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const addIsfRapportActiviteOs = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.POST_ISF_RAPPORT_ACTIVITE_OS}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getIsfRapportActiviteOs = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ISF_RAPPORT_ACTIVITE_OS}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const updateIsfRapportActiviteOs = (id, payload) => {
  return apis.put(`${API_URLS_PRESFOR.PUT_ISF_RAPPORT_ACTIVITE_OS}/${id}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteIsfRapportActiviteOs = (id) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_ISF_RAPPORT_ACTIVITE_OS}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const uploadPdfIsfRapportActiviteOs = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.UPLOAD_PDF_ISF_RAPPORT_ACTIVITE_OS}`, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const postValidateRapportActiviteOs = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_RAPPORT_OSF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRejectRapportActiviteOs = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_RAPPORT_OSF}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getIsfPrealableStats = (dateDebut, dateFin) => {
  const params = new URLSearchParams();

  if (dateDebut) params.append('dateDebut', dateDebut);
  if (dateFin) params.append('dateFin', dateFin);

  const queryString = params.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_ISF_PREALABLE_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_ISF_PREALABLE_STATS;

  return apis.get(url, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getIsfComplementaireStats = (dateDebut, dateFin) => {
  const params = new URLSearchParams();

  if (dateDebut) params.append('dateDebut', dateDebut);
  if (dateFin) params.append('dateFin', dateFin);

  const queryString = params.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_ISF_COMPLEMENTAIRE_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_ISF_COMPLEMENTAIRE_STATS;

  return apis.get(url, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getOpeningStatsDtv = (dateDebut, dateFin) => {
  const params = new URLSearchParams();

  if (dateDebut) params.append('dateDebut', dateDebut);
  if (dateFin) params.append('dateFin', dateFin);

  const queryString = params.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_ISF_DTV_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_ISF_DTV_STATS;

  return apis.get(url, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getOpeningStatsDcf = (dateDebut, dateFin) => {
  const params = new URLSearchParams();

  if (dateDebut) params.append('dateDebut', dateDebut);
  if (dateFin) params.append('dateFin', dateFin);

  const queryString = params.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_ISF_DCF_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_ISF_DCF_STATS;

  return apis.get(url, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getIsfTransmissionStats = () => {
  return apis.get(`${API_URLS_PRESFOR.GET_ISF_TRANSMISSION_STATS}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getIsfPrealableValidateStats = (dateDebut, dateFin) => {
  const params = new URLSearchParams();

  if (dateDebut) params.append('dateDebut', dateDebut);
  if (dateFin) params.append('dateFin', dateFin);

  const queryString = params.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_ISF_PREALABLE_VALIDATE}?${queryString}`
    : API_URLS_PRESFOR.GET_ISF_PREALABLE_VALIDATE;

  return apis.get(url, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getSuperficieByEnquete = (codeenquete, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_SUPERFICIE_ENQ}/${codeenquete}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getCEDTV = (code_sp, code_vil) => {
  return apis.get(`${API_URLS_PRESFOR.GET_CE_DTV}/${code_sp}/${code_vil}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getDcfValidateStats = (dateDebut, dateFin) => {
  const params = new URLSearchParams();

  if (dateDebut) params.append('dateDebut', dateDebut);
  if (dateFin) params.append('dateFin', dateFin);

  const queryString = params.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_DCF_VALIDATE}?${queryString}`
    : API_URLS_PRESFOR.GET_DCF_VALIDATE;

  return apis.get(url, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getCEDCF = (code_sp, code_vil) => {
  return apis.get(`${API_URLS_PRESFOR.GET_CE_DCF}/${code_sp}/${code_vil}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getCEPVCL = (code_sp, code_vil) => {
  return apis.get(`${API_URLS_PRESFOR.GET_CE_PVCL}/${code_sp}/${code_vil}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getPVByEnquete = (codeEnquete, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_PV_BY_ENQ}/${codeEnquete}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};
export const deleteIsfCompteRenduContactSp = (id) => {
  console.log('delete compte id', id);
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_COMPTE_RENDU_CONTACT_SP}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getIsfCompteRenduContactSp = (code_sp) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_COMPTE_RENDU_CONTACT_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const updateIsfCompteRenduContactSp = (code_sp, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.PUT_COMPTE_RENDU_CONTACT_SP}/${code_sp}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const postValidateCompteRenduPriseContactSp = (code_sp) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_COMPTE_RENDU_PRISE_CONTACT_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectCompteRenduPriseContactSp = (code_sp) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_COMPTE_RENDU_PRISE_CONTACT_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getIsfListePresenceContactSp = (code_sp) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_LISTE_PRESENCE_CONTACT_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const addIsfListePresenceContactSp = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_LISTE_PRESENCE_CONTACT_SP, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const updateIsfListePresenceContactSp = (code_sp, payload) => {
  return apis.put(
    `${API_URLS_PRESFOR.PUT_LISTE_PRESENCE_CONTACT_SP}/${code_sp}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const deleteIsfListePresenceContactSp = (code_sp) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_LISTE_PRESENCE_CONTACT_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postValidateIsfListePresenceContactSp = (code_sp) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_LISTE_PRESENCE_CONTACT_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postRejectIsfListePresenceContactSp = (code_sp) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_LISTE_PRESENCE_CONTACT_SP}/${code_sp}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const updateQuestionnairePVRDC = (payload) => {
  return apis.put(`${API_URLS_PRESFOR.UPDATE_QUESTIONNAIRE_PVRDC}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const importDCFExcelFile = (payload) => {
  return apis.post(`${API_URLS_PRESFOR.IMPORT_DCF_EXCEL_FILE}`, {
    ...payload,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getHistoryImportLivrable = (code_livrable) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_HISTORY_IMPORT_LIVRABLE}/${code_livrable}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const downloadFileApi = async (filePath) => {
  try {
    const apiUrl = `${API_URLS_PRESFOR.DOWNLOAD_FILE}/${filePath}`;
    const response = await apis.get(apiUrl, {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;

    const app_name = filePath.split('/').pop();
    link.setAttribute('download', app_name); // Nom du fichier à télécharger
    document.body.appendChild(link);
    link.click();

    // Optionnel : Nettoyer après téléchargement
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Erreur lors du téléchargement:', error);
    throw error;
  }
};

export const addQuestionnairePVRDC = (payload) => {
  return apis.post(API_URLS_PRESFOR.ADD_QUESTIONNAIRE_PVRDC, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getStatsContrats = (dateDebut, dateFin) => {
  const params = new URLSearchParams();

  if (dateDebut) params.append('dateDebut', dateDebut);
  if (dateFin) params.append('dateFin', dateFin);

  const queryString = params.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_ISF_CONTRAT_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_ISF_CONTRAT_STATS;

  return apis.get(url, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const exportDcfsPdf = (dataToSend) => {
  return apis.post(API_URLS_PRESFOR.EXPORT_DCF_PDF, {
    data: dataToSend,
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'arraybuffer',
  });
};

export const exportPvclsExcel = (dataToSend) => {
  return apis.post(API_URLS_PRESFOR.EXPORT_PVCL, {
    data: dataToSend,
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'arraybuffer',
  });
};

export const getHistoryExportLivrable = (type_livrable, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_HISTORY_EXPORT_LIVRABLE}/${type_livrable}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const downloadHistoryExportLivrable = (type_livrable, id, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DOWNLOAD_HISTORY_EXPORT_LIVRABLE}/${type_livrable}/${id}/download`;
  return apis.get(apiUrl, {
    ...payload,
    responseType: 'arraybuffer',
    headers: { ...payload?.headers },
  });
};

export const exportContratPdf = (dataToSend) => {
  return apis.post(API_URLS_PRESFOR.EXPORT_CONTRAT_PDF, {
    data: dataToSend,
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'arraybuffer',
  });
};

export const exportContratsExcel = (payload) => {
  return apis.post(API_URLS_PRESFOR.EXPORT_CONTRATS, {
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'arraybuffer',
  });
};

export const getPVRDCAnnexe1 = async (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_PVRDC_ANNEXE1}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getPVRDCAnnexe2 = async (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_PVRDC_ANNEXE2}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getPVRDCAnnexe3 = async (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_PVRDC_ANNEXE3}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getPVRDCAnnexe4 = async (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_PVRDC_ANNEXE4}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getPVRDCAnnexe5 = async (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_PVRDC_ANNEXE5}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deletePvrdcQuestionnaire = (codepvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PVRDC_QUESTIONAIRE}/${codepvrdc}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getListeCertificatByEnquete = (codeEnquete, payload) => {
  const { skip = 0, limit = 10, search = '', ...otherParams } = payload || {};
  // Ensure skip and limit are numbers
  const skipNum = Number(skip);
  const limitNum = Number(limit);
  const searchValue = typeof search === 'string' ? search.trim() : '';

  // Construct the URL by appending the contract ID to the base URL with pagination params
  const params = new URLSearchParams({
    skip: String(skipNum),
    limit: String(limitNum),
  });
  if (searchValue.length > 0) {
    params.append('search', searchValue);
  }
  const apiUrl = `${API_URLS_PRESFOR.GET_LISTE_CF_BY_ENQ}/${codeEnquete}?${params.toString()}`;

  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...otherParams,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getSingleDcfWithPVRDC = async (codecf, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_SINGLE_DCF_WITH_PVRDC}/${codecf}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getDcfConstatsLimite = (codecf) => {
  return apis.get(`${API_URLS_PRESFOR.GET_DCF_CONSTAT_LIMITE}/${codecf}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getPVRDCAnnexe01 = (code_pvrdc) => {
  return apis.get(`${API_URLS_PRESFOR.GET_PVRDC_ANNEXE01}/${code_pvrdc}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// export const getPVRDCListeddcc = (code_pvrdc) => {
//   return apis.get(
//     `${API_URLS_PRESFOR.GET_PVRDC_LISTE_DETENTEURS_DROITS}/${code_pvrdc}`,
//     {
//       headers: { 'Content-Type': 'application/json' },
//     }
//   );
// };

// export const getPVRDCEtatsDroits = (code_pvrdc) => {
//   return apis.get(
//     `${API_URLS_PRESFOR.GET_PVRDC_LISTE_ETATS_DROITS}/${code_pvrdc}`,
//     {
//       headers: { 'Content-Type': 'application/json' },
//     }
//   );
// };

// export const getPVRDCGBFC = (code_pvrdc) => {
//   return apis.get(
//     `${API_URLS_PRESFOR.GET_PVRDC_DESIGNATION_GESTIONNAIRE}/${code_pvrdc}`,
//     {
//       headers: { 'Content-Type': 'application/json' },
//     }
//   );
// };

// export const getPVRDCListeServitude = (code_pvrdc) => {
//   return apis.get(
//     `${API_URLS_PRESFOR.GET_PVRDC_LISTE_SERVITUDE}/${code_pvrdc}`,
//     {
//       headers: { 'Content-Type': 'application/json' },
//     }
//   );
// };

export const getDemandeurByDcf = (code_dcf) => {
  return apis.get(`${API_URLS_PRESFOR.GET_DEMANDEUR_BY_DCF}/${code_dcf}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getPVRDCListeddcc = (code_pvrdc) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_PVRDC_LISTE_DETENTEURS_DROITS}/${code_pvrdc}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getPVRDCEtatsDroits = (code_pvrdc) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_PVRDC_LISTE_ETATS_DROITS}/${code_pvrdc}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getPVRDCGBFC = (code_pvrdc, page = 1, limit = 10) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));

  return apis.get(
    `${API_URLS_PRESFOR.GET_PVRDC_DESIGNATION_GESTIONNAIRE}/${code_pvrdc}`,
    {
      params: {
        page: validPage,
        limit: validLimit,
      },
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getPVRDCListeServitude = (code_pvrdc, page = 1, limit = 10) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));

  return apis.get(
    `${API_URLS_PRESFOR.GET_PVRDC_LISTE_SERVITUDE}/${code_pvrdc}`,
    {
      params: {
        page: validPage,
        limit: validLimit,
      },
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getDcf = (codecf) => {
  return apis.get(`${API_URLS_PRESFOR.GET_DCF}/${codecf}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getPVRDCMemebreEquipeEnquete = (
  code_pvrdc,
  page = 1,
  limit = 10,
  type_liste
) => {
  // Ensure page and limit are valid numbers
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));

  return apis.get(
    `${API_URLS_PRESFOR.GET_PVRDC_MEMEBRE_EQUIPE_ENQUETE}/${code_pvrdc}`,
    {
      params: {
        page: validPage,
        limit: validLimit,
        ...(type_liste ? { type_liste } : {}),
      },
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getPVRDCFicheDemographique = (
  code_pvrdc,
  page = 1,
  limit = 10
) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));
  return apis.get(
    `${API_URLS_PRESFOR.GET_PVRDC_FICHE_DEMOGRAPHIQUE}/${code_pvrdc}`,
    {
      params: {
        page: validPage,
        limit: validLimit,
      },
      headers: { 'Content-Type': 'application/json' },
      params: { page, limit },
    }
  );
};

export const getPVRDCDeclarations = (code_pvrdc, page = 1, limit = 10) => {
  // Ensure page and limit are valid numbers
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));

  return apis.get(`${API_URLS_PRESFOR.GET_PVRDC_DECLARATIONS}/${code_pvrdc}`, {
    params: {
      page: validPage,
      limit: validLimit,
    },
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getPVRDCOccupantsParcelle = (code_pvrdc, page = 1, limit = 10) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));

  return apis.get(
    `${API_URLS_PRESFOR.GET_PVRDC_OCCUPANTS_PARCELLE}/${code_pvrdc}`,
    {
      params: {
        page: validPage,
        limit: validLimit,
      },
      headers: { 'Content-Type': 'application/json' },
      params: { page, limit },
    }
  );
};

export const getFicheLitigePVRDC = (code_pvrdc, page = 1, limit = 10) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));

  return apis.get(`${API_URLS_PRESFOR.GET_FICHE_LITIGE_PVRDC}/${code_pvrdc}`, {
    params: {
      page: validPage,
      limit: validLimit,
    },
    headers: { 'Content-Type': 'application/json' },
    params: { page, limit },
  });
};

export const getPVRDCCreated = (type_pvrdc) => {
  return apis.get(`${API_URLS_PRESFOR.GET_PVRDC_CREATED}/${type_pvrdc}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getMinimizePVCL = (codedcf) => {
  return apis.get(`${API_URLS_PRESFOR.GET_MINIMIZE_PVCL}/${codedcf}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getOnePVCL = (code_pvcl) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ONE_PVCL}/${code_pvcl}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getPVRDCListeEtatsDroits = (code_pvrdc, page = 1, limit = 10) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));

  return apis.get(`${API_URLS_PRESFOR.GET_PVRDC_ETATS_DROITS}/${code_pvrdc}`, {
    params: {
      page: validPage,
      limit: validLimit,
    },
    headers: { 'Content-Type': 'application/json' },
    params: { page, limit },
  });
};

export const getPVRDCListeDetenteursDroits = (
  code_pvrdc,
  page = 1,
  limit = 10
) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));

  return apis.get(
    `${API_URLS_PRESFOR.GET_PVRDC_DETENTEURS_DROITS}/${code_pvrdc}`,
    {
      params: {
        page: validPage,
        limit: validLimit,
      },
      headers: { 'Content-Type': 'application/json' },
      params: { page, limit },
    }
  );
};

export const getMinmizeDcfListe = (numero_enquete) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_MINIMIZE_LISTE_CF_BY_ENQ}/${numero_enquete}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getPVRDCDesignationGbfc = (code_pvrdc, page = 1, limit = 10) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));

  return apis.get(
    `${API_URLS_PRESFOR.GET_PVRDC_DESIGNATION_GBFC}/${code_pvrdc}`,
    {
      params: {
        page: validPage,
        limit: validLimit,
      },
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getPVRDCAnnexe6 = async (codecf, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_PVRDC_ANNEXE6}/${codecf}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getPVRDCQUESTIONNAIRE = (code_pvrdc) => {
  return apis.get(`${API_URLS_PRESFOR.GET_PVRDC_QUESTIONNAIRE}/${code_pvrdc}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getFicheIdentitification = (code_dcf) => {
  return apis.get(`${API_URLS_PRESFOR.GET_FICHE_IDENTIFICATION}/${code_dcf}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getMinimizeFicheId = async (codecf, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_MINIMIZE_FICHE_ID}/${codecf}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getMinimizeCertificatByEnquete = (codeEnquete, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_MINIMIZE_CF_BY_ENQ}/${codeEnquete}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const postRegeneratePvrdcPDF = (code_dcf) => {
  return apis.get(`${API_URLS_PRESFOR.POST_REGENERATE_PVRDC_PDF}/${code_dcf}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const totalSuperficieDcfApi = (accessToken) => {
  return apis.get(
    `${COMMON_URL_PRESFOR}certificat-foncier/total-superficie-dcf`,
    {
      headers: createHeaders(accessToken),
    }
  );
};

export const postCotRejectID = (code_id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_ID}/${code_id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateID = (code_id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_ID}/${code_id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectPVRDC = (code_pvrdc, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_PVRDC}/${code_pvrdc}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidatePVRDC = (code_pvrdc) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_PVRDC}/${code_pvrdc}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectPVCL = (code_pvcl, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_PVCL}/${code_pvcl}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidatePVCL = (code_pvcl) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_PVCL}/${code_pvcl}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotValidateDCF = (code_dcf) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_DCF}/${code_dcf}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectCLP = (code_clp, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_CLP}/${code_clp}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateCLP = (code_clp) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_CLP}/${code_clp}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectDCF = (code_dcf, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DCF}/${code_dcf}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateCECPDC = (code_constat) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_CECPDC}/${code_constat}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectCECPDC = (code_constat, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_CECPDC}/${code_constat}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateVALID = (code_constat) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_VALID}/${code_constat}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectVALID = (code_constat, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_VALID}/${code_constat}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateDTVHISTO = (code_constat) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_DTV_HISTO}/${code_constat}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectDTVHISTO = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DTV_HISTO}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// ANP: PROCES VERBAL D'ANNONCE DE PUBLICITE
export const postCotValidateDtvAnp = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_DTV_ANP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectDtvAnp = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DTV_ANP}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// ANPO: PROCES VERBAL D'OUVERTURE DE PUBLICITE
export const postCotValidateDtvAnpo = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_DTV_ANPO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectDtvAnpo = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DTV_ANPO}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// ANPC: PROCES VERBAL DE CLOTURE DE PUBLICITE
export const postCotValidateDtvAnpc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_DTV_ANPC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectDtvAnpc = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DTV_ANPC}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// APPROBATION: ATTESTATION D'APPROBATION
export const postCotValidateDtvApprobation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_DTV_APPROBATION}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectDtvApprobation = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DTV_APPROBATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// VALIDATION: ATTESTATION DE VALIDATION
export const postCotValidateDtvValidation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_DTV_VALIDATION}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectDtvValidation = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DTV_VALIDATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

//api function isf
export const postCotValidateIsfCompteRendu = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_ISF_COMPTE_RENDU}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectIsfCompteRendu = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_ISF_COMPTE_RENDU}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidatePC = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_PC}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectPC = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REJECT_PC}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotValidateCCO = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_CCO}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectCCO = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REJECT_CCO}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotValidateRecueil = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_RECUEIL}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectRecueil = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_RECUEIL}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateListePresenceRecueil = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_LISTE_PRESENCE_RECUEIL}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectListePresenceRecueil = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_LISTE_PRESENCE_RECUEIL}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateDeclaration = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_DECLARATION}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectDeclaration = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DECLARATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateDemande = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_DEMANDE}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectDemande = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DEMANDE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateCeremonie = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_CEREMONIE}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectCeremonie = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_CEREMONIE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateCompteRendu = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_COMPTE_RENDU}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectCompteRendu = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_COMPTE_RENDU}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateRapportVillage = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_RAPPORT_VILLAGE}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectRapportVillage = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_RAPPORT_VILLAGE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateDecisionCreation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_DECISION_CREATION}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectDecisionCreation = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DECISION_CREATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidatePvConstitution = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_PV_CONSTITUTION}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectPvConstitution = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_PV_CONSTITUTION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateDiagnostic = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_DIAGNOSTIC}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectDiagnostic = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DIAGNOSTIC}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateCalendrier = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_CALENDRIER}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectCalendrier = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_CALENDRIER}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateGuide = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_GUIDE}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectGuide = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_GUIDE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateProtocole = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_PROTOCOLE}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectProtocole = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_PROTOCOLE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidatePvca = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_PVCA}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectPvca = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REJECT_PVCA}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotValidatePvcfi = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_PVCFI}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectPvcfi = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_PVCFI}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidatePvrlf = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_PVRLF}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectPvrlf = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_PVRLF}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateCourrier = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_COURRIER}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectCourrier = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_COURRIER}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateReglement = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_REGLEMENT}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectReglement = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_REGLEMENT}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateAttestationFormation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_ATTESTATION_FORMATION}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectAttestationFormation = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_ATTESTATION_FORMATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateListePresence = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_LISTE_PRESENCE}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectListePresence = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_LISTE_PRESENCE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateIs = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_IS}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectIs = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REJECT_IS}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotValidateRapportIsf = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_RAPPORT_ISF}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectRapportIsf = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_RAPPORT_ISF}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateRapportActivite = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_RAPPORT_ACTIVITE}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectRapportActivite = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_RAPPORT_ACTIVITE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateRapportOsf = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_RAPPORT_OSF}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectRapportOsf = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_RAPPORT_OSF}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateIsfDcf = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_ISF_DCF}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectIsfDcf = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_ISF_DCF}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateDcc = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_DCC}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectDcc = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REJECT_DCC}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotValidateDecision = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_DECISION}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectDecision = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DECISION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateResume = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_RESUME}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectResume = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_RESUME}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// APPROBATION/REJET COT POUR ACTIVITES / INFORMATION ET SENSIBILISATION
export const postCotValidateIsfComplementaireActivite = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_ISF_COMPLEMENTAIRE_ACTIVITE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectIsfComplementaireActivite = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_ISF_COMPLEMENTAIRE_ACTIVITE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// APPROBATION/REJET COT POUR FACILITATION
export const postCotValidateIsfComplementaireFacilitation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_ISF_COMPLEMENTAIRE_FACILITATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectIsfComplementaireFacilitation = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_ISF_COMPLEMENTAIRE_FACILITATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// APPROBATION/REJET COT POUR FORMATION ET ENCADREMENT
export const postCotValidateIsfComplementaireFormation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_ISF_COMPLEMENTAIRE_FORMATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectIsfComplementaireFormation = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_ISF_COMPLEMENTAIRE_FORMATION}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// TRONCON LIMITE
export const postCotValidateDtvTronconLimite = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_DTV_TRONCON_LIMITE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectDtvTronconLimite = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DTV_TRONCON_LIMITE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotValidateCalendrierPrev = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_VALIDATE_CALENDRIER_PREV}/${id}`,

    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotRejectCalendrierPrev = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_CALENDRIER_PREV}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// DEMANDE IDENTITE
export const postCotValidateDeamndeId = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_DEMANDE_ID}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectDeamndeId = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_DEMANDE_ID}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// CONTRAT
export const postCotValidateContrat = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_CONTRAT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectContrat = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_CONTRAT}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getOnlyValidateEnqueteAll = (status, type_livrable) => {
  const url = `${API_URLS_PRESFOR.GET_ONLY_VALIDATE_ENQUETE_ALL}`;
  return apis.get(url, {
    params: {
      status,
      type_livrable,
    },
  });
};

// Charte dossier 11
export const postCotValidateCharte = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_CHARTE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectCharte = (id, payload) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REJECT_CHARTE}/${id}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// Annoce de pub
export const postCotValidateAnp = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_ANP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectAnp = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REJECT_ANP}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotValidateAnpo = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_ANPO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectAnpo = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REJECT_ANPO}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotValidateAnpc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_ANPC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectAnpc = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REJECT_ANPC}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getOnlyCQValidateEnqueteAll = (status, type_livrable) => {
  const url = `${API_URLS_PRESFOR.GET_ONLY_CQ_VALIDATE_ENQUETE_ALL}`;
  return apis.get(url, {
    params: {
      status,
      type_livrable,
    },
  });
};

export const getPVRDCListeDateServitude = (
  code_pvrdc,
  page = 1,
  limit = 10
) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_PVRDC_LISTE_DATE_SERVITUDE}/${code_pvrdc}`,
    {
      headers: { 'Content-Type': 'application/json' },
      params: { page, limit },
    }
  );
};

export const postCQReviewDcf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_DCF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewDcf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_DCF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCQReviewFicheId = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_ID}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewFicheId = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_ID}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCQReviewPvrdc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_PVRDC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewPvrdc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_PVRDC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCQReviewPvcl = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_PVCL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewPvcl = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_PVCL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCQReviewClp = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_CLP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewClp = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_CLP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCQReviewCecpdc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_CECPDC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewCecpdc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_CECPDC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCQReviewValid = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_VALID}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewValid = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_VALID}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewAnp = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_ANP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCqReviewAnp = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_ANP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewAnpo = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_ANPO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCqReviewAnpo = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_ANPO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewAnpc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_ANPC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCqReviewAnpc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_ANPC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewContrat = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_CONTRAT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCqReviewContrat = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_CONTRAT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewDtvHisto = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_DTV_HISTO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCqReviewDtvHisto = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_DTV_HISTO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewDtvAnp = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_DTV_ANP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCqReviewDtvAnp = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_DTV_ANP}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewDtvAnpo = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_DTV_ANPO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCqReviewDtvAnpo = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_DTV_ANPO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewDtvAnpc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_DTV_ANPC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCqReviewDtvAnpc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_DTV_ANPC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewDtvApprobation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_DTV_APPROBATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCqReviewDtvApprobation = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_DTV_APPROBATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewDtvValidation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_DTV_VALIDATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCqReviewDtvValidation = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_DTV_VALIDATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewDtvTroncon = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_DTV_TRONCON_LIMITE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCqReviewDtvTroncon = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_DTV_TRONCON_LIMITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Filtered APIs - Get certificats fonciers by enquete with status filter
export const getFilteredCFByEnquete = (numero_enquete, status, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_FILTERED_CF_BY_ENQUETE}/${numero_enquete}?status=${status}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// Get PVRDC by enquete with status filter
export const getFilteredPVRDCByEnquete = (numero_enquete, status, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_FILTERED_PVRDC_BY_ENQUETE}/${numero_enquete}?status=${status}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// Get PVCL by enquete with status filter
export const getFilteredPVCLByEnquete = (numero_enquete, status, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_FILTERED_PVCL_BY_ENQUETE}/${numero_enquete}?status=${status}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

// --- FONCTIONS REVIEW ISF ---

// Demande Identité
export const postCotReviewDemandeIdentite = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_DEMANDE_IDENTITE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewDemandeIdentite = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_DEMANDE_IDENTITE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// Cérémonie Ouverture
export const postCotReviewCeremonieOuverture = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_CEREMONIE_OUVERTURE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewCeremonieOuverture = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_CEREMONIE_OUVERTURE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotReviewCeremonieCompteRendu = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_CEREMONIE_COMPTE_RENDU}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewCeremonieCompteRendu = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_CEREMONIE_COMPTE_RENDU}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotReviewRapportVillage = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_RAPPORT_VILLAGE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewRapportVillage = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_RAPPORT_VILLAGE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// Diagnostic
export const postCotReviewDiagnostic = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_DIAGNOSTIC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewDiagnostic = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_DIAGNOSTIC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Dialogue Social
export const postCotReviewCalendrierPrevisionnelDS = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_CALENDRIER_PREVISIONNEL_DS}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewCalendrierPrevisionnelDS = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_CALENDRIER_PREVISIONNEL_DS}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotReviewGuide = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_GUIDE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewGuide = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_GUIDE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewProtocole = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_PROTOCOLE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewProtocole = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_PROTOCOLE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewPvca = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_PVCA}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewPvca = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_PVCA}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewPvcfi = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_PVCFI}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewPvcfi = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_PVCFI}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewPvrlf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_PVRLF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewPvrlf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_PVRLF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewCharte = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_CHARTE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewCharte = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_CHARTE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Elaboration Calendrier
export const postCotReviewCalendrier = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_CALENDRIER}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewCalendrier = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_CALENDRIER}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Formation
export const postCotReviewAttestationFormation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_ATTESTATION_FORMATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewAttestationFormation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_ATTESTATION_FORMATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotReviewReglementInterieur = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_REGLEMENT_INTERIEUR}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewReglementInterieur = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_REGLEMENT_INTERIEUR}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// Information Sensibilisation
export const postCotReviewInformationSensibilisation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_INFO_SENSIBILISATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewInformationSensibilisation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_INFO_SENSIBILISATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotReviewRapportIsf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_RAPPORT_ISF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewRapportIsf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_RAPPORT_ISF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// ISF Complémentaire
export const postCotReviewActivite = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_ACTIVITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewActivite = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_ACTIVITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewFacilitation = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_FACILITATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewFacilitation = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_FACILITATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewFormation = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_FORMATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewFormation = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_FORMATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// ISF Service
export const postCotReviewCCO = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_CCO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewCCO = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_CCO}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewRecueil = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_RECUEIL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewRecueil = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_RECUEIL}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewListePresenceRecueil = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_LISTE_PRESENCE_RECUEIL}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewListePresenceRecueil = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_LISTE_PRESENCE_RECUEIL}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotReviewDeclaration = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_DECLARATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewDeclaration = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_DECLARATION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Rapport
export const postCotReviewRapportActivite = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_RAPPORT_ACTIVITE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewRapportActivite = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_RAPPORT_ACTIVITE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const postCotReviewRapportOsf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_RAPPORT_OSF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewRapportOsf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_RAPPORT_OSF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Registre Intention
export const postCotReviewisfDcf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_DCF_INTENTION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewisfDcf = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_DCF_INTENTION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewDcc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_DCC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewDcc = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_DCC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Reunion Periodique
export const postCotReviewDecision = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_DECISION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewDecision = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_DECISION}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotReviewResume = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_RESUME}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewResume = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_RESUME}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// --- SUITE FONCTIONS REVIEW (Ajouts manquants) ---

// Formation - Liste de présence
export const postCotReviewListePresence = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_LISTE_PRESENCE}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewListePresence = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_LISTE_PRESENCE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Elaboration Calendrier - Courrier
export const postCotReviewCourrierTransmission = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_COURRIER}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewCourrierTransmission = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_COURRIER}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Diagnostic - Décision Création
export const postCotReviewDecisionCreation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_DECISION_CREATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewDecisionCreation = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_DECISION_CREATION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// Diagnostic - PV Constitution
export const postCotReviewPvConstitution = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_COT_REVIEW_PV_CONSTITUTION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};
export const postCqReviewPvConstitution = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_CQ_REVIEW_PV_CONSTITUTION}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// Prise de Contact (PC)
export const postCotReviewPC = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_PC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewPC = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_PC}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Prise de Contact - Compte Rendu (CR)
export const postCotReviewCR = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_CR_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
export const postCqReviewCR = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_CR_CONTACT}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getOneSinglePVCL = (code_pvcl) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ONE_SINGLE_PVCL}/${code_pvcl}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const validateShape = (code_dcf, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_VALIDATE_SHAPE}/${code_dcf}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const reviewShape = (code_dcf, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REVIEW_SHAPE}/${code_dcf}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const rejectShape = (code_dcf, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_REJECT_SHAPE}/${code_dcf}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getOnePppShapeFile = (code_dcf) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_ONE_SINGLE_PPP_SHAPE_FILE}/${code_dcf}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getOnePpdShapeFile = (code_dcf) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_ONE_SINGLE_PPD_SHAPE_FILE}/${code_dcf}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const listObjDtvApi = (accessToken) => {
  return apis.get(`${COMMON_URL_PRESFOR}dtv/total-obj-dtv`, {
    headers: createHeaders(accessToken),
  });
};

export const listObjIsfApi = (accessToken) => {
  return apis.get(`${COMMON_URL_PRESFOR}isf/total-obj-isf`, {
    headers: createHeaders(accessToken),
  });
};

export const listObjContractsApi = (accessToken) => {
  return apis.get(`${COMMON_URL_PRESFOR}contrat/total-obj-contract`, {
    headers: createHeaders(accessToken),
  });
};

// Add this to your service/api-presfor.js file
export const generateWeeklyReportApi = (data, accessToken) => {
  return apis.post(`${COMMON_URL_PRESFOR}send-reports/generate`, data, {
    headers: createHeaders(accessToken),
  });
};

export const sendReportEmailApi = (data, accessToken) => {
  return apis.post(`${COMMON_URL_PRESFOR}send-reports/send-email`, data, {
    headers: createHeaders(accessToken),
  });
};

export const getWeeklyReportsApi = (params = {}, accessToken) => {
  const queryParams = new URLSearchParams();

  if (params.region) queryParams.append('region', params.region);
  if (params.startDate) queryParams.append('startDate', params.startDate);
  if (params.endDate) queryParams.append('endDate', params.endDate);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${COMMON_URL_PRESFOR}send-reports?${queryString}`
    : `${COMMON_URL_PRESFOR}send-reports`;

  return apis.get(url, {
    headers: createHeaders(accessToken),
  });
};

export const deleteWeeklyReportApi = (id, accessToken) => {
  return apis.delete(`${COMMON_URL_PRESFOR}send-reports/${id}`, {
    headers: createHeaders(accessToken),
  });
};

export const getRapportDcfStats = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_DCF_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_DCF_STATS;

  return apis.post(
    url,
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};
export const getRapportPvrdcStats = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_PVRDC_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_PVRDC_STATS;

  return apis.post(
    url,
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};
export const getRapportPvclStats = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_PVCL_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_PVCL_STATS;

  return apis.post(
    url,
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getRapportPppStats = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_PPP_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_PPP_STATS;

  return apis.post(
    url,
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getRapportAttestationStats = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_ATTESTATION_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_ATTESTATION_STATS;

  return apis.post(
    url,
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getRapportCecpdcStats = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_CECPDC_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_CECPDC_STATS;

  return apis.post(
    url,
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

const buildRapportUrl = (baseUrl, payload) => {
  const queryParams = new URLSearchParams();
  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);
  const queryString = queryParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};

export const getRapportAnpStats = (payload) => {
  return apis.post(
    buildRapportUrl(API_URLS_PRESFOR.GET_RAPPORT_ANP_STATS, payload),
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getRapportAnpoStats = (payload) => {
  return apis.post(
    buildRapportUrl(API_URLS_PRESFOR.GET_RAPPORT_ANPO_STATS, payload),
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getRapportAnpcStats = (payload) => {
  return apis.post(
    buildRapportUrl(API_URLS_PRESFOR.GET_RAPPORT_ANPC_STATS, payload),
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

// Fonctions à ajouter à la fin du fichier
export const getRapportClpStats = (payload) => {
  return apis.post(
    buildRapportUrl(API_URLS_PRESFOR.GET_RAPPORT_CLP_STATS, payload),
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getRapportPpdStats = (payload) => {
  return apis.post(
    buildRapportUrl(API_URLS_PRESFOR.GET_RAPPORT_PPD_STATS, payload),
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const exportSuperficiesXlsx = async (typeStatus, typeProjet) => {
  if (!typeStatus || !typeProjet) {
    throw new Error('typeStatus et typeProjet sont requis');
  }

  const apiUrl = `${API_URLS_PRESFOR.EXPORT_SUPERFICIES_XLSX}/${typeStatus}/${typeProjet}`;

  const response = await apis.get(apiUrl, {
    responseType: 'blob',
  });

  return response;
};
export const getRapportCf19Stats = (payload) => {
  return apis.post(
    buildRapportUrl(API_URLS_PRESFOR.GET_RAPPORT_CF19_STATS, payload),
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const uploadPppV2 = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPLOAD_PPP_V2, {
    ...payload.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const getRapportDossierProvStats = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_DOSSIER_PROVISOIRE_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_DOSSIER_PROVISOIRE_STATS;

  return apis.post(
    url,
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const deletePppV2 = (codedcf, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DELETE_PPP_V2}/${codedcf}`;

  return apis.delete(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const regeneratePdfRapportActivite = (id) => {
  return apis.get(`${API_URLS_PRESFOR.REGENERATE_PDF_RAPPORT_ACTIVITE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const regeneratePdfRapportOsf = (id) => {
  return apis.get(`${API_URLS_PRESFOR.REGENERATE_PDF_RAPPORT_OSF}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getRapportDossierProv2Stats = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_DOSSIER_PROVISOIRE2_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_DOSSIER_PROVISOIRE2_STATS;

  return apis.post(
    url,
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getRapportDossierDefinitifStats = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_DOSSIER_DEFINITIF_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_DOSSIER_DEFINITIF_STATS;

  return apis.post(
    url,
    {},
    {
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const getEnqueteDtvPvlim = (numero_enquete) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_DTV_PVLIM_BY_ENQUETE}/${numero_enquete}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getEnqueteDtvAnpc = (numero_enquete) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_DTV_ANPC_BY_ENQUETE}/${numero_enquete}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getMinimizeListPubByEnquete = (code, payload) => {
  return apis.get(`${API_URLS_PRESFOR.MINIMIZE_LIST_PUB_BY_ENQUETE}/${code}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getAnpdsByAnnoncePub = (code, payload = {}) => {
  const { params = {}, ...rest } = payload;
  return apis.get(`${API_URLS_PRESFOR.GET_ANPDS_BY_ANNONCE_PUB}/${code}`, {
    ...rest,
    params,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getAnpdsByEnquete = (code, payload = {}) => {
  const { params = {}, ...rest } = payload;
  return apis.get(`${API_URLS_PRESFOR.GET_ANPDS_BY_ENQUETE}/${code}`, {
    ...rest,
    params,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getAnpoLpsByAnnoncePub = (code, payload) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ANPO_LPS_BY_ANNONCE_PUB}/${code}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getAnpcLpsByAnnoncePub = (code, payload) => {
  return apis.get(`${API_URLS_PRESFOR.GET_ANPC_LPS_BY_ANNONCE_PUB}/${code}`, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const deleteCECPDCByAnnonce = (code_annonce_pub, payload) => {
  return apis.delete(
    `${API_URLS_PRESFOR.DELETE_CECPDC_BY_ANNONCE_PUB}/${code_annonce_pub}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const usersCount = (accessToken) => {
  return apis.get(`${COMMON_URL_PRESFOR}user/all/total-count`, {
    headers: createHeaders(accessToken),
  });
};

export const getPlanParcelStatistiqueByEnquete = (enqueteid, payload = {}) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_PLAN_PARCEL_STATISTIQUE_BY_ENQUETE}/${enqueteid}`,
    {
      ...payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const dtvHistobyenquete = (code_pvrdc, page = 1, limit = 10) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));
  return apis.get(
    `${API_URLS_PRESFOR.GET_DTV_HISTO_BY_ENQUETE}/${code_pvrdc}`,
    {
      params: {
        page: validPage,
        limit: validLimit,
      },
      headers: { 'Content-Type': 'application/json' },
      params: { page, limit },
    }
  );
};

export const dtvAttestationValidbyenquete = (
  code_pvrdc,
  page = 1,
  limit = 10
) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));
  return apis.get(
    `${API_URLS_PRESFOR.GET_DTV_ATTESTATION_VALID_BY_ENQUETE}/${code_pvrdc}`,
    {
      params: {
        page: validPage,
        limit: validLimit,
      },
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const dtvAttestationApprobationbyenquete = (
  code_pvrdc,
  page = 1,
  limit = 10
) => {
  const validPage = Math.max(1, parseInt(page) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit) || 10));
  return apis.get(
    `${API_URLS_PRESFOR.GET_DTV_ATTESTATION_APPROBATION_BY_ENQUETE}/${code_pvrdc}`,
    {
      params: {
        page: validPage,
        limit: validLimit,
      },
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getTransmissionTagsByCodeCf = (codecf) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_TRANSMISSION_TAGS_BY_CODE_CF}/${codecf}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const regenerateAnpPdf = (
  code_annonce_pub,
  code_certif,
  NNNNNs = []
) => {
  return apis.post(API_URLS_PRESFOR.REGENERATE_ANP_PDF, {
    code_annonce_pub,
    code_certif,
    NNNNNs,
  });
};

export const regenerateAnpoPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.REGENERATE_ANPO_PDF, {
    ...payload,
  });
};

export const regenerateDcfAnpPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.REGENERATE_DCF_ANP_PDF, {
    ...payload,
  });
};

export const regenerateDcfAnpoPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.REGENERATE_DCF_ANPO_PDF, {
    ...payload,
  });
};

export const regenerateDcfAnpcPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.REGENERATE_DCF_ANPC_PDF, {
    ...payload,
  });
};

export const regenerateQuestionnairePdf = (code_pvrdc) => {
  return apis.get(
    `${API_URLS_PRESFOR.REGENERATE_QUESTIONNAIRE_PDF}/${code_pvrdc}`
  );
};

export const getDemandesPresATransmettre = (
  page = 1,
  limit = 10,
  numero_dossier,
  code_sp,
  village
) => {
  const validPage = Math.max(1, parseInt(page, 10) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit, 10) || 10));

  const params = {
    page: validPage,
    limit: validLimit,
  };

  if (numero_dossier != null && numero_dossier !== '') {
    params.numero_dossier = numero_dossier;
  }
  if (code_sp != null && code_sp !== '') {
    params.code_sp = code_sp;
  }
  if (village != null && village !== '') {
    params.code_vil = village;
  }

  return apis.get(`${API_URLS_PRESFOR.GET_DEMANDES_PRES_A_TRANSMETTRE}`, {
    params,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getLivrableTransmis = (
  type_livrable,
  page = 1,
  limit = 10,
  numero_dossier,
  code_sp,
  village
) => {
  const validPage = Math.max(1, parseInt(page, 10) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit, 10) || 10));
  const params = {
    page: validPage,
    limit: validLimit,
  };
  if (type_livrable != null && type_livrable !== '') {
    params.type_livrable = type_livrable;
  }
  if (numero_dossier != null && numero_dossier !== '') {
    params.numero_dossier = numero_dossier;
  }
  if (code_sp != null && code_sp !== '') {
    params.code_sp = code_sp;
  }

  if (village != null && village !== '') {
    params.code_vil = village;
  }
  return apis.get(`${API_URLS_PRESFOR.GET_LIVRABLE_TRANSMIS}`, {
    params,
    headers: { 'Content-Type': 'application/json' },
  });
};

export const toggleLivrableTransmisEditability = (id) => {
  return apis.patch(
    `${API_URLS_PRESFOR.TOGGLE_LIVRABLE_TRANSMIS_EDITABILITY}/${id}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getLivrableVisiblity = (numero_dossier) => {
  return apis.get(`${API_URLS_PRESFOR.GET_LIVRABLE_VISIBILITY}`, {
    params: {
      numero_dossier,
    },
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRegeneratePvclPDF = (code_pvcl) => {
  return apis.get(`${API_URLS_PRESFOR.POST_REGENERATE_PVCL_PDF}/${code_pvcl}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postRegenerateDcfPDF = (code_dcf) => {
  return apis.get(`${API_URLS_PRESFOR.POST_REGENERATE_DCF_PDF}/${code_dcf}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getAforValidationMessageByNNNNN = (nnnnn) => {
  return apis.get(`${API_URLS_PRESFOR.GET_AFOR_VALIDATION_MESSAGE_BY_NNNNN}?NNNNN=${nnnnn}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const regenerateDtvHistoPdf = (numero_enquete) => {
  return apis.get(
    `${API_URLS_PRESFOR.REGENERATE_DTV_HISTO_PDF}/${numero_enquete}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const recoveryFromDrive = (data) => {
  return apis.post(API_URLS_PRESFOR.IMPORT_DRIVE, { data });
};

export const getDriveImportStatus = (requestId) => {
  return apis.get(`${API_URLS_PRESFOR.IMPORT_DRIVE_STATUS}/${requestId}`);
};

export const downloadRecoveryReport = (path) => {
  return apis.get(`${API_URLS_PRESFOR.DOWNLOAD_RECOVERY_REPORT}?path=${encodeURIComponent(path)}`, {
    responseType: 'arraybuffer',
  });
};

export const regenerateTronconPdf = (tronconId) => {
  return apis.get(
    `${COMMON_URL_PRESFOR}dtv/regenerate-troncon-pdf/${tronconId}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

export const getHistoImportPlanDrive = (params) => {
  return apis.get(API_URLS_PRESFOR.GET_HISTO_IMPORT_PLAN_DRIVE, { params });
};

export const downloadHistoImportPlanReport = (id) => {
  return apis.get(`${API_URLS_PRESFOR.DOWNLOAD_HISTO_IMPORT_PLAN_REPORT}/${id}/download`, {
    responseType: 'arraybuffer',
  });
};

export const recoveryCf19FromDrive = (data) => {
  return apis.post(API_URLS_PRESFOR.IMPORT_CF19_DRIVE, { data });
};

export const getHistoImportCf19Drive = (params) => {
  return apis.get(API_URLS_PRESFOR.GET_HISTO_IMPORT_CF19_DRIVE, { params });
};

export const downloadHistoImportCf19Report = (id) => {
  return apis.get(`${API_URLS_PRESFOR.DOWNLOAD_HISTO_IMPORT_CF19_REPORT}/${id}/download`, {
    responseType: 'arraybuffer',
  });
};

export const transmitOrUpdateDcfPieces = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_DCF_PIECES,
    {
      // Backend attend la valeur NNNNN dans le body
      ...payload,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        ...payload?.headers,
      },
    }
  );
};

export const transmitOrUpdateAnps = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_ANPS,
    {
      ...payload,
    },
  );
};

export const transmitOrUpdateAnpos = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_ANPOS,
    {
      ...payload,
    },
  );
};

export const transmitOrUpdateAnpcs = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_ANPCS,
    {
      ...payload,
    },
  );
};

export const getCodeCertifByAnnoncePub = (codepub, payload) => {
  // Construct the URL by appending the contract ID to the base URL
  const apiUrl = `${API_URLS_PRESFOR.GET_CODE_CERTIF_BY_ANNONCE_PUB}/${codepub}`;
  // Make the GET request with the constructed URL
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const regenerateCecpdcPdf = (code_dcf) => {
  return apis.get(`${API_URLS_PRESFOR.REGENERATE_CECPDC_PDF_BY_CODEDCF}/${code_dcf}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getSousPrefecturesByCodeReg = (code_reg) => {
  return apis.get(`${API_URLS_PRESFOR.GET_SP_BY_CODE_REG}/${code_reg}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getRapportTransmissionCf = (payload = {}) => {
  return apis.post(API_URLS_PRESFOR.RAPPORT_TRANSMISSION_CF, {
    data: {
      ...payload,
    },
  });
};

export const exportStatsCfExcel = (payload = {}) => {
  return apis.post(API_URLS_PRESFOR.STATS_CF_EXCEL, {
    data: {
      ...payload,
    },
  });
};

export const getHistoryStatsCfExcel = (payload = {}) => {
  return apis.get(API_URLS_PRESFOR.STATS_CF_EXCEL_HISTORY, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const downloadHistoryStatsCfExcel = (id, payload = {}) => {
  return apis.get(`${API_URLS_PRESFOR.STATS_CF_EXCEL_HISTORY}/${id}/download`, {
    ...payload,
    responseType: 'arraybuffer',
    headers: { ...payload?.headers },
  });
};

export const exportStatsContratExcel = (payload = {}) => {
  return apis.post(API_URLS_PRESFOR.STATS_CONTRAT_EXCEL, {
    data: {
      ...payload,
    },
  });
};

export const getHistoryStatsContratExcel = (payload = {}) => {
  return apis.get(API_URLS_PRESFOR.STATS_CONTRAT_EXCEL_HISTORY, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const downloadHistoryStatsContratExcel = (id, payload = {}) => {
  return apis.get(
    `${API_URLS_PRESFOR.STATS_CONTRAT_EXCEL_HISTORY}/${id}/download`,
    {
      ...payload,
      responseType: 'arraybuffer',
      headers: { ...payload?.headers },
    }
  );
};

export const getRapportTransmissionContrat = (payload = {}) => {
  return apis.post(API_URLS_PRESFOR.RAPPORT_TRANSMISSION_CONTRAT, {
    data: {
      ...payload,
    },
  });
};
export const transmitOrUpdatePlansProvisoire = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_PLANS_PROVISOIRE,
    {
      ...payload,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        ...payload?.headers,
      },
    }
  );
};

export const transmitOrUpdatePlansProvisoireV2 = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_PLANS_PROVISOIRE_V2,
    {
      ...payload,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        ...payload?.headers,
      },
    }
  );
};

export const transmitOrUpdatePlansDefinitif = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_PLANS_DEFINITIF, { ...payload },
    { headers: { 'Content-Type': 'application/json', ...payload?.headers } }
  );
};

export const transmitOrUpdateAttestationApprobation = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_ATT_APPROBATION, { ...payload },
    { headers: { 'Content-Type': 'application/json', ...payload?.headers } }
  );
};

export const transmitOrUpdateAttestationValidation = (payload = {}) => {
  return apis.post(
    API_URLS_PRESFOR.TRANSMIT_OR_UPDATE_ATT_VALIDATION, { ...payload },
    { headers: { 'Content-Type': 'application/json', ...payload?.headers } }
  );
};

export const getContratsATransmettre = (page, limit, sousPrefecture, village, typeContrat) => {
  return apis.get(API_URLS_PRESFOR.GET_CONTRATS_A_TRANSMETTRE, {
    params: {
      page,
      limit,
      ...(sousPrefecture ? { code_sp: sousPrefecture } : {}),
      ...(village ? { code_vil: village } : {}),
      ...(typeContrat ? { type: typeContrat } : {}),
    },
  });
};

export const transmitContratAfor = (payload = {}) => {
  return apis.post(API_URLS_PRESFOR.TRANSMIT_CONTRAT_AFOR, { data: { ...payload } });
};

export const transmitContratDocumentsAfor = (payload = {}) => {
  return apis.post(API_URLS_PRESFOR.TRANSMIT_CONTRAT_DOCUMENTS_AFOR, { data: { ...payload } });
};

// Upload PDF plan provisoire
export const uploadDtvPlanProvisoirePdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPLOAD_DTV_PLAN_PROVISOIRE, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

// Upload PDF plan définitif
export const uploadDtvPlanDefinitifPdf = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPLOAD_DTV_PLAN_DEFINITIF, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

// Upload Shapefile plan provisoire (ZIP)
export const uploadDtvPlanProvisoireShapefile = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPLOAD_DTV_PLAN_PROVISOIRE_SHP, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

// Upload Shapefile plan définitif (ZIP)
export const uploadDtvPlanDefinitifShapefile = (payload) => {
  return apis.post(API_URLS_PRESFOR.UPLOAD_DTV_PLAN_DEFINITIF_SHP, {
    ...payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

// Récupérer les fichiers de plan délimitation par enquête
export const getDtvPlanDelimitation = (numero_enquete) => {
  return apis.get(`${API_URLS_PRESFOR.GET_DTV_PLAN_DELIMITATION}/${numero_enquete}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};
// Suppression fichier délimitation par ID
export const deleteDtvDelimitationFile = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_DTV_DELIMITATION_FILE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Suppression plan définitif PDF par enquête
export const deleteDtvPlanDefinitifPdf = (numero_enquete) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_DTV_PLAN_DEFINITIF_PDF}/${numero_enquete}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// Suppression shapefile définitif par enquête
export const deleteDtvPlanDefinitifShapefile = (numero_enquete) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_DTV_PLAN_DEFINITIF_SHP}/${numero_enquete}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// COT : Validation / Rejet
export const postCotValidateDtvDelimitationFile = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_VALIDATE_DTV_DELIMITATION_FILE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCotRejectDtvDelimitationFile = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REJECT_DTV_DELIMITATION_FILE}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// CQ : Validation / Rejet
export const postCqValidateDtvDelimitationFile = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_VALIDATE_DTV_DELIMITATION_FILE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postCqRejectDtvDelimitationFile = (id, payload) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REJECT_DTV_DELIMITATION_FILE}/${id}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
};

// COT : Revu
export const postCotReviewDtvDelimitationFile = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_COT_REVIEW_DTV_DELIMITATION_FILE}/${id}`, {}, {
    headers: { 'Content-Type': 'application/json' },
  });
};
// CQ : Revu
export const postCqReviewDtvDelimitationFile = (id) => {
  return apis.patch(`${API_URLS_PRESFOR.POST_CQ_REVIEW_DTV_DELIMITATION_FILE}/${id}`, {}, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getOnePppv2ShapeFile = (code_dcf) => {
  return apis.get(
    `${API_URLS_PRESFOR.GET_ONE_SINGLE_PPP_V2_SHAPE_FILE}/${code_dcf}`,
    {
      headers: { 'Content-Type': 'application/json' },
    }
  );
};

// Récupération depuis drive
export const recoveryDtvPlanDelimitationFromDrive = (driveLink) => {
  return apis.post(API_URLS_PRESFOR.RECOVERY_DTV_PLAN_DELIMITATION_FROM_DRIVE, { data: { driveLink } });
};

export const getHistoImportDelimitationDrive = (params) => {
  return apis.get(API_URLS_PRESFOR.GET_HISTO_IMPORT_DELIMITATION_DRIVE, { params });
};

export const downloadHistoImportDelimitationReport = (id) => {
  return apis.get(`${API_URLS_PRESFOR.GET_HISTO_IMPORT_DELIMITATION_DRIVE}/${id}/download`, {
    responseType: 'arraybuffer',
  });
};

export const regenerateValidPdf = (code_dcf) => {
  return apis.get(`${API_URLS_PRESFOR.REGENERATE_VALID_PDF_BY_CODEDCF}/${code_dcf}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getDtvPresATransmettre = (page = 1, limit = 10, numero_enquete, code_sp, code_vil) => {
  const validPage = Math.max(1, parseInt(page, 10) || 1);
  const validLimit = Math.min(100, Math.max(1, parseInt(limit, 10) || 10));
  const params = { page: validPage, limit: validLimit };
  if (numero_enquete != null && numero_enquete !== '') params.numero_enquete = numero_enquete; // ← corrigé
  if (code_sp != null && code_sp !== '') params.code_sp = code_sp;
  if (code_vil != null && code_vil !== '') params.code_vil = code_vil;
  return apis.get(API_URLS_PRESFOR.GET_DTV_A_TRANSMETTRE, { params });
};

export const transmitDtvHisto = (payload = {}) =>
  apis.post(API_URLS_PRESFOR.TRANSMIT_DTV_HISTO, { ...payload, headers: { 'Content-Type': 'application/json', ...payload?.headers } });

export const transmitDtvDeclarationOuverturePdf = (payload = {}) =>
  apis.post(API_URLS_PRESFOR.TRANSMIT_DTV_DECLARATION_OUVERTURE_PDF, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });

export const transmitDtvTroncon = (payload = {}) =>
  apis.post(API_URLS_PRESFOR.TRANSMIT_DTV_TRONCON, { ...payload, headers: { 'Content-Type': 'application/json', ...payload?.headers } });


export const transmitDtvAnp = (payload = {}) =>
  apis.post(API_URLS_PRESFOR.TRANSMIT_DTV_ANP, { ...payload, headers: { 'Content-Type': 'application/json', ...payload?.headers } });


export const transmitDtvAnpo = (payload = {}) =>
  apis.post(API_URLS_PRESFOR.TRANSMIT_DTV_ANPO, { ...payload, headers: { 'Content-Type': 'application/json', ...payload?.headers } });


export const transmitDtvAnpc = (payload = {}) =>
  apis.post(API_URLS_PRESFOR.TRANSMIT_DTV_ANPC, { ...payload, headers: { 'Content-Type': 'application/json', ...payload?.headers } });


export const transmitDtvApprobation = (payload = {}) =>
  apis.post(API_URLS_PRESFOR.TRANSMIT_DTV_APPROBATION, { ...payload, headers: { 'Content-Type': 'application/json', ...payload?.headers } });


export const transmitDtvValidation = (payload = {}) =>
  apis.post(API_URLS_PRESFOR.TRANSMIT_DTV_VALIDATION, { ...payload, headers: { 'Content-Type': 'application/json', ...payload?.headers } });


export const transmitDtvPlanProv = (payload = {}) =>
  apis.post(API_URLS_PRESFOR.TRANSMIT_DTV_PPP, { ...payload, headers: { 'Content-Type': 'application/json', ...payload?.headers } });


export const transmitDtvPlanDef = (payload = {}) =>
  apis.post(API_URLS_PRESFOR.TRANSMIT_DTV_PPD, { ...payload, headers: { 'Content-Type': 'application/json', ...payload?.headers } });

export const getPvrdcDocumentsAnnexe = (code_pvrdc) => {
  return apis.get(`${API_URLS_PRESFOR.GET_PVRDC_DOCUMENTS_ANNEXE}/${code_pvrdc}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postPvrdcDocumentsAnnexe = (payload) => {
  return apis.post(API_URLS_PRESFOR.POST_PVRDC_DOCUMENTS_ANNEXE, {
    data: payload?.data,
    headers: { 'Content-Type': 'multipart/form-data', ...payload?.headers },
  });
};

export const deletePvrdcDocumentsAnnexe = (id) => {
  return apis.delete(`${API_URLS_PRESFOR.DELETE_PVRDC_DOCUMENTS_ANNEXE}/${id}`, {
    headers: { 'Content-Type': 'application/json' },
  });
};

export const postValidatePvrdcDocumentsAnnexe = (code_pvrdc) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_VALIDATE_PVRDC_DOCUMENTS_ANNEXE}/${code_pvrdc}`,
    { headers: { 'Content-Type': 'application/json' } }
  );
};

export const postRejectPvrdcDocumentsAnnexe = (code_pvrdc, payload = {}) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REJECT_PVRDC_DOCUMENTS_ANNEXE}/${code_pvrdc}`,
    {
      data: payload?.data ?? payload,
      headers: { 'Content-Type': 'application/json', ...payload?.headers },
    }
  );
};

export const postReviewPvrdcDocumentsAnnexe = (code_pvrdc) => {
  return apis.patch(
    `${API_URLS_PRESFOR.POST_REVIEW_PVRDC_DOCUMENTS_ANNEXE}/${code_pvrdc}`,
    { headers: { 'Content-Type': 'application/json' } }
  );
};

export const getPVRDCAnnexe7 = async (code_pvrdc, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.GET_PVRDC_ANNEXE7}/${code_pvrdc}`;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const getContratsHistory = async (payload) => {
  const apiUrl = API_URLS_PRESFOR.GET_CONTRATS_HISTORY;
  return apis.get(apiUrl, {
    ...payload,
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
  });
};

export const downloadContratExportFile = async (id, payload) => {
  const apiUrl = `${API_URLS_PRESFOR.DOWNLOAD_CONTRAT_EXPORT}/${id}/download`;
  return apis.get(apiUrl, {
    ...payload,
    responseType: 'arraybuffer',
    headers: { ...payload?.headers },
  });
};

export const getRapportDtvLivrables = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_DTV_LIVRABLES}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_DTV_LIVRABLES;

  return apis.get(url, {
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
    signal: payload?.signal,
  });
};

export const getRapportDtvVillages = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);
  if (payload?.livrable) queryParams.append('livrable', payload.livrable);
  if (payload?.etape) queryParams.append('etape', payload.etape);
  if (payload?.search) queryParams.append('search', payload.search);
  if (payload?.page) queryParams.append('page', payload.page);
  if (payload?.limit) queryParams.append('limit', payload.limit);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_DTV_VILLAGES}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_DTV_VILLAGES;

  return apis.get(url, {
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
    signal: payload?.signal,
  });
};


export const getRapportContratStats = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);
  if (payload?.type_contrat)
    queryParams.append('type_contrat', payload.type_contrat);
  if (payload?.categorie) queryParams.append('categorie', payload.categorie);
  if (payload?.etat_contrat)
    queryParams.append('etat_contrat', payload.etat_contrat);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_CONTRAT_STATS}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_CONTRAT_STATS;

  return apis.get(url, {
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
    signal: payload?.signal,
  });
};

export const getRapportContratListe = (payload) => {
  const queryParams = new URLSearchParams();

  if (payload?.region) queryParams.append('region', payload.region);
  if (payload?.departement)
    queryParams.append('departement', payload.departement);
  if (payload?.sous_prefecture)
    queryParams.append('sous_prefecture', payload.sous_prefecture);
  if (payload?.village) queryParams.append('village', payload.village);
  if (payload?.type_contrat)
    queryParams.append('type_contrat', payload.type_contrat);
  if (payload?.categorie) queryParams.append('categorie', payload.categorie);
  if (payload?.etat_contrat)
    queryParams.append('etat_contrat', payload.etat_contrat);
  if (payload?.etape) queryParams.append('etape', payload.etape);
  if (payload?.search) queryParams.append('search', payload.search);
  if (payload?.page) queryParams.append('page', payload.page);
  if (payload?.limit) queryParams.append('limit', payload.limit);

  const queryString = queryParams.toString();
  const url = queryString
    ? `${API_URLS_PRESFOR.GET_RAPPORT_CONTRAT_LISTE}?${queryString}`
    : API_URLS_PRESFOR.GET_RAPPORT_CONTRAT_LISTE;

  return apis.get(url, {
    headers: { 'Content-Type': 'application/json', ...payload?.headers },
    signal: payload?.signal,
  });
};

export const getOnlyEnqueteAllByPost = (payload) => {
  const paginate=`skip=${payload?.skip??1}&limit=${payload?.limit??10}`
  const url = `${API_URLS_PRESFOR.GET_ONLY_ENQUETE_ALL}?${paginate}&with_dcf=${payload.with_dcf}&with_contract=${payload.with_contract}&with_isf=${payload.with_isf}`;
  return apis.post(url, 
    {
      data: payload?.filters,
      headers: { 'Content-Type': 'application/json' },
    }
    );
};
